import {FlightStepType} from "components/shared/enums/global-enums.tsx";
import { DateTime } from "luxon";


export function dateInFormat(date, timezone, format) {
  if (date === null) date = DateTime.now();
  let d = DateTime.fromISO(date, { zone: "utc" }).setZone(timezone);
  if (format !== null) d = d.toFormat(format);
  return d;
}


export function exactAirport(typeFor, flightRecord) {
  if (typeFor===FlightStepType.COLLECTION){
    return flightRecord.departure_airport;
  }else{
    if (flightRecord.layovers.length > 0) return flightRecord.layovers[0].arrival_airport; 
    else return flightRecord.arrival_airport; 
  } 
}

export function msToTime(duration) {
  var minutes = Math.floor((duration / (1000 * 60)) % 60),
    hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

  minutes = (minutes < 10) ? "0" + minutes : minutes;

  return hours + "h" + minutes;
}

export function diffInSeconds(date1, date2) {
  return Math.round((date2.getTime() - date1.getTime()) / (1000));
}

export function diffInDays(date1, date2) {
  return Math.round((date2.getTime() - date1.getTime()) / (1000 * 3600 * 24));
}


export function parseBCBPBarcode(barcode) {
  const fields = {};

  // Fixed length fields as per IATA Resolution 792
  fields.formatCode         = barcode.substring(0, 1);    // M
  fields.numberOfLegs       = barcode.substring(1, 2);    // 1
  fields.passengerName      = barcode.substring(2, 22).trim();   // AZKUR    AHMETKUR

  fields.electronicTicket   = barcode.substring(22, 23);  // E
  fields.operatingCarrierPNR = barcode.substring(23, 30).trim(); // RG6ULZ

  // Flight details (leg 1)
  fields.fromCity           = barcode.substring(30, 33).trim();  // ZRH
  fields.toCity             = barcode.substring(33, 36).trim();  // IST
  fields.operatingCarrier   = barcode.substring(36, 39).trim();  // TK
  fields.flightNumber       = barcode.substring(39, 44).trim(); // 1912
  fields.dateOfFlight       = barcode.substring(44, 47);  // Julian Date: 211
  fields.compartmentCode    = barcode.substring(47, 48);  // Y
  fields.seatNumber         = barcode.substring(48, 52);  // 024F
  fields.checkInSeqNumber   = barcode.substring(52, 57);  // 0028
  fields.passengerStatus    = barcode.substring(57, 58);  // 1

  // Optional data (free text, e.g. frequent flyer, etc.)
  fields.optionalData       = barcode.substring(58).trim();

  return fields;
}

function camelToSnake(str) {
  return str.replace(/([A-Z])/g, "_$1").toLowerCase();
}

export function convertKeysToSnakeCase(input) {
  if (Array.isArray(input)) {
    return input.map(convertKeysToSnakeCase);
  } else if (input !== null && typeof input === "object") {
    return Object.keys(input).reduce((acc, key) => {
      const newKey = camelToSnake(key);
      acc[newKey] = convertKeysToSnakeCase(input[key]);
      return acc;
    }, {});
  }
  return input;
}



export function generateTimeSlots(dateString) {
  const date = DateTime.fromISO(dateString).startOf("day");

  const start = date.set({ hour: 7, minute: 0, second: 0, millisecond: 0 });
  const end   = date.set({ hour: 14, minute: 0, second: 0, millisecond: 0 });

  const slots = [];
  let current = start;

  while (current <= end) {
    slots.push(current);
    current = current.plus({ minutes: 30 });
  }

  return slots;
}

export const airportsDic = { AAA: "Anaa",
AAB: "Tanbar",
AAC: "El Arish",
AAD: "Adado",
AAE: "Annaba",
AAF: "Apalachicola",
AAH: "Aachen",
AAI: "Arraias",
AAJ: "Awaradam",
AAK: "Buariki",
AAL: "Aalborg",
AAM: "Malamala",
AAN: "Al Ain",
AAO: "Anaco",
AAP: "Samarinda",
AAQ: "Krasnyi Kurgan",
AAR: "Aarhus",
AAS: "Apalapsili",
AAT: "Altay",
AAU: "Asau",
AAV: "Surallah",
AAX: "Arax‡",
AAY: "Al Ghaydah",
AAZ: "Quezaltenango",
ABA: "Abakan",
ABB: "Asaba",
ABC: "Albacete",
ABD: "Abadan",
ABE: "Allentown",
ABF: "Abaiang",
ABG: "Abingdon Downs",
ABH: "Alpha",
ABI: "Abilene",
ABJ: "Abidjan",
ABK: "Kebri Dahar",
ABL: "Ambler",
ABM: "Bamaga",
ABN: "Albina",
ABO: "Aboisso",
ABP: "Atkamba Mission",
ABQ: "Albuquerque",
ABR: "Aberdeen",
ABS: "Abu Simbel",
ABT: "Al-Baha",
ABU: "Atambua",
ABV: "Abuja",
ABX: "East Albury",
ABY: "Albany",
ABZ: "Aberdeen",
ACA: "Acapulco",
ACB: "Bellaire",
ACC: "Accra",
ACD: "Acand’",
ACE: "San BartolomŽ",
ACF: "Aral",
ACH: "St. Gallen",
ACI: "Saint Anne",
ACJ: "Anuradhapura",
ACK: "Nantucket",
ACM: "Arica",
ACN: "Ciudad Acu–a",
ACO: "C—bano",
ACP: "Maragheh",
ACR: "Araracuara",
ACS: "Achinsk",
ACT: "Waco",
ACU: "Mamitupu",
ACV: "Arcata/Eureka",
ACX: "Xingyi",
ACY: "Atlantic City",
ACZ: "Zabol",
ADA: "Seyhan",
ADB: "Gaziemir",
ADC: "Andekombe",
ADD: "Addis Ababa",
ADE: "Aden",
ADF: "Adõyaman",
ADG: "Adrian",
ADH: "Aldan",
ADI: "Arandis",
ADJ: "Amman",
ADK: "Adak",
ADL: "Adelaide",
ADM: "Ardmore",
ADO: "Andamooka",
ADP: "Ampara",
ADQ: "Kodiak",
ADR: "Andrews",
ADS: "Dallas",
ADT: "Ada",
ADU: "Ardabil",
ADV: "El Daein",
ADW: "Camp Springs",
ADX: "Leuchars, Fife",
ADY: "Alldays",
ADZ: "San AndrŽs",
AEA: "Abemama",
AEB: "Baise (Tianyang)",
AEE: "Adar",
AEG: "Padang Sidempuan",
AEH: "Abeche",
AEK: "Aseki",
AEL: "Albert Lea",
AEM: "Amgu",
AEO: "Aioun El Atrouss",
AEP: "Buenos Aires",
AEQ: "Chifeng",
AER: "Sochi",
AES: "lesund",
AET: "Allakaket",
AEU: "Abu Musa",
AEX: "Alexandria",
AEY: "Akureyri",
AFA: "San Rafael",
AFD: "Port Alfred",
AFF: "Colorado Springs",
AFI: "Amalfi",
AFK: "Ampara",
AFL: "Alta Floresta",
AFN: "Jaffrey",
AFO: "Afton",
AFR: "Afore",
AFS: "Zarafshan",
AFT: "Bila",
AFW: "Fort Worth",
AFY: "Afyonkarahisar",
AFZ: "Sabzevar",
AGA: "Agadir (Temsia)",
AGB: "Augsburg",
AGC: "Pittsburgh",
AGD: "Anggi-Papua Island",
AGE: "Wangerooge",
AGF: "Agen/La Garenne",
AGG: "Angoram",
AGH: "€ngelholm",
AGI: "Wageningen",
AGJ: "Aguni",
AGK: "Kagua",
AGL: "Wanigela",
AGM: "Tasiilaq",
AGN: "Angoon",
AGO: "Magnolia",
AGP: "M‡laga",
AGR: "Agra",
AGS: "Augusta",
AGT: "Ciudad del Este",
AGU: "Aguascalientes",
AGV: "Acarigua",
AGW: "Agnew",
AGX: "Agatti",
AGY: "Argyle Downs",
AGZ: "Aggeneys",
AHB: "Abha",
AHC: "Herlong",
AHD: "Ardmore",
AHE: "Ahe Atoll",
AHF: "Arapahoe",
AHG: "Vingt Cinq",
AHH: "Amery",
AHI: "Amahai",
AHJ: "Ngawa (Hongyuan)",
AHL: "Aishalton",
AHM: "Ashland",
AHN: "Athens",
AHO: "Alghero",
AHS: "Ahuas",
AHU: "Al Hoceima",
AHY: "Ambatolahy",
AHZ: "Huez, Isre",
AIA: "Alliance",
AIC: "Bigatyelang Island",
AID: "Anderson",
AIE: "Aiome",
AIF: "Assis",
AIG: "Yalinga",
AIH: "Aiambak",
AII: "Ali-Sabieh",
AIK: "Aiken",
AIL: "Isla Lorenzo Bello",
AIM: "Ailuk Island",
AIN: "Wainwright",
AIO: "Atlantic",
AIP: "Adampur",
AIR: "Aripuan‹",
AIS: "Arorae Island",
AIT: "Aitutaki",
AIU: "Atiu Island",
AIV: "Aliceville",
AIW: "Ai-Ais",
AIY: "Araua’",
AIZ: "Kaiser Lake Ozark",
AJA: "Ajaccio/NapolŽon Bonaparte",
AJF: "Al-Jawf",
AJI: "A?rõ",
AJJ: "Akjoujt",
AJK: "Araak",
AJL: "Aizawl (Lengpui)",
AJN: "Ouani",
AJR: "Arvidsjaur",
AJS: "MulegŽ",
AJU: "Aracaju",
AJY: "Agadez",
AKA: "Ankang (Hanbin)",
AKB: "Atka",
AKC: "Akron",
AKD: "Akola",
AKE: "Akieni",
AKF: "Kufra",
AKG: "Anguganak",
AKH: "Al Kharj",
AKI: "Akiak",
AKJ: "Higashikagura",
AKK: "Akhiok",
AKL: "Auckland",
AKM: "ZaKouma",
AKN: "King Salmon",
AKO: "Akron",
AKP: "Anaktuvuk Pass",
AKQ: "Menggala",
AKR: "Akure",
AKS: "Auki",
AKT: "Akrotiri",
AKU: "Aksu (Onsu)",
AKV: "Akulivik",
AKW: "Aghajari",
AKX: "Aktobe",
AKY: "Sittwe",
ALA: "Almaty",
ALB: "Albany",
ALC: "Alicante",
ALD: "Fortaleza",
ALE: "Alpine",
ALF: "Alta",
ALG: "Algiers",
ALH: "Albany",
ALI: "Alice",
ALJ: "Alexander Bay",
ALL: "Villanova d'Albenga (SV)",
ALM: "Alamogordo",
ALN: "Alton/St Louis",
ALO: "Waterloo",
ALP: "Aleppo",
ALQ: "Alegrete",
ALR: "Alexandra",
ALS: "Alamosa",
ALT: "Alenquer",
ALU: "Alula",
ALW: "Walla Walla",
ALX: "Alexander City",
ALZ: "Lazy Bay",
AMA: "Amarillo",
AMC: "Am Timan",
AMD: "Ahmedabad",
AME: "Alto Molocue",
AMH: "Arba Minch",
AMJ: "Almenara",
AMK: "Durango",
AML: "Puerto Armuelles",
AMM: "Amman",
AMN: "Alma",
AMO: "Mao",
AMP: "Ampanihy",
AMQ: "Ambon",
AMS: "Amsterdam",
AMU: "Amanab",
AMV: "Amderma",
AMW: "Ames",
AMZ: "Manurewa",
ANA: "Maasai Mara",
ANB: "Anniston",
ANC: "Anchorage",
AND: "Anderson",
ANE: "MarcŽ, Maine-et-Loire",
ANF: "Antofagasta",
ANG: "Angoulme/Brie/Champniers",
ANI: "Aniak",
ANJ: "Zanaga",
ANK: "Ankara",
ANL: "Andulo",
ANM: "Antsirabe",
ANN: "Metlakatla",
ANO: "Angoche",
ANP: "Annapolis",
ANQ: "Angola",
ANR: "Antwerp",
ANS: "Andahuaylas",
ANT: "Sankt Anton am Arlberg",
ANU: "Osbourn",
ANV: "Anvik",
ANW: "Ainsworth",
ANX: "Andenes",
ANY: "Anthony",
ANZ: "Angus Downs Station",
AOC: "Nobitz",
AOD: "Abou-De•a",
AOE: "Eski?ehir",
AOG: "Anshan",
AOH: "Lima",
AOI: "Falconara Marittima (AN)",
AOJ: "Aomori",
AOK: "Karpathos Island",
AOL: "Paso de los Libres",
AOM: "Adam",
AOO: "Altoona",
AOP: "Andoas",
AOQ: "Aappilattoq",
AOR: "Alor Satar",
AOS: "Amook Bay",
AOT: "Saint-Christophe (AO)",
AOU: "Attopeu",
APA: "Denver",
APB: "Apolo",
APC: "Napa",
APD: "Bone",
APF: "Naples",
APG: "Aberdeen",
APH: "Bowling Green",
API: "Apiay",
APJ: "Burang Town",
APK: "Apataki",
APL: "Nampula",
APN: "Alpena",
APO: "Carepa",
APQ: "Arapiraca",
APR: "April River",
APS: "An‡polis",
APT: "Jasper",
APU: "Apucarana",
APV: "Apple Valley",
APW: "Apia",
APX: "Arapongas",
APY: "Alto Parna’ba",
APZ: "Zapala",
AQA: "Araraquara",
AQB: "Santa Cruz del QuichŽ",
AQG: "Anqing",
AQI: "Qaisumah",
AQJ: "Aqaba",
AQM: "Ariquemes",
AQP: "Arequipa",
AQY: "Girdwood",
ARA: "New Iberia",
ARB: "Ann Arbor",
ARC: "Arctic Village",
ARD: "Kabola",
ARE: "Arecibo",
ARF: "Acaricuara",
ARG: "Walnut Ridge",
ARH: "Archangelsk",
ARI: "Arica",
ARK: "Arusha",
ARL: "Arly",
ARM: "Armidale",
ARN: "Stockholm",
ARO: "Arboletes",
ARQ: "Arauquita",
ARR: "Alto Rio Senguerr",
ARS: "Aragaras",
ART: "Watertown",
ARU: "Araatuba",
ARV: "Woodruff",
ARW: "Arad",
ARX: "Aracati",
ARY: "Ararat",
ARZ: "N'zeto",
ASA: "Assab",
ASB: "Ashgabat",
ASC: "Ascensi—n de Guarayos",
ASD: "Andros Town",
ASE: "Aspen",
ASF: "Astrakhan",
ASG: "Ashburton",
ASH: "Nashua",
ASI: "Cat Hill",
ASJ: "Amami",
ASK: "Yamoussoukro",
ASL: "Marshall",
ASM: "Asmara",
ASN: "Talladega",
ASO: "Asosa",
ASP: "Alice Springs",
ASQ: "Austin",
ASR: "Kayseri",
ASS: "Arathusa",
AST: "Astoria",
ASU: "Asunci—n",
ASV: "Amboseli National Park",
ASW: "Aswan",
ASX: "Ashland",
ASY: "Ashley",
ATA: "Anta",
ATB: "Atbara",
ATC: "Arthur's Town",
ATD: "Atoifi",
ATE: "Antlers",
ATF: "Ambato",
ATG: "Kamra",
ATH: "Spata-Artemida",
ATI: "Artigas",
ATJ: "Antsirabe",
ATK: "Atqasuk",
ATL: "Atlanta",
ATM: "Altamira",
ATN: "Namatanai",
ATO: "Albany",
ATP: "Aitape",
ATQ: "Amritsar",
ATR: "Atar",
ATS: "Artesia",
ATT: "Atmautluak",
ATU: "Attu",
ATV: "Ati",
ATW: "Appleton",
ATX: "Atbasar",
ATY: "Watertown",
ATZ: "Asyut",
AUA: "Oranjestad",
AUC: "Arauca",
AUE: "Ras Abu Rudeis",
AUF: "Appoigny, Yonne",
AUG: "Augusta",
AUH: "Abu Dhabi",
AUI: "Aua Island",
AUJ: "Ambunti",
AUK: "Alakanuk",
AUL: "Aur Atoll",
AUM: "Austin",
AUN: "Auburn",
AUO: "Auburn",
AUP: "Agaun",
AUQ: "Hiva Oa Island",
AUR: "Aurillac",
AUS: "Austin",
AUT: "Vila",
AUU: "Aurukun",
AUV: "Aumo",
AUW: "Wausau",
AUX: "Aragua’na",
AUY: "Anatom Island",
AUZ: "Chicago/Aurora",
AVA: "Anshun (Xixiu)",
AVB: "Aviano (PN)",
AVG: "Auvergne Station",
AVI: "Ciro Redondo",
AVK: "Arvaikheer",
AVL: "Asheville",
AVN: "Avignon, Vaucluse",
AVO: "Avon Park",
AVP: "Wilkes-Barre/Scranton",
AVR: "Vila Franca de Xira",
AVU: "Avu Avu",
AVV: "Lara",
AVW: "Marana",
AVX: "Avalon",
AWA: "Hawassa",
AWB: "Awaba",
AWD: "Aniwa",
AWE: "Wonga WonguŽ Presidential Reserve",
AWK: "Wake Island",
AWM: "West Memphis",
AWR: "Awar",
AWZ: "Ahvaz",
AXA: "The Valley",
AXB: "Alexandria Bay",
AXD: "Alexandroupolis",
AXE: "Xanxer",
AXF: "Bayanhot",
AXG: "Algona",
AXJ: "Amakusa",
AXK: "Ataq",
AXM: "Armenia",
AXN: "Alexandria",
AXO: "Kabir",
AXP: "Spring Point",
AXS: "Altus",
AXT: "Akita",
AXU: "Axum",
AXV: "Wapakoneta",
AXX: "Angel Fire",
AYA: "Ayapel",
AYC: "Ayacucho",
AYD: "Alroy Downs",
AYG: "San Vicente Del Cagu‡n",
AYI: "Yari",
AYJ: "Faizabad",
AYK: "Arkalyk",
AYM: "Abu Dhabi",
AYN: "Anyang",
AYO: "Ayolas",
AYP: "Ayacucho",
AYQ: "Yulara",
AYR: "Ayr",
AYS: "Waycross",
AYT: "Antalya",
AYU: "Aiyura Valley",
AYW: "Ayawasi",
AYX: "Atalaya",
AYY: "Pottuvil",
AZA: "Mesa",
AZD: "Yazd",
AZG: "Apatzing‡n",
AZH: "Azamgarh",
AZI: "Abu Dhabi",
AZJ: "Zhenjiang",
AZL: "Sapezal",
AZN: "Andizhan",
AZO: "Kalamazoo",
AZP: "Atizap‡n de Zaragoza",
AZR: "Adrar",
AZS: "Samana",
AZT: "Zapatoca",
AZZ: "Ambriz",
BAA: "Bialla, Matalilu, Ewase",
BAB: "Beale Air Force Base",
BAC: "Barranca De Upia",
BAD: "Bossier City",
BAE: "Saint-Pons, Alpes-de-Haute-Provence",
BAF: "Westfield",
BAG: "Baguio",
BAH: "Manama",
BAI: "Punta Arenas",
BAJ: "Unea Island",
BAL: "Batman",
BAM: "Battle Mountain",
BAN: "Basongo",
BAO: "Ban Mak Khaen",
BAQ: "Barranquilla",
BAR: "Qionghai (Basuo)",
BAS: "Ballalae",
BAT: "Barretos",
BAV: "Baotou",
BAX: "Barnaul",
BAY: "T?u?ii-M?gher?u?",
BAZ: "Barcelos",
BBA: "Balmaceda",
BBB: "Benson",
BBC: "Bay City",
BBD: "Brady",
BBG: "Butaritari",
BBH: "Barth",
BBI: "Bhubaneswar",
BBJ: "Bitburg",
BBK: "Kasane",
BBM: "Battambang",
BBN: "Bario",
BBO: "Berbera",
BBP: "Bembridge, Isle of Wight",
BBQ: "Codrington",
BBR: "Basse-Terre",
BBS: "Camberley, Surrey",
BBT: "BerbŽrati",
BBU: "Bucharest",
BBV: "Grand-BŽrŽby",
BBW: "Broken Bow",
BBX: "Philadelphia",
BBY: "Bambari",
BBZ: "Zambezi",
BCA: "Baracoa",
BCB: "Blacksburg",
BCC: "Bear Creek",
BCD: "Bacolod City",
BCE: "Bryce Canyon",
BCF: "Bouca",
BCG: "Kumaka",
BCH: "Baucau",
BCI: "Barcaldine",
BCJ: "Mianyang",
BCL: "Pococi",
BCM: "Bac?u",
BCN: "Barcelona",
BCO: "Baco",
BCP: "Bambu",
BCQ: "Brak",
BCR: "Boca do Acre",
BCS: "Belle Chasse",
BCT: "Boca Raton",
BCU: "Bauchi",
BCV: "Belmopan",
BCW: "Benguera Island",
BCX: "Beloretsk",
BCZ: "Bickerton Island",
BDA: "Hamilton",
BDB: "Bundaberg",
BDC: "Barra do Corda",
BDD: "Badu Island",
BDE: "Baudette",
BDF: "Bradford",
BDG: "Blanding",
BDH: "Bandar Lengeh",
BDI: "Bird Island",
BDJ: "Landasan Ulin",
BDK: "Bondoukou",
BDL: "Hartford",
BDM: "Bandõrma",
BDN: "Badin",
BDO: "Bandung",
BDP: "Bhadrapur",
BDQ: "Vadodara",
BDR: "Bridgeport",
BDS: "Brindisi",
BDT: "Gbadolite",
BDU: "MŒlselv",
BDV: "Moba",
BDX: "Broadus",
BDY: "Bandon",
BEB: "Balivanich",
BEC: "Wichita",
BED: "Bedford",
BEE: "Dampier Peninsula",
BEF: "Bluefileds",
BEG: "Belgrade",
BEH: "Benton Harbor",
BEI: "Beica",
BEJ: "Tanjung Redeb - Borneo Island",
BEK: "Bareilly",
BEL: "BelŽm",
BEM: "Oulad Yaich",
BEN: "Benina",
BEO: "City of Lake Macquarie",
BEP: "Bellary",
BEQ: "Bury Saint Edmunds, Suffolk",
BER: "Berlin",
BES: "Brest/Guipavas",
BET: "Bethel",
BEU: "Bedourie",
BEV: "Beersheba",
BEW: "Beira",
BEX: "Wallingford, Oxfordshire",
BEY: "Beirut",
BEZ: "Beru",
BFA: "Bah’a Negra",
BFD: "Bradford",
BFE: "Bielefeld",
BFF: "Scottsbluff",
BFG: "Bullfrog",
BFH: "Curitiba",
BFI: "Seattle",
BFJ: "Bijie",
BFK: "Aurora",
BFL: "Bakersfield",
BFM: "Mobile",
BFN: "Bloemfontain",
BFO: "Chiredzi",
BFP: "Beaver Falls",
BFQ: "Puerto Pi–a",
BFR: "Bedford",
BFS: "Belfast",
BFT: "Beaufort",
BFU: "Bengbu",
BFV: "Buriram",
BFW: "Sidi Bel Abbs",
BFX: "Bafoussam",
BGA: "Bucaramanga",
BGB: "Booue",
BGC: "Bragana",
BGD: "Borger",
BGE: "Bainbridge",
BGF: "Bangui",
BGG: "Bingšl",
BGH: "Boghe",
BGI: "Bridgetown",
BGJ: "Borgarfjšr?ur eystri",
BGK: "Big Creek",
BGL: "Baglung",
BGM: "Binghamton",
BGN: "Belaya Gora",
BGO: "Bergen",
BGQ: "Big Lake",
BGR: "Bangor",
BGS: "Boguchany",
BGT: "Bagdad",
BGU: "Bangassou",
BGV: "Bento Gonalves",
BGW: "Baghdad",
BGX: "BagŽ",
BGY: "Orio al Serio (BG)",
BGZ: "Braga",
BHA: "Bah’a de Caraquez",
BHB: "Bar Harbor",
BHC: "Bhurban",
BHD: "Belfast",
BHE: "Blenheim",
BHF: "Bah’a Solano",
BHG: "Brus Laguna",
BHH: "Bisha",
BHI: "Bah’a Blanca",
BHJ: "Bhuj",
BHK: "Bukhara",
BHL: "Ensenada",
BHM: "Birmingham",
BHN: "Beihan",
BHO: "Bhopal",
BHP: "Bhojpur",
BHQ: "Broken Hill",
BHR: "Bharatpur",
BHS: "Bathurst",
BHT: "Brighton Downs",
BHU: "Bhavnagar",
BHV: "Bahawalpur",
BHW: "Bhagatanwala",
BHX: "Birmingham, West Midlands",
BHY: "Beihai (Yinhai)",
BIA: "Bastia/Poretta",
BIB: "Baidoa",
BIC: "Bangor",
BID: "Block Island",
BIE: "Beatrice",
BIF: "Fort Bliss/El Paso",
BIG: "Delta Junction Ft Greely",
BIH: "Bishop",
BII: "Bikini Atoll",
BIK: "Biak",
BIL: "Billings",
BIM: "South Bimini",
BIN: "Bamyan",
BIO: "Bilbao",
BIQ: "Biarritz/Anglet/Bayonne",
BIR: "Biratnagar",
BIS: "Bismarck",
BIT: "Baitadi",
BIU: "Bildudalur",
BIV: "Bria",
BIX: "Biloxi",
BIY: "Bisho",
BJA: "BŽja•a",
BJB: "Bojnord",
BJC: "Denver",
BJD: "Bakkafjšr?ur",
BJE: "Baleela Base Camp",
BJF: "BŒtsfjord",
BJG: "Kota Mobagu",
BJH: "Bajhang",
BJI: "Bemidji",
BJJ: "Wooster",
BJK: "Maikoor Island",
BJL: "Yundum",
BJM: "Bujumbura",
BJO: "Bermejo",
BJP: "Bragana Paulista",
BJQ: "Bahja",
BJR: "Bahir Dar",
BJT: "Bentota",
BJU: "Bajura",
BJV: "Bodrum",
BJW: "Soa, Ngada",
BJX: "Silao",
BJY: "Zemun",
BJZ: "Badajoz",
BKA: "Baykit",
BKB: "Bikaner",
BKC: "Buckland",
BKD: "Breckenridge",
BKE: "Baker City",
BKF: "Katmai National Park",
BKG: "Branson",
BKH: "Kekaha",
BKI: "Kota Kinabalu",
BKJ: "BokŽ",
BKK: "Bangkok",
BKL: "Cleveland",
BKM: "Bakalalan",
BKN: "Balkanabat",
BKO: "Bamako",
BKQ: "Blackall",
BKR: "Bokoro",
BKS: "Bengkulu",
BKT: "Blackstone",
BKU: "Betioky",
BKV: "Bailingmiao",
BKW: "Beaver",
BKX: "Brookings",
BKY: "Kamakombe",
BKZ: "Bukoba",
BLA: "Barcelona",
BLB: "Panam‡ City",
BLC: "Bali",
BLD: "Boulder City",
BLE: "Borlange",
BLF: "Bluefield",
BLG: "Belaga",
BLH: "Blythe",
BLI: "Bellingham",
BLJ: "Batna",
BLK: "Blackpool",
BLL: "Billund",
BLM: "Belmar/Farmingdale",
BLN: "Benalla",
BLO: "Blšndu—s",
BLP: "Bellavista",
BLQ: "Bologna",
BLR: "Bangalore",
BLU: "Emigrant Gap",
BLV: "Belleville",
BLW: "Beledweyne",
BLX: "Belluno (BL)",
BLY: "Belmullet",
BLZ: "Blantyre",
BMA: "Stockholm",
BMB: "Bumba",
BMC: "Brigham City",
BMD: "Belo sur Tsiribihina",
BME: "Broome",
BMF: "Bakouma",
BMG: "Bloomington",
BMH: "Bomai",
BMI: "Bloomington/Normal",
BMJ: "Baramita",
BMK: "Borkum",
BML: "Berlin",
BMM: "Bitam",
BMN: "Bamarni",
BMO: "Banmaw",
BMQ: "Bamburi",
BMR: "Baltrum",
BMS: "Brumado",
BMT: "Beaumont",
BMU: "Palibelo, Bima",
BMV: "Buon Ma Thuot",
BMW: "Bordj Badji Mokhtar",
BMX: "Big Mountain",
BMY: "Waala",
BMZ: "Bamu",
BNA: "Nashville",
BNB: "Boende",
BNC: "Beni",
BND: "Bandar Abbas",
BNE: "Brisbane",
BNF: "Baranof",
BNG: "Banning",
BNH: "Boston",
BNI: "Benin",
BNK: "Ballina",
BNL: "Barnwell",
BNM: "Bodinumu",
BNN: "Br¿nn¿y",
BNO: "Burns",
BNP: "Bannu",
BNR: "Banfora",
BNS: "Barinas",
BNT: "Bundi",
BNU: "Blumenau",
BNV: "Boana",
BNW: "Boone",
BNX: "Mahovljani",
BNY: "Anua",
BOA: "Boma",
BOB: "Motu Mute",
BOC: "Isla Col—n",
BOD: "Bordeaux/MŽrignac",
BOE: "Boundji",
BOG: "Bogota",
BOH: "Bournemouth",
BOI: "Boise",
BOJ: "Burgas",
BOK: "Brookings",
BOM: "Mumbai",
BON: "Kralendijk",
BOO: "Bod¿",
BOP: "Bouar",
BOR: "Ton Phueng",
BOS: "Boston",
BOT: "Bosset",
BOU: "Bourges, Cher",
BOV: "Boang Island",
BOW: "Bartow",
BOY: "Bobo Dioulasso",
BOZ: "Bozoum",
BPA: "Borongan City",
BPC: "Bamenda",
BPD: "Bapi",
BPE: "Qinhuangdao (Changli)",
BPF: "Batuna Mission Station",
BPG: "Barra do Garas",
BPH: "Bislig",
BPI: "Big Piney",
BPK: "Biangabip",
BPL: "Bole",
BPM: "Hyderabad",
BPN: "Balikpapan",
BPS: "Porto Seguro",
BPT: "Beaumont/Port Arthur",
BPX: "Bangda",
BPY: "Besalampy",
BQA: "Baler",
BQB: "Busselton",
BQD: "Bœ?ardalur",
BQE: "Bubaque",
BQG: "Bogorodskoye",
BQH: "London",
BQI: "Bagani",
BQJ: "Batagay",
BQK: "Brunswick",
BQN: "Aguadilla",
BQO: "Bouna",
BQQ: "Barra",
BQS: "Blagoveschensk",
BQT: "Brest",
BQU: "Bequia",
BQV: "Gustavus",
BQW: "Balgo",
BRA: "Barreiras",
BRB: "Barreirinhas",
BRC: "San Carlos de Bariloche",
BRD: "Brainerd",
BRE: "Bremen",
BRG: "Balirangen",
BRH: "Brahman Mission",
BRI: "Bari",
BRL: "Burlington",
BRM: "Barquisimeto",
BRN: "Bern",
BRO: "Brownsville",
BRP: "Biaru",
BRQ: "Brno",
BRR: "Eoligarry",
BRS: "Bristol",
BRT: "Wurrumiyanga",
BRU: "Zaventem",
BRW: "Utqia?vik",
BRX: "Barahona",
BRY: "Bardstown",
BSA: "Bosaso",
BSB: "Bras’lia",
BSC: "Bah’a Solano",
BSD: "Baoshan (Longyang)",
BSE: "Sematan",
BSF: "Waimea (Kamuela)",
BSG: "Bata",
BSI: "Balesin",
BSJ: "Bairnsdale",
BSK: "Biskra",
BSL: "Saint-Louis",
BSM: "Amol",
BSN: "Bossangoa",
BSO: "Basco",
BSP: "Bensbach",
BSQ: "Bisbee",
BSR: "Basra",
BSS: "Balsas",
BST: "Lashkar Gah",
BSU: "Basankusu",
BSV: "Besakoa",
BSW: "Boswell Bay",
BSX: "Pathein",
BSY: "Baardheere",
BTA: "Bertoua",
BTB: "Betou",
BTC: "Batticaloa",
BTF: "Bountiful",
BTG: "Batangafo",
BTH: "Batam",
BTI: "Barter Island",
BTJ: "Banda Aceh",
BTK: "Bratsk",
BTL: "Battle Creek",
BTM: "Butte",
BTN: "Bennettsville",
BTO: "Botopasi",
BTP: "Butler",
BTQ: "Butare",
BTR: "Baton Rouge",
BTS: "Bratislava",
BTT: "Bettles",
BTU: "Bintulu",
BTV: "South Burlington",
BTW: "Batu Licin",
BTY: "Beatty",
BTZ: "Betong",
BUA: "Buka Island",
BUB: "Burwell",
BUD: "Budapest",
BUF: "Buffalo",
BUG: "Benguela",
BUI: "Bokondini",
BUJ: "Ouled Sidi Brahim",
BUK: "Al-Bough",
BUL: "Bulolo",
BUM: "Butler",
BUN: "Buenaventura",
BUO: "Burao",
BUQ: "Bulawayo",
BUR: "Burbank",
BUS: "Batumi",
BUT: "Jakar",
BUU: "Muara Bungo",
BUV: "Bella Union",
BUW: "Bau Bau",
BUX: "Bunia",
BUZ: "Bushehr",
BVA: "TillŽ",
BVB: "Boa Vista",
BVC: "Rabil",
BVE: "Brive la Gaillarde",
BVG: "BerlevŒg",
BVH: "Vilhena",
BVJ: "Bovanenkovo",
BVK: "Itenes",
BVL: "Baures",
BVM: "Belmonte",
BVO: "Bartlesville",
BVR: "Brava Island",
BVS: "Breves",
BVU: "Beluga",
BVV: "Kurilsk",
BVX: "Batesville",
BVY: "Beverly / Danvers",
BVZ: "Wunaamin Miliwundi Ranges",
BWA: "Siddharthanagar (Bhairahawa)",
BWC: "Brawley",
BWD: "Brownwood",
BWE: "Braunschweig",
BWF: "Barrow-in-Furness",
BWG: "Bowling Green",
BWH: "Butterworth",
BWI: "Baltimore",
BWK: "Gornji Humac",
BWL: "Blackwell",
BWM: "Bowman",
BWN: "Bandar Seri Begawan",
BWO: "Balakovo",
BWP: "Bewani",
BWT: "Burnie",
BWU: "Sydney",
BWW: "Cayo Santa Maria",
BWX: "Rogojampi, Banyuwangi",
BXA: "Bogalusa",
BXB: "Babo",
BXD: "Bade",
BXE: "Bakel",
BXF: "Pumululu National Park",
BXH: "Balkhash",
BXI: "Boundiali",
BXJ: "Boralday",
BXK: "Buckeye",
BXL: "Nanuya Lailai Island",
BXM: "Batom",
BXN: "Bodrum",
BXO: "Buochs",
BXR: "Bam",
BXS: "Borrego Springs",
BXT: "Bontang-Borneo Island",
BXU: "Butuan",
BXV: "Brei?dalsv’k",
BXW: "Bawean",
BXX: "Borama",
BXY: "Baikonur",
BXZ: "Bunsil - Umboi Island",
BYA: "Boundary",
BYB: "Dibba al Baya",
BYC: "Yacu’ba",
BYD: "Al-Bayda",
BYF: "MŽaulte, Somme",
BYG: "Buffalo",
BYH: "Blytheville",
BYI: "Burley",
BYJ: "Beja",
BYK: "BouakŽ",
BYL: "Beliyela",
BYM: "Bayamo",
BYN: "Bayankhongor",
BYO: "Bonito",
BYQ: "Bunju Island",
BYR: "L¾s¿",
BYS: "Fort Irwin/Barstow",
BYT: "Bantry",
BYU: "Bindlach",
BYV: "Colombo",
BYW: "Blakely Island",
BYX: "Baniyala",
BZA: "Bonanza",
BZB: "Bazaruto Island",
BZC: "Cabo Frio",
BZE: "Belize City",
BZF: "Redding",
BZG: "Bydgoszcz",
BZH: "Bumi",
BZI: "Balõkesir",
BZJ: "Bozhou",
BZK: "Bryansk",
BZL: "Barisal",
BZM: "Bemolanga",
BZN: "Bozeman",
BZO: "Bolzano (BZ)",
BZP: "Lakefield National Park",
BZR: "BŽziers/Vias",
BZT: "Brazoria",
BZU: "Buta",
BZV: "Brazzaville",
BZX: "Bazhong (Enyang)",
BZY: "B?l?i",
BZZ: "Carterton, Oxfordshire",
CAA: "El Aguacate",
CAB: "Cabinda",
CAC: "Cascavel",
CAD: "Cadillac",
CAE: "Columbia",
CAF: "Carauari",
CAG: "Cagliari",
CAH: "Ca Mau City",
CAI: "Cairo",
CAJ: "Canaima",
CAK: "Akron",
CAL: "Campbeltown",
CAM: "Camiri",
CAN: "Guangzhou (Huadu)",
CAO: "Clayton",
CAP: "Cap Haitien",
CAQ: "Caucasia",
CAR: "Caribou",
CAT: "Cascais",
CAU: "Caruaru",
CAV: "Cazombo",
CAW: "Campos dos Goytacazes",
CAX: "Carlisle, Cumbria",
CAY: "Matoury",
CBA: "West Kelowna",
CBB: "Cochabamba",
CBD: "IAF Camp",
CBE: "Wiley Ford",
CBF: "Council Bluffs",
CBG: "Cambridge, Cambridgeshire",
CBH: "BŽchar",
CBI: "Cape Barren Island",
CBJ: "Cabo Rojo",
CBK: "Colby",
CBL: "Ciudad Bolivar",
CBM: "Columbus",
CBN: "Cirebon-Java Island",
CBO: "Datu Odin Sinsuat",
CBP: "Coimbra",
CBQ: "Calabar",
CBR: "Canberra",
CBS: "Cabimas",
CBT: "Catumbela",
CBV: "Coban",
CBW: "Campo Mour‹o",
CBY: "Canobie",
CBZ: "Binzhou",
CCA: "Chimore",
CCB: "Upland",
CCC: "Cayo Coco",
CCD: "Los Angeles",
CCE: "New Cairo",
CCF: "Carcassonne/Salvaza",
CCG: "Crane",
CCH: "Chile Chico",
CCI: "Conc—rdia",
CCJ: "Calicut",
CCK: "West Island",
CCL: "Chinchilla",
CCM: "Criciœma",
CCN: "Chaghcharan",
CCO: "Puerto L—pez",
CCP: "Concepcion",
CCR: "Concord",
CCS: "Maiquet’a",
CCU: "Kolkata",
CCV: "Craig Cove",
CCX: "C‡ceres",
CCY: "Charles City",
CCZ: "Chub Cay",
CDB: "Cold Bay",
CDC: "Cedar City",
CDD: "Cauquira",
CDE: "Chengde",
CDG: "Paris (Roissy-en-France, Val-d'Oise)",
CDH: "Camden",
CDI: "Cachoeiro do Itapemirim",
CDJ: "Concei‹o do Araguaia",
CDK: "Cedar Key",
CDL: "Candle",
CDN: "Camden",
CDO: "Cradock",
CDP: "Kadapa",
CDR: "Chadron",
CDS: "Childress",
CDT: "Castell—n de la Plana",
CDU: "Cobbitty",
CDV: "Cordova",
CDW: "Caldwell",
CDY: "Mapun",
CEA: "Wichita",
CEB: "Lapu-Lapu City",
CEC: "Crescent City",
CEE: "Cherepovets",
CEF: "Chicopee",
CEG: "Broughton",
CEI: "Chiang Rai",
CEK: "Chelyabinsk",
CEL: "Canela",
CEM: "Central",
CEN: "Ciudad Obreg—n",
CEO: "Waco Kungo",
CEP: "Concepci—n",
CEQ: "Cannes, Alpes-Maritimes",
CER: "Gonneville-Le Theil, Manche",
CET: "Cholet/Le Pontreau",
CEU: "Clemson",
CEV: "Connersville",
CEW: "Crestview",
CEX: "Chena Hot Springs",
CEY: "Murray",
CEZ: "Cortez",
CFB: "Cabo Frio",
CFC: "Caador",
CFD: "Bryan",
CFE: "Aulnat, Puy-de-D™me",
CFF: "Cafunfo",
CFG: "Cienfuegos",
CFH: "Clifton Hills",
CFK: "Chlef",
CFM: "Conklin",
CFN: "Donegal",
CFO: "Confresa",
CFP: "Carpentaria Downs",
CFQ: "Creston",
CFR: "Carpiquet, Calvados",
CFS: "Coffs Harbour",
CFT: "Clifton",
CFU: "Kerkyra (Corfu)",
CFV: "Coffeyville",
CGA: "Craig",
CGB: "Cuiab‡",
CGC: "Cape Gloucester",
CGD: "Changde (Dingcheng)",
CGE: "Cambridge",
CGF: "Cleveland",
CGG: "Casiguran",
CGH: "S‹o Paulo",
CGI: "Cape Girardeau",
CGJ: "Chingola",
CGK: "Jakarta",
CGM: "Mambajao",
CGN: "Kšln (Cologne)",
CGO: "Zhengzhou",
CGP: "Chattogram (Chittagong)",
CGQ: "Changchun",
CGR: "Campo Grande",
CGS: "College Park",
CGX: "Chunga",
CGY: "Laguindingan",
CGZ: "Casa Grande",
CHA: "Chattanooga",
CHB: "Chilas",
CHC: "Christchurch",
CHD: "Mucug",
CHE: "Tallinn",
CHF: "Jinhae",
CHG: "Shuangta, Chaoyang",
CHH: "Chachapoyas",
CHJ: "Chipinge",
CHK: "Chickasha",
CHL: "Challis",
CHM: "Chimbote",
CHN: "Jeonju",
CHO: "Charlottesville",
CHP: "Circle Hot Springs",
CHQ: "Souda",
CHR: "DŽols, Indre",
CHS: "Charleston",
CHT: "Te One",
CHU: "Chuathbaluk",
CHV: "Chaves",
CHX: "Changuinola",
CHY: "Choiseul Bay",
CHZ: "Chiloquin",
CIA: "Rome",
CIC: "Chico",
CID: "Cedar Rapids",
CIE: "Collie",
CIF: "Chifeng",
CIG: "Craig",
CIH: "Changzhi",
CII: "Aydõn",
CIJ: "Cobija",
CIK: "Chalkyitsik",
CIL: "Council",
CIM: "Cimitarra",
CIN: "Carroll",
CIO: "Concepci—n",
CIP: "Chipata",
CIQ: "Chiquimula",
CIR: "Cairo",
CIS: "Abariringa",
CIT: "Shymkent",
CIU: "Kincheloe",
CIV: "Chomley",
CIW: "Canouan",
CIX: "Chiclayo",
CIY: "Comiso",
CIZ: "Coari",
CJA: "Cajamarca",
CJB: "Coimbatore",
CJC: "Calama",
CJD: "Candilejas",
CJF: "Coondewanna",
CJH: "Chilko Lake",
CJJ: "Cheongju",
CJL: "Chitral",
CJM: "Chumphon",
CJN: "Cijulang",
CJS: "Ciudad Ju‡rez",
CJT: "Comit‡n",
CJU: "Jeju City",
CJZ: "Cajazeiras",
CKA: "Cherokee",
CKB: "Bridgeport",
CKC: "Cherkasy",
CKD: "Crooked Creek",
CKE: "Lakeport",
CKG: "Chongqing",
CKH: "Chokurdah",
CKK: "Ash Flat",
CKL: "Moscow",
CKM: "Clarksdale",
CKN: "Crookston",
CKO: "CornŽlio Proc—pio",
CKR: "Crane Island",
CKS: "Parauapebas",
CKT: "Sarakhs",
CKU: "Cordova",
CKV: "Clarksville",
CKW: "Christmas Creek Mine",
CKX: "Chicken",
CKY: "Conakry",
CKZ: "‚anakkale",
CLA: "Comilla",
CLD: "Carlsbad",
CLE: "Cleveland",
CLG: "Coalinga",
CLI: "Clintonville",
CLJ: "Cluj-Napoca",
CLK: "Clinton",
CLL: "College Station",
CLM: "Port Angeles",
CLN: "Carolina",
CLO: "Cali",
CLP: "Clarks Point",
CLQ: "Colima",
CLR: "Calipatria",
CLS: "Chehalis",
CLT: "Charlotte",
CLU: "Columbus",
CLV: "Caldas Novas",
CLW: "Clearwater",
CLX: "Clorinda",
CLY: "Calvi/Sainte-Catherine",
CLZ: "Guarico",
CMB: "Colombo",
CMC: "Camocim",
CME: "Ciudad del Carmen",
CMF: "Viviers-du-Lac",
CMG: "Corumb‡",
CMH: "Columbus",
CMI: "Savoy",
CMJ: "Qimei",
CMK: "Club Makokola",
CMM: "Carmelita",
CMN: "Casablanca",
CMO: "Hobyo",
CMR: "Colmar, Haut-Rhin",
CMS: "Iskushuban",
CMT: "Camet‡",
CMU: "Kundiawa",
CMV: "Coromandel",
CMW: "Camaguey",
CMX: "Hancock",
CMY: "Sparta",
CMZ: "Caia",
CNA: "Cananea",
CND: "Mihail Kog?lniceanu",
CNE: "Penrose",
CNF: "Belo Horizonte",
CNG: "Cognac/Ch‰teaubernard",
CNH: "Claremont",
CNI: "Dalian (Changhai)",
CNJ: "Cloncurry",
CNK: "Concordia",
CNL: "Sindal",
CNM: "Carlsbad",
CNN: "Kannur",
CNO: "Chino",
CNP: "Neerlerit Inaat",
CNQ: "Corrientes",
CNR: "Cha–aral",
CNS: "Cairns",
CNT: "Charata",
CNU: "Chanute",
CNV: "Canavieiras",
CNW: "Waco",
CNX: "Chiang Mai",
CNY: "Moab",
CNZ: "Cangamba",
COA: "Columbia",
COB: "Coolibah",
COC: "Concordia",
COD: "Cody",
COE: "Coeur d'Alene",
COF: "Cocoa Beach",
COG: "Condoto",
COH: "Cooch Behar",
COI: "Merritt Island",
COK: "Kochi",
COL: "Coll Island",
COM: "Coleman",
CON: "Concord",
COO: "Cotonou",
COP: "Cooperstown",
COR: "Cordoba",
COS: "Colorado Springs",
COT: "Cotulla",
COU: "Columbia",
COV: "Tarsus",
COW: "Coquimbo",
COY: "Coolawanyah Station",
COZ: "Costanza",
CPA: "Harper",
CPB: "Acand’",
CPC: "Chapelco/San Martin de los Andes",
CPD: "Coober Pedy",
CPE: "Campeche",
CPF: "Blora",
CPG: "Carmen de Patagones",
CPH: "Copenhagen",
CPL: "Chaparral",
CPM: "Compton",
CPN: "Cape Rodney",
CPO: "Copiapo",
CPP: "Pica",
CPR: "Casper",
CPS: "Cahokia/St Louis",
CPT: "Cape Town",
CPU: "Cururupu",
CPV: "Campina Grande",
CPX: "Culebra",
CQA: "Canarana",
CQD: "Shahrekord",
CQF: "Marck",
CQM: "Ciudad Real",
CQS: "Costa Marques",
CQT: "Caquetania",
CQW: "Wulong",
CRA: "Craiova",
CRC: "Cartago",
CRD: "Comodoro Rivadavia",
CRE: "North Myrtle Beach",
CRF: "Carnot",
CRG: "Jacksonville",
CRH: "Cherrabah Homestead Resort",
CRI: "Colonel Hill",
CRJ: "Coorabie",
CRK: "Mabalacat",
CRL: "Charleroi",
CRM: "Catarman",
CRO: "Corcoran",
CRP: "Corpus Christi",
CRQ: "Caravelas",
CRR: "Ceres",
CRS: "Corsicana",
CRT: "Crossett",
CRU: "Carriacou Island",
CRV: "Isola di Capo Rizzuto (KR)",
CRW: "Charleston",
CRX: "Corinth",
CRY: "Carlton Hill",
CRZ: "TŸrkmenabat",
CSA: "Colonsay",
CSB: "Caransebe?",
CSC: "Ca–as",
CSD: "Cresswell Downs",
CSE: "Crested Butte",
CSF: "Creil",
CSG: "Columbus",
CSH: "Solovetsky Islands",
CSK: "Cap Skirring",
CSM: "Clinton",
CSN: "Carson City",
CSO: "Hecklingen",
CSQ: "Creston",
CSR: "Casuarito",
CSS: "Cassil‰ndia",
CST: "Castaway Island",
CSU: "Santa Cruz Do Sul",
CSV: "Crossville",
CSX: "Changsha (Changsha)",
CSY: "Cheboksary",
CSZ: "Coronel Suarez",
CTA: "Catania",
CTB: "Cut Bank",
CTC: "Catamarca",
CTD: "ChitrŽ",
CTE: "Cart’ Islands",
CTF: "Coatepeque",
CTG: "Cartagena",
CTH: "Coatesville",
CTI: "Cuito Cuanavale",
CTK: "Canton",
CTL: "Charleville",
CTM: "Chetumal",
CTO: "Calverton",
CTP: "Carutapera",
CTQ: "Santa Vit—ria do Palmar",
CTS: "Sapporo",
CTT: "Le Castellet, Var",
CTU: "Chengdu (Shuangliu)",
CTV: "Saurimo",
CTW: "Cottonwood",
CTX: "Cortland",
CTY: "Cross City",
CTZ: "Clinton",
CUA: "Comondœ",
CUB: "Columbia",
CUC: "Cœcuta",
CUD: "Caloundra",
CUE: "Cuenca",
CUF: "Levaldigi (CN)",
CUH: "Cushing",
CUI: "Currillo",
CUJ: "Culion",
CUK: "Caye Caulker",
CUL: "Culiac‡n",
CUN: "Cancœn",
CUO: "Carurœ",
CUP: "Carœpano",
CUQ: "Coen",
CUR: "Willemstad",
CUS: "Columbus",
CUT: "Cutral-Co",
CUU: "Chihuahua",
CUV: "Casigua El Cubo",
CUX: "Corpus Christi",
CUZ: "Cusco",
CVB: "Chungribu",
CVE: "Cove–as",
CVF: "Saint-Bon",
CVG: "Cincinnati / Covington",
CVH: "Lafontaine",
CVI: "Caleta Olivia",
CVJ: "Temixco",
CVM: "Ciudad Victoria",
CVN: "Clovis",
CVO: "Corvallis",
CVQ: "Carnarvon",
CVS: "Clovis",
CVT: "Coventry, West Midlands",
CVU: "Corvo",
CWA: "Mosinee",
CWB: "Curitiba",
CWC: "Chernivtsi",
CWF: "Lake Charles",
CWI: "Clinton",
CWJ: "Lincang (Cangyuan)",
CWK: "Chitrakoot",
CWL: "Cardiff",
CWP: "Campbellpore",
CWS: "Center Island",
CWX: "Willcox",
CXB: "Cox's Bazar",
CXC: "Chitina",
CXF: "Coldfoot",
CXH: "Vancouver",
CXI: "Kiritimati",
CXJ: "Caxias Do Sul",
CXL: "Calexico",
CXM: "Camaxilo",
CXN: "Candala",
CXO: "Houston",
CXP: "Cilacap",
CXQ: "Wangkat Jungka",
CXR: "Cam Ranh",
CXY: "North Cat Cay",
CYA: "Les Cayes",
CYB: "West End",
CYC: "Caye Chapel",
CYD: "Maya Flats",
CYF: "Chefornak",
CYI: "Shuishang",
CYL: "Coyoles",
CYM: "Chatham",
CYO: "Cayo Largo del Sur",
CYP: "Calbayog City",
CYR: "Colonia del Sacramento",
CYS: "Cheyenne",
CYT: "Yakataga",
CYU: "Cuyo",
CYW: "Celaya",
CYX: "Cherskiy",
CYZ: "Cauayan City",
CZA: "Tinœm",
CZB: "Cruz Alta",
CZC: "Copper Center",
CZE: "Coro",
CZF: "Cape Romanzof",
CZH: "Corozal",
CZJ: "Tupile",
CZK: "Cascade Locks",
CZL: "Constantine",
CZM: "Cozumel",
CZN: "Chisana",
CZO: "Chistochina",
CZP: "Cape Pole",
CZR: "Chara",
CZS: "Cruzeiro Do Sul",
CZT: "Carrizo Springs",
CZU: "Corozal",
CZW: "Rudniki",
CZX: "Changzhou",
DAA: "Fort Belvoir",
DAB: "Daytona Beach",
DAC: "Dhaka",
DAD: "Da Nang",
DAG: "Daggett",
DAH: "Dathina",
DAK: "Dakhla Oases",
DAL: "Dallas",
DAM: "Damascus",
DAN: "Danville",
DAP: "Darchula",
DAR: "Dar es Salaam",
DAS: "Great Bear Lake",
DAT: "Datong",
DAU: "Daru",
DAV: "David",
DAX: "Dazhou (Daxian)",
DAY: "Dayton",
DAZ: "Darwaz",
DBA: "Dalbandin",
DBB: "El Alamein",
DBC: "Baicheng",
DBK: "Kalpitiya Island",
DBM: "Debre Markos",
DBN: "Dublin",
DBO: "Dubbo",
DBP: "Debepare",
DBQ: "Dubuque",
DBR: "Darbhanga",
DBS: "Dubois",
DBT: "Debre Tabor",
DBU: "Dambulla",
DBV: "?ilipi",
DCA: "Washington",
DCF: "Canefield",
DCG: "Dubai",
DCI: "Decimomannu",
DCK: "Dahl Creek",
DCM: "Castres/Mazamet",
DCN: "Derby",
DCT: "Duncan Town",
DCU: "Decatur",
DCY: "Garz (Daocheng)",
DDC: "Dodge City",
DDD: "Kudahuvadhoo",
DDG: "Dandong (Zhenxing)",
DDI: "Whitsundays",
DDR: "Xigaz (Dingri)",
DDU: "Dadu",
DEA: "Dera Ghazi Khan",
DEB: "Debrecen",
DEC: "Decatur",
DED: "Dehradun (Jauligrant)",
DEE: "Yuzhno-Kurilsk",
DEF: "Dezful",
DEH: "Decorah",
DEI: "Denis Island",
DEL: "New Delhi",
DEM: "Dembidollo",
DEN: "Denver",
DEP: "Daporijo",
DEQ: "Huzhou",
DER: "Derim",
DES: "Desroches Island",
DET: "Detroit",
DEX: "Dekai",
DEZ: "Deir ez-Zor",
DFA: "Shangluo (Danfeng)",
DFI: "Defiance",
DFP: "Palmer",
DFW: "Dallas-Fort Worth",
DGA: "Dangriga",
DGE: "Mudgee",
DGF: "Douglas Lake",
DGH: "Deoghar",
DGL: "Douglas",
DGM: "Colombo",
DGN: "Dahlgren",
DGO: "Durango",
DGR: "Dargaville",
DGT: "Dumaguete City",
DGU: "Dedougou",
DGW: "Douglas",
DHA: "Dhahran",
DHB: "Deer Harbor",
DHG: "Dalnegorsk",
DHI: "Dhangarhi",
DHL: "Ad-Dali",
DHM: "Kangra",
DHN: "Dothan",
DHR: "Den Helder",
DHT: "Dalhart",
DHX: "Kediri",
DIA: "Doha",
DIB: "Dibrugarh",
DIE: "Antisiranana",
DIG: "Diqing (Shangri-La)",
DIJ: "Ouges, C™te-d'Or",
DIK: "Dickinson",
DIL: "Dili",
DIM: "Dimbokro",
DIN: "Dien Bien Phu",
DIO: "Diomede",
DIP: "Diapaga",
DIQ: "Divin—polis",
DIR: "Dire Dawa",
DIS: "Dolisie",
DIU: "Diu",
DIW: "Dickwella",
DIY: "Diyarbakõr",
DJA: "Djougou",
DJB: "Jambi",
DJE: "Mellita",
DJG: "Djanet",
DJJ: "Sentani",
DJM: "Djambala",
DJN: "Delta Junction",
DJU: "Djœpivogur",
DKA: "Katsina",
DKI: "Dunk Island",
DKK: "Dunkirk",
DKR: "Dakar",
DKS: "Dikson",
DKV: "Kaltukatjara",
DLA: "Douala",
DLC: "Dalian (Ganjingzi)",
DLE: "Tavaux, Jura",
DLF: "Del Rio",
DLG: "Dillingham",
DLH: "Duluth",
DLI: "Da Lat",
DLK: "Dulkaninna",
DLL: "Dillon",
DLM: "Dalaman",
DLN: "Dillon",
DLR: "Dalnerechensk",
DLS: "Dallesport / The Dalles",
DLU: "Dali (Xiaguan)",
DLY: "Dillon's Bay",
DLZ: "Dalanzadgad",
DMA: "Tucson",
DMB: "Taraz",
DME: "Moscow",
DMK: "Bangkok",
DMM: "Ad Dammam",
DMN: "Deming",
DMO: "Sedalia",
DMT: "Diamantino",
DMU: "Dimapur",
DNA: "Okinawa",
DNB: "Maramie",
DND: "Dundee",
DNF: "Martuba",
DNG: "Drysdale River",
DNH: "Dunhuang",
DNK: "Dnipro",
DNL: "Augusta",
DNN: "Dalton",
DNO: "Dian—polis",
DNP: "Dang",
DNQ: "Deniliquin",
DNR: "Pleurtuit, Ille-et-Vilaine",
DNS: "Denison",
DNU: "Dinangat",
DNV: "Danville",
DNX: "Dinder",
DNZ: "Denizli",
DOA: "Doany",
DOB: "Dobo-Warmar Island",
DOC: "Dornoch, Sunderland",
DOD: "Dodoma",
DOE: "Djumu-Djomoe",
DOG: "Dongola",
DOH: "Doha",
DOI: "Castori Islets",
DOL: "Deauville, Calvados",
DOM: "Marigot",
DON: "Dos Lagunas",
DOO: "Dorobisoro",
DOP: "Dolpa",
DOR: "Dori",
DOU: "Dourados",
DOV: "Dover",
DOX: "Port Denison",
DOY: "Dongying (Kenli)",
DPA: "Chicago/West Chicago",
DPB: "Bahia Inutil",
DPE: "Saint-Aubin-sur-Scie",
DPG: "Dugway Proving Ground",
DPL: "Dipolog",
DPO: "Devonport",
DPS: "Kuta, Badung",
DPT: "Deputatskiy",
DQA: "Daqing",
DQM: "Duqm",
DRA: "Mercury",
DRB: "Derby",
DRC: "Dirico",
DRD: "Dorunda Outstation",
DRE: "Drummond Island",
DRF: "Kenai",
DRG: "Deering",
DRH: "Dabra",
DRI: "DeRidder",
DRJ: "Drietabbetje",
DRK: "Puntarenas",
DRO: "Durango",
DRP: "Legazpi",
DRS: "Dresden",
DRT: "Del Rio",
DRU: "Drummond",
DRV: "Baa Atoll",
DRW: "Darwin",
DRY: "Drysdale River",
DSC: "Dschang",
DSD: "Grande Anse",
DSE: "Dessie",
DSG: "Dilasag",
DSI: "Destin",
DSK: "Dera Ismael Khan",
DSM: "Des Moines",
DSN: "Ordos",
DSO: "S?nd?ng-ni",
DSS: "Dakar",
DSV: "Dansville",
DSX: "Kaohsiung (Cijin - Pratas Island)",
DSY: "Ta Noun",
DTA: "Delta",
DTB: "Siborong-Borong",
DTD: "Datadawai-Borneo Island",
DTE: "Daet",
DTH: "Death Valley",
DTI: "Diamantina",
DTL: "Detroit Lakes",
DTM: "Dortmund",
DTN: "Shreveport",
DTR: "Decatur",
DTU: "Heihe",
DTW: "Detroit",
DUA: "Durant",
DUB: "Dublin",
DUC: "Duncan",
DUD: "Dunedin",
DUE: "Chitato",
DUF: "Corolla",
DUG: "Douglas Bisbee",
DUJ: "Dubois",
DUK: "Mubatuba",
DUM: "Dumai",
DUQ: "Duncan",
DUR: "Durban",
DUS: "DŸsseldorf",
DUT: "Unalaska",
DVD: "Andavadoaka",
DVK: "Diavik",
DVL: "Devils Lake",
DVN: "Davenport",
DVO: "Davao",
DVR: "Nauiyu",
DVT: "Phoenix",
DWA: "Dwangwa",
DWB: "Soalala",
DWC: "Jebel Ali",
DWD: "Dawadmi",
DWH: "Houston",
DWO: "Sri Jayawardenepura Kotte",
DWR: "Reg",
DWS: "Hulunbuir",
DXB: "Dubai",
DXD: "New Dixie",
DXE: "Madison",
DXJ: "Xiangxi",
DXR: "Danbury",
DYG: "Zhangjiajie (Yongding)",
DYL: "Doylestown",
DYM: "Diamantina Lakes",
DYR: "Anadyr",
DYS: "Abilene",
DYU: "Dushanbe",
DYW: "Daly Waters",
DZA: "Dzaoudzi",
DZH: "Dazhou (Dachuan)",
DZI: "Codazzi",
DZN: "Zhezkazgan",
DZO: "Durazno",
DZU: "Dazu",
EAA: "Eagle",
EAB: "Abs",
EAE: "Emae Island",
EAL: "Mejato Island",
EAM: "Najran",
EAN: "Wheatland",
EAR: "Kearney",
EAS: "Hondarribia",
EAT: "Wenatchee",
EAU: "Eau Claire",
EBA: "Campo nell'Elba (LI)",
EBB: "Kampala",
EBD: "El-Obeid",
EBG: "El Bagre",
EBH: "El Bayadh",
EBJ: "Esbjerg",
EBL: "Arbil",
EBM: "El Borma",
EBN: "Ebadon Island",
EBO: "Ebon Atoll",
EBS: "Webster City",
EBU: "AndrŽzieux-BouthŽon, Loire",
EBW: "Ebolowa",
ECA: "East Tawas",
ECG: "Elizabeth City",
ECI: "Tola",
ECN: "Tymbou (Kirklar)",
ECO: "El Encanto",
ECP: "Panama City Beach",
ECR: "El Charco",
ECS: "Newcastle",
EDA: "Edna Bay",
EDB: "Al Dabbah",
EDD: "Ghan",
EDE: "Edenton",
EDF: "Anchorage",
EDI: "Edinburgh",
EDK: "El Dorado",
EDL: "Eldoret",
EDM: "La Roche-sur-Yon/Les Ajoncs",
EDN: "Yedinka",
EDO: "Edremit",
EDQ: "Erandique",
EDR: "Pormpuraaw",
EDW: "Edwards",
EEA: "Correia Pinto",
EED: "Needles",
EEK: "Eek",
EEN: "Keene",
EES: "Berenice Troglodytica",
EFD: "Houston",
EFG: "Efogi",
EFK: "Newport",
EFL: "Kefallinia Island",
EFW: "Jefferson",
EGA: "Engati",
EGC: "Bergerac/Roumanire",
EGE: "Eagle",
EGH: "El Jora",
EGI: "Crestview",
EGL: "Negele Borana",
EGM: "Sege",
EGN: "Geneina",
EGO: "Belgorod",
EGP: "Eagle Pass",
EGS: "Egilssta?ir",
EGV: "Eagle River",
EGX: "Egegik",
EHL: "El Bols—n",
EHM: "Cape Newenham",
EHU: "Ezhou",
EIB: "Hšrselberg-Hainich",
EIE: "Yeniseysk",
EIH: "Einasleigh",
EIK: "Yeysk",
EIL: "Fairbanks",
EIN: "Eindhoven",
EIS: "Beef Island",
EIY: "Sapir",
EJA: "Barrancabermeja",
EJH: "Al Wajh",
EJN: "Ejin Banner",
EJT: "Enejit Island",
EKA: "Eureka",
EKB: "Ekibastuz",
EKI: "Elkhart",
EKN: "Elkins",
EKO: "Elko",
EKS: "Shakhtyorsk",
EKT: "Eskilstuna",
EKX: "Elizabethtown",
ELA: "Eagle Lake",
ELB: "El Banco",
ELC: "Elcho Island",
ELD: "El Dorado",
ELE: "El Real de Santa Mar’a",
ELF: "El Fasher",
ELG: "El Menia",
ELH: "North Eleuthera",
ELI: "Elim",
ELJ: "Ruperto Polania",
ELK: "Elk City",
ELL: "Ellisras",
ELM: "Elmira/Corning",
ELN: "Ellensburg",
ELO: "El Dorado",
ELP: "El Paso",
ELQ: "Buraidah",
ELR: "Elelim",
ELS: "East London",
ELT: "At Tur",
ELU: "Guemar",
ELV: "Elfin Cove",
ELW: "Ellamar",
ELX: "El Tigre",
ELY: "Ely",
ELZ: "Wellsville",
EMA: "Nottingham",
EMD: "Emerald",
EME: "Emden",
EMG: "Empangeni",
EMI: "Emirau Island",
EMK: "Emmonak",
EML: "Emmen",
EMM: "Kemmerer",
EMN: "NŽma",
EMO: "Emo Mission",
EMP: "Emporia",
EMR: "El Mirador",
EMS: "Embessa",
EMT: "El Monte",
EMX: "El MaitŽn",
EMY: "El Minya",
ENA: "Kenai",
ENB: "Eneabba",
ENC: "Tomblaine, Meurthe-et-Moselle",
END: "Enid",
ENE: "Ende",
ENF: "Enontekio",
ENG: "Enggano",
ENH: "Enshi (Enshi)",
ENI: "El Nido",
ENJ: "El Naranjo",
ENK: "Enniskillen",
ENL: "Centralia",
ENN: "Nenana",
ENO: "Encarnaci—n",
ENS: "Enschede",
ENT: "Eniwetok Atoll",
ENU: "Enegu",
ENV: "Wendover",
ENW: "Kenosha",
ENY: "Yan'an (Baota)",
EOH: "Medell’n",
EOI: "Eday",
EOK: "Keokuk",
EOR: "Bolivar",
EOS: "Neosho",
EPA: "El Palomar",
EPG: "Weeping Water",
EPH: "Ephrata",
EPL: "Juvaincourt, Vosges",
EPR: "Esperance",
EPT: "Eliptamin",
EPU: "PŠrnu",
EQS: "Esquel",
ERA: "Erigavo",
ERC: "Erzincan",
ERD: "Berdyansk",
ERE: "Erave",
ERF: "Erfurt",
ERG: "Erbogachen",
ERH: "Errachidia",
ERI: "Erie",
ERL: "Erenhot",
ERM: "Erechim",
ERN: "EirunepŽ",
ERQ: "Elrose Mine",
ERR: "Errol",
ERS: "Windhoek",
ERT: "Erdenet",
ERU: "Erume",
ERV: "Kerrville",
ERZ: "Erzurum",
ESA: "Esa'ala",
ESB: "Ankara",
ESC: "Escanaba",
ESD: "Eastsound",
ESE: "Ensenada",
ESF: "Alexandria",
ESG: "Mariscal Estigarribia",
ESH: "Brighton, East Sussex",
ESK: "Eski?ehir",
ESL: "Elista",
ESM: "Tachina",
ESN: "Easton",
ESO: "Espanola",
ESR: "El Salvador",
ESS: "Essen",
EST: "Estherville",
ESU: "Essaouira",
ESW: "Easton",
ETB: "West Bend",
ETD: "Etadunna",
ETE: "Metema",
ETL: "Svetlaya",
ETM: "Eilat",
ETN: "Eastland",
ETR: "Santa Rosa",
ETS: "Enterprise",
ETZ: "Goin",
EUA: "Eua Island",
EUE: "Eureka",
EUF: "Eufaula",
EUG: "Eugene",
EUM: "NeumŸnster",
EUN: "El Aaiœn",
EUO: "Paratebueno",
EUQ: "San Jose",
EUX: "Oranjestad",
EVD: "Eva Downs",
EVE: "Evenes",
EVG: "Sveg",
EVM: "Eveleth",
EVN: "Yerevan",
EVV: "Evansville",
EVW: "Evanston",
EVX: "Fauville, Eure",
EWB: "New Bedford",
EWE: "Agats",
EWI: "Enarotali",
EWK: "Newton",
EWN: "New Bern",
EWO: "Ewo",
EWR: "Newark",
EXI: "Excursion Inlet",
EXM: "Exmouth",
EXT: "Exeter, Devon",
EYA: "Zeya",
EYL: "YŽlimanŽ",
EYP: "Yopal",
EYR: "Yerington",
EYS: "Eliye Springs",
EYW: "Key West",
EZE: "Buenos Aires (Ezeiza)",
EZS: "Elazõ?",
FAA: "Faranah",
FAB: "Farnborough, Hampshire",
FAC: "Faaite",
FAE: "V‡gar",
FAF: "Newport News (Fort Eustis)",
FAG: "Fagurh—lsm?ri",
FAH: "Farah",
FAI: "Fairbanks",
FAK: "False Island",
FAM: "Farmington",
FAO: "Faro",
FAQ: "Frieda River",
FAR: "Fargo",
FAS: "F‡skrœ?sfjšr?ur",
FAT: "Fresno",
FAU: "Fahud",
FAY: "Fayetteville",
FAZ: "Fasa",
FBA: "Fonte Boa",
FBD: "Fayzabad",
FBE: "Francisco Beltr‹o",
FBG: "Fort Bragg",
FBK: "Fairbanks",
FBL: "Faribault",
FBM: "Lubumbashi",
FBR: "Fort Bridger",
FBS: "Friday Harbor",
FBY: "Fairbury",
FCA: "Kalispell",
FCB: "Ficksburg",
FCH: "Fresno",
FCM: "Minneapolis",
FCN: "Wurster NordseekŸste",
FCO: "Rome",
FCS: "Fort Carson",
FCY: "Forrest City",
FDA: "Fundaci—n",
FDE: "F¿rde",
FDF: "Fort-de-France",
FDH: "Friedrichshafen",
FDK: "Frederick",
FDR: "Frederick",
FDU: "Bandundu",
FDY: "Findlay",
FEA: "Fetlar Island",
FEB: "Sanfebagar",
FEC: "Feira de Santana",
FEG: "Fergana",
FEJ: "Feij—",
FEN: "Fernando de Noronha",
FEP: "Freeport",
FET: "Fremont",
FEZ: "Sa•ss",
FFA: "Kill Devil Hills",
FFD: "Fairford, Gloucestershire",
FFL: "Fairfield",
FFM: "Fergus Falls",
FFO: "Dayton",
FFT: "Frankfort",
FFU: "Futaleufu",
FGD: "Fderik",
FGI: "Apia",
FGL: "Fox Glacier",
FGU: "Fangatau",
FHU: "Fort Huachuca / Sierra Vista",
FHZ: "Fakahina",
FID: "Fishers Island",
FIE: "Fair Isle",
FIG: "Fria",
FIH: "Kinshasa",
FIK: "Finke",
FIL: "Fillmore",
FIN: "Buki",
FJR: "Fujairah",
FKB: "RheinmŸnster",
FKI: "Kisangani",
FKJ: "Fukui",
FKL: "Franklin",
FKN: "Franklin",
FKQ: "Fakfak",
FKS: "Sukagawa",
FLA: "Florencia",
FLB: "Floriano",
FLD: "Fond du Lac",
FLF: "Flensburg",
FLG: "Flagstaff",
FLH: "Flotta Isle",
FLI: "Flateyri",
FLL: "Fort Lauderdale",
FLM: "Filadelfia",
FLN: "Florian—polis",
FLO: "Florence",
FLP: "Flippin",
FLR: "Firenze (FI)",
FLS: "Whitemark",
FLT: "Flat",
FLV: "Fort Leavenworth",
FLW: "Santa Cruz das Flores",
FLX: "Fallon",
FLZ: "Sibolga (Pinangsori)",
FMA: "Formosa",
FME: "Fort Meade(Odenton)",
FMG: "Brasilito",
FMH: "Falmouth",
FMI: "Kalemie",
FMM: "Memmingen",
FMN: "Farmington",
FMO: "Greven",
FMS: "Fort Madison",
FMT: "Faresmaathodaa",
FMU: "Florence",
FMY: "Fort Myers",
FNA: "Freetown (Lungi-Town)",
FNB: "Trollenhagen",
FNC: "Funchal",
FND: "Funadhoo",
FNE: "Fane Mission",
FNG: "Fada N'gourma",
FNH: "Fincha",
FNI: "N”mes/Garons",
FNJ: "Pyongyang",
FNL: "Loveland",
FNR: "Funter Bay",
FNT: "Flint",
FNU: "Oristano",
FOA: "Foula",
FOB: "Fort Bragg",
FOC: "Fuzhou (Changle)",
FOD: "Fort Dodge",
FOE: "Topeka",
FOG: "Foggia (FG)",
FOK: "Westhampton Beach",
FOM: "Foumban",
FON: "La Fortuna",
FOO: "Kornasoren",
FOR: "Fortaleza",
FOU: "Fougamou",
FOY: "Foya",
FPO: "Freeport",
FPR: "Fort Pierce",
FPY: "Perry",
FRA: "Frankfurt am Main",
FRB: "Forbes",
FRC: "Franca",
FRD: "Friday Harbor",
FRE: "Fera Island",
FRG: "Farmingdale",
FRH: "French Lick",
FRI: "Fort Riley (Junction City)",
FRK: "FrŽgate Island",
FRL: "Forl“ (FC)",
FRM: "Fairmont",
FRN: "Fort Richardson",
FRO: "Flor¿",
FRQ: "Feramin",
FRR: "Front Royal",
FRS: "San Benito",
FRT: "Frutillar",
FRU: "Bishkek",
FRW: "Francistown",
FRY: "Fryeburg",
FRZ: "Fritzlar",
FSC: "Figari Sud-Corse",
FSD: "Sioux Falls",
FSI: "Fort Sill",
FSK: "Fort Scott",
FSL: "Fossil Downs Station",
FSM: "Fort Smith",
FSP: "Saint-Pierre",
FST: "Fort Stockton",
FSU: "Fort Sumner",
FSZ: "Makinohara / Shimada",
FTA: "Futuna Island",
FTE: "El Calafate",
FTI: "Fitiuta Village",
FTK: "Fort Knox",
FTU: "T™lanaro",
FTW: "Fort Worth",
FTX: "Owando",
FTY: "Atlanta",
FUB: "Fulleborn",
FUE: "El Matorral",
FUG: "Yingzhou, Fuyang",
FUJ: "Goto",
FUK: "Fukuoka",
FUL: "Fullerton",
FUM: "Fuma",
FUN: "Funafuti",
FUO: "Foshan (Nanhai)",
FUT: "Futuna Island",
FVM: "Fuvahmulah Island",
FVR: "Oombulgurri",
FWA: "Fort Wayne",
FWH: "Fort Worth",
FWL: "Farewell",
FXE: "Fort Lauderdale",
FXO: "Cuamba",
FXY: "Forest City",
FYJ: "Fuyuan",
FYM: "Fayetteville",
FYN: "Fuyun",
FYT: "Faya-Largeau",
FYU: "Fort Yukon",
FYV: "Fayetteville",
FZL: "Fuzuli",
GAA: "Guamal",
GAB: "Gabbs",
GAC: "Gracias",
GAD: "Gadsden",
GAE: "Gabs",
GAF: "Gafsa",
GAG: "Gage",
GAH: "Gayndah",
GAI: "Gaithersburg",
GAJ: "Higashine",
GAL: "Galena",
GAM: "Gambell",
GAN: "Gan",
GAO: "Guant‡namo",
GAP: "Gusap",
GAR: "Garaina",
GAS: "Garissa",
GAT: "Tallard, Hautes-Alpes",
GAU: "Guwahati",
GAV: "Gag Island",
GAW: "Gangaw",
GAX: "Gamba",
GAY: "Gaya",
GAZ: "Woodlark (Muyua) Island",
GBA: "Cirencester, Gloucestershire",
GBB: "Gabala",
GBC: "Gasuke",
GBD: "Great Bend",
GBE: "Gaborone",
GBF: "Negarbo",
GBG: "Galesburg",
GBH: "Galbraith Lake",
GBI: "Kalaburagi",
GBJ: "Grand-Bourg",
GBK: "Gbangbatok",
GBM: "Garbaharey",
GBP: "Gamboola",
GBR: "Great Barrington",
GBT: "Gorgan",
GBU: "Khashm El Girba",
GBV: "Gibb",
GBW: "Ginbata",
GBZ: "Claris",
GCA: "Guacamayas",
GCC: "Gillette",
GCD: "Electric City",
GCH: "Gachsaran",
GCI: "Saint Peter Port",
GCJ: "Midrand",
GCK: "Garden City",
GCM: "George Town",
GCN: "Grand Canyon - Tusayan",
GCT: "Littlefield",
GCV: "Gravatai",
GCW: "Peach Springs",
GCY: "Greeneville",
GDB: "Gondia",
GDC: "Greenville",
GDD: "Gordon Downs",
GDE: "Gode",
GDH: "Golden Horn Lodge",
GDI: "Melle",
GDL: "Guadalajara",
GDM: "Gardner",
GDN: "Gda?sk",
GDO: "Guasdualito",
GDP: "Guadalupe",
GDQ: "Azezo",
GDR: "Angra dos Reis",
GDT: "Cockburn Town",
GDV: "Glendive",
GDW: "Gladwin",
GDX: "Magadan",
GDZ: "Gelendzhik",
GEA: "NoumŽa",
GEB: "Gebe Island",
GEC: "Lefkoniko (Geitkale)",
GED: "Georgetown",
GEE: "George Town",
GEF: "Liangia",
GEG: "Spokane",
GEL: "Santo ångelo",
GEM: "MengomeyŽn",
GEO: "Georgetown",
GER: "Nueva Gerona",
GES: "General Santos",
GET: "Moonyoonooka",
GEV: "GŠllivare",
GEW: "Gewoia",
GEY: "Greybull",
GFA: "Great Falls",
GFD: "Greenfield",
GFE: "Grenfell",
GFF: "Griffith",
GFK: "Grand Forks",
GFL: "Glens Falls",
GFN: "Grafton",
GFO: "Bartica",
GFR: "BrŽville-sur-Mer, Manche",
GFY: "Grootfontein",
GGB: "çgua Boa",
GGC: "Lumbala N'guimbo",
GGE: "Georgetown",
GGF: "Almeirim",
GGG: "Longview",
GGH: "Cianorte",
GGJ: "Gua’ra",
GGM: "Kakamega",
GGN: "Gagnoa",
GGO: "Guiglo",
GGR: "Garowe",
GGS: "Gobernador Gregores",
GGT: "Moss Town",
GGW: "Glasgow",
GHA: "El Atteuf",
GHB: "Governor's Harbour",
GHC: "Bullocks Harbour",
GHE: "GarachinŽ",
GHF: "Giebelstadt",
GHK: "Kennedy Lake",
GHM: "Centerville",
GHN: "Deyang (Guanghan)",
GHS: "Melak-Borneo Island",
GHT: "Ghat",
GHU: "Gualeguaychu",
GHV: "Bra?ov (Ghimbav)",
GIB: "Gibraltar",
GIC: "Boigu Island",
GID: "Gitega",
GIF: "Winter Haven",
GIG: "Rio De Janeiro",
GII: "Siguiri",
GIL: "Gilgit",
GIM: "Miele Mimbale",
GIR: "Girardot",
GIS: "Gisborne",
GIT: "Geita",
GIU: "Sigiriya",
GIY: "Giyani",
GIZ: "Jizan",
GJA: "Guanaja",
GJL: "Tahir",
GJM: "Guajar‡-Mirim",
GJR: "Gjšgur",
GJT: "Grand Junction",
GKA: "Goronka",
GKD: "Gškeada",
GKE: "Geilenkirchen",
GKH: "Gorkha",
GKK: "Huvadhu Atoll",
GKL: "Great Keppel Island",
GKN: "Gulkana",
GKT: "Sevierville",
GLA: "Glasgow",
GLB: "Globe",
GLC: "Geladi",
GLD: "Goodland",
GLE: "Gainesville",
GLF: "Golfito",
GLH: "Greenville",
GLI: "Glen Innes",
GLK: "Galcaio",
GLL: "Klanten flyplass",
GLN: "Guelmim",
GLO: "Staverton",
GLP: "Gulgubip",
GLR: "Gaylord",
GLS: "Galveston",
GLT: "Gladstone",
GLU: "Gelephu",
GLV: "Golovin",
GLW: "Glasgow",
GLX: "Galela-Celebes Island",
GLZ: "Rijen",
GMA: "Gemena",
GMB: "Gambela",
GMC: "Puerto Carre–o",
GMD: "Ben Slimane",
GME: "Gomel",
GMI: "Gasmata Island",
GMM: "Gamboma",
GMO: "Gombe",
GMP: "Seoul",
GMQ: "Golog (Maqn)",
GMS: "Guimar‹es",
GMT: "Granite Mountain",
GMU: "Greenville",
GMV: "Oljato-Monument Valley",
GMZ: "Alajero, La Gomera Island",
GNA: "Hrodna",
GNB: "Saint-ƒtienne-de-Saint-Geoirs, Isre",
GND: "Saint George's",
GNE: "Gent",
GNF: "Quincy",
GNG: "Gooding",
GNI: "LŸdao",
GNJ: "Ganja",
GNM: "Guanambi",
GNN: "Ghinnir",
GNR: "General Roca",
GNS: "Gunungsitoli",
GNT: "Grants",
GNU: "Goodnews",
GNV: "Gainesville",
GNY: "?anlõurfa",
GNZ: "Ghanzi",
GOA: "Genova (GE)",
GOB: "Goba",
GOC: "Gora",
GOE: "Gonaili",
GOG: "Gobabis",
GOH: "Nuuk",
GOI: "Vasco da Gama",
GOJ: "Nizhny Novgorod",
GOK: "Guthrie",
GOL: "Gold Beach",
GOM: "Goma",
GON: "Groton",
GOP: "Gorakhpur",
GOQ: "Golmud",
GOR: "Gore",
GOS: "Gosford",
GOT: "Gšteborg",
GOU: "Garoua",
GOV: "Nhulunbuy",
GOX: "Mopa",
GOY: "Tura",
GOZ: "Gorna Oryahovitsa",
GPA: "Patras",
GPB: "Guarapuava",
GPD: "Mount Gordon Mine",
GPI: "Guapi",
GPL: "Pococi",
GPN: "Pirlangimpi",
GPO: "General Pico",
GPS: "Isla Baltra",
GPT: "Gulfport",
GPZ: "Grand Rapids",
GQQ: "Galion",
GRA: "Puerto Mosquito",
GRB: "Green Bay",
GRC: "Grand Cess",
GRD: "Greenwood",
GRE: "Greenville",
GRF: "Fort Lewis/Tacoma",
GRG: "Gardez",
GRI: "Grand Island",
GRJ: "George",
GRK: "Fort Cavazos",
GRL: "Au",
GRM: "Grand Marais",
GRN: "Gordon",
GRO: "Girona",
GRP: "Gurupi",
GRQ: "Groningen",
GRR: "Grand Rapids",
GRS: "Grosseto (GR)",
GRT: "Gujrat",
GRU: "S‹o Paulo",
GRV: "Grozny",
GRW: "Santa Cruz da Graciosa",
GRX: "Granada",
GRY: "Gr’msey",
GRZ: "Feldkirchen bei Graz",
GSA: "Long Miau",
GSB: "Goldsboro",
GSC: "Gascoyne Junction",
GSE: "Gšteborg",
GSH: "Goshen",
GSI: "Grand-Santi",
GSJ: "Puerto San JosŽ",
GSL: "Taltheilei Narrows",
GSM: "Dayrestan",
GSN: "Mount Gunson",
GSO: "Greensboro",
GSP: "Greer",
GSQ: "Sharq El Owainat",
GSR: "Gardo",
GSS: "Belfast",
GST: "Gustavus",
GSV: "Saratov",
GTA: "Gatokae",
GTC: "Chato District",
GTE: "Groote Eylandt",
GTF: "Great Falls",
GTG: "Grantsburg",
GTI: "Dreschvitz",
GTK: "Sungai Tekai",
GTN: "Glentanner Station",
GTO: "Gorontalo-Celebes Island",
GTP: "Grants Pass",
GTR: "Columbus/W Point/Starkville",
GTS: "The Granites Gold Mine",
GTT: "Georgetown",
GTY: "Gettysburg",
GTZ: "Grumeti Game Reserve",
GUA: "Guatemala City",
GUB: "San Quint’n",
GUC: "Gunnison",
GUD: "Goundam",
GUE: "Guriaso",
GUF: "Gulf Shores",
GUG: "Guari",
GUJ: "Guaratinguet‡",
GUM: "HagŒt–a",
GUO: "Guriel",
GUP: "Gallup",
GUQ: "Guanare",
GUR: "Gurney",
GUS: "Peru",
GUU: "Grundarfjšr?ur",
GUV: "Mougulu",
GUW: "Atyrau",
GUY: "Guymon",
GUZ: "Guarapari",
GVA: "Geneva",
GVE: "Gordonsville",
GVI: "Green River",
GVL: "Gainesville",
GVN: "Sovetskaya Gavan",
GVR: "Governador Valadares",
GVT: "Greenville",
GVX: "GŠvle / Sandviken",
GWA: "Gwa",
GWD: "Gurandani",
GWE: "Gweru",
GWL: "Gwalior",
GWO: "Greenwood",
GWS: "Glenwood Springs",
GWT: "Sylt",
GWV: "Glendale",
GXF: "Seiyun",
GXG: "Negage",
GXH: "Gannan (Xiahe)",
GXQ: "Coyhaique",
GXX: "Yagoua",
GXY: "Greeley",
GYA: "Guayaramer’n",
GYB: "Wodgina",
GYD: "Baku",
GYE: "Guayaquil",
GYG: "Magan",
GYI: "Gisenyi",
GYM: "Guaymas",
GYN: "Goi‰nia",
GYO: "Kabupaten Gayo Lues",
GYR: "Goodyear",
GYS: "Guangyuan (Lizhou)",
GYU: "Guyuan (Yuanzhou)",
GYY: "Gary",
GYZ: "Cosmo Newbery",
GZG: "Garz (Garz)",
GZI: "Ghazni",
GZO: "Gizo",
GZP: "Gazipa?a",
GZT: "Gaziantep",
GZW: "Qazvin",
HAA: "Hasvik",
HAB: "Hamilton",
HAC: "Hachijojima",
HAD: "Halmstad",
HAE: "Supai Village",
HAF: "Half Moon Bay",
HAH: "Moroni",
HAI: "Three Rivers",
HAJ: "Hannover",
HAK: "Haikou (Meilan)",
HAL: "Halali",
HAM: "Hamburg",
HAN: "Hanoi (Soc Son)",
HAO: "Hamilton",
HAP: "Long Island",
HAQ: "Haa Dhaalu Atoll",
HAR: "Harrisburg",
HAS: "Ha'il",
HAT: "Shelburne",
HAU: "Karm¿y",
HAV: "Havana",
HAW: "Haverfordwest",
HAY: "Aguachica",
HAZ: "Hatzfeldhaven",
HBA: "Hobart (Cambridge)",
HBB: "Hobbs",
HBD: "Habi",
HBE: "Alexandria",
HBG: "Hattiesburg",
HBH: "Entrance Island",
HBK: "Holbrook",
HBQ: "Haibei (Qilian)",
HBR: "Hobart",
HBT: "Hambantota",
HBU: "Bulgan",
HBX: "Hubli",
HCA: "Big Spring",
HCC: "Hudson",
HCJ: "Hechi (Jinchengjiang)",
HCM: "Eyl",
HCN: "Hengchun",
HCR: "Holy Cross",
HCW: "Cheraw",
HCZ: "Chenzhou",
HDD: "Hyderabad",
HDE: "Holdrege",
HDF: "Zirchow",
HDG: "Handan",
HDH: "Mokuleia",
HDK: "Kulhudhuffushi",
HDM: "Hamadan",
HDN: "Hayden",
HDO: "Ghaziabad",
HDR: "Bandar Abbas",
HDS: "Hoedspruit",
HDY: "Hat Yai",
HEA: "Guzara",
HEB: "Hinthada",
HED: "Herendeen Bay",
HEE: "West Helena",
HEG: "Heglig Oilfield",
HEH: "Kalaw Township",
HEI: "Oesterdeichstrich",
HEK: "Heihe",
HEL: "Helsinki (Vantaa)",
HEN: "Helsinki",
HEO: "Haelogo",
HER: "Heraklion",
HES: "Hermiston",
HET: "Hohhot",
HEW: "Jinhua (Dongyang)",
HEY: "Fort Rucker Ozark",
HEZ: "Natchez",
HFA: "Haifa",
HFD: "Hartford",
HFE: "Hefei",
HFF: "Hoffman",
HFN: "Hšfn",
HFS: "RŒda",
HFT: "Hammerfest",
HGA: "Hargeisa",
HGD: "Hughenden",
HGE: "Higuerote",
HGH: "Hangzhou",
HGI: "Hollongi",
HGL: "Helgoland",
HGN: "Mae Hong Son",
HGO: "Korhogo",
HGR: "Hagerstown",
HGS: "Freetown",
HGT: "Jolon",
HGU: "Mount Hagen",
HGZ: "Hogatza",
HHE: "Hachinohe",
HHH: "Hilton Head Island",
HHI: "Wahiawa",
HHN: "Frankfurt am Main (Lautzenhausen)",
HHP: "Central and Western",
HHQ: "Hua Hin",
HHR: "Hawthorne",
HHZ: "Hikueru",
HIA: "Huai'an",
HIB: "Hibbing",
HID: "Horn",
HIE: "Whitefield",
HIF: "Ogden",
HIG: "Highbury",
HII: "Lake Havasu City",
HIJ: "Hiroshima",
HIK: "Honolulu",
HIL: "Shilavo",
HIM: "Polonnaruwa Town",
HIN: "Sacheon",
HIO: "Portland",
HIR: "Honiara",
HIS: "Hayman Island",
HIT: "Haivaro",
HIW: "Hiroshima",
HJB: "Hejing",
HJJ: "Huaihua",
HJR: "Khajuraho",
HJT: "Khujirt",
HKA: "Blytheville",
HKB: "Healy Lake",
HKD: "Hakodate",
HKG: "Hong Kong",
HKN: "Kimbe",
HKR: "Mara",
HKS: "Jackson",
HKT: "Phuket",
HKY: "Hickory",
HLA: "Johannesburg",
HLB: "Batesville",
HLC: "Hill City",
HLD: "Hailar",
HLE: "Longwood",
HLF: "Hultsfred",
HLG: "Wheeling",
HLH: "Ulanhot",
HLI: "Hollister",
HLJ: "Suihua",
HLL: "Hillside",
HLM: "Holland",
HLN: "Helena",
HLO: "Onundarfjšr?ur",
HLP: "Jakarta",
HLR: "Fort Cavazos (Killeen)",
HLV: "Helenvale",
HLW: "Hluhluwe",
HLZ: "Hamilton",
HMA: "Khanty-Mansiysk",
HMB: "Suhaj",
HME: "Hassi Messaoud",
HMG: "Hermannsburg (Ntaria)",
HMI: "Hami",
HMJ: "Khmelnytskyi",
HMN: "Alamogordo",
HMO: "Hermosillo",
HMR: "Hamar",
HMS: "Muara Teweh",
HMT: "Hemet",
HMV: "Hemavan",
HMY: "Seosan",
HNA: "Hanamaki",
HNB: "Huntingburg",
HNC: "Hatteras",
HND: "Tokyo",
HNH: "Hoonah",
HNI: "Heiweni",
HNL: "Honolulu, Oahu",
HNM: "Hana",
HNN: "Honinabi",
HNS: "Haines",
HNY: "Hengyang",
HOA: "Hola",
HOB: "Hobbs",
HOC: "Komako",
HOE: "Huay Xai",
HOF: "Hofuf",
HOG: "Holguin",
HOH: "Hohenems",
HOI: "Otepa",
HOK: "Lajamanu",
HOM: "Homer",
HON: "Huron",
HOO: "??k R'L?p",
HOP: "Fort Campbell",
HOQ: "Hof",
HOR: "Horta",
HOS: "Chos Malal",
HOT: "Hot Springs",
HOU: "Houston",
HOV: "¯rsta",
HOX: "Hommalinn",
HPA: "Lifuka",
HPB: "Hooper Bay",
HPE: "Hope Vale",
HPG: "Shennongjia (Hongping)",
HPH: "Haiphong (Hai An)",
HPN: "White Plains",
HPR: "Pretoria",
HPT: "Hampton",
HPV: "Hanalei",
HPY: "Baytown",
HQL: "Tashikuergan",
HQM: "Hoquiam",
HQQ: "Anyang",
HRA: "Mnichovo Hradi?t?",
HRB: "Harbin",
HRC: "Zhayrem",
HRE: "Harare",
HRG: "Hurghada",
HRH: "Aligarh",
HRI: "Mattala",
HRK: "Kharkiv",
HRL: "Harlingen",
HRM: "Hassi R'Mel",
HRO: "Harrison",
HRR: "Campi–a",
HRS: "Harrismith",
HRY: "Ghan",
HRZ: "Horizontina",
HSA: "Turkõstan",
HSB: "Harrisburg",
HSC: "Shaoguan",
HSF: "Suifenhe",
HSG: "Saga",
HSH: "Las Vegas",
HSI: "Hastings",
HSJ: "Zhengzhou",
HSK: "Monflorite/Alcal‡ del Obispo",
HSL: "Huslia",
HSN: "Zhoushan",
HSP: "Hot Springs",
HSR: "Rajkot",
HSS: "Hisar",
HST: "Homestead",
HSV: "Huntsville",
HSZ: "Hsinchu City",
HTA: "Chita",
HTG: "Khatanga",
HTH: "Hawthorne",
HTI: "Hamilton Island",
HTL: "Houghton Lake",
HTM: "Hatgal",
HTN: "Hotan",
HTO: "East Hampton",
HTR: "Taketomi",
HTS: "Huntington",
HTT: "Mengnai",
HTV: "Huntsville",
HTW: "South Point",
HTY: "Antakya",
HTZ: "Hato Corozal",
HUA: "Redstone Arsnl Huntsville",
HUC: "Humacao",
HUD: "Humboldt",
HUE: "Akwi",
HUF: "Terre Haute",
HUG: "Huehuetenango",
HUH: "Fare",
HUI: "Hu?",
HUJ: "Hugo",
HUK: "Hukuntsi",
HUL: "Houlton",
HUM: "Houma",
HUN: "Hualien City",
HUO: "Holingol",
HUS: "Hughes",
HUT: "Hutchinson",
HUU: "Hu‡nuco",
HUW: "Humait‡",
HUX: "Huatulco",
HUY: "Grimsby, Lincolnshire",
HUZ: "Huizhou (Pingtan)",
HVA: "Analalava",
HVB: "Hervey Bay",
HVD: "Khovd",
HVE: "Hanksville",
HVG: "HonningsvŒg",
HVK: "H—lmav’k",
HVN: "New Haven",
HVR: "Havre",
HVS: "Hartsville",
HWA: "Hawabango",
HWD: "Hayward",
HWI: "Hawk Inlet",
HWK: "Hawker",
HWN: "Gwayi River Farms",
HWO: "Hollywood",
HXD: "Delingha",
HYA: "Hyannis",
HYC: "Marlow, Buckinghamshire",
HYD: "Hyderabad",
HYF: "Bainyik",
HYG: "Hydaburg",
HYL: "Hollis",
HYN: "Taizhou (Luqiao)",
HYR: "Hayward",
HYS: "Hays",
HYV: "HyvinkŠŠ",
HZA: "Heze (Dingtao)",
HZB: "Merville, Nord",
HZG: "Hanzhong (Chenggu)",
HZH: "Liping",
HZK: "Hœsav’k",
HZL: "Hazleton",
HZP: "Fort Mackay",
HZU: "Chengdu (Jintang)",
HZV: "Hazyview",
IAA: "Igarka",
IAB: "Wichita",
IAD: "Dulles",
IAG: "Niagara Falls",
IAH: "Houston",
IAL: "Ialibu",
IAM: "In AmŽnas",
IAN: "Kiana",
IAO: "Del Carmen",
IAQ: "Imam Hassan",
IAR: "Tunoshna",
IAS: "Ia?i",
IAX: "Miangas",
IBA: "Ibadan",
IBB: "Puerto Villamil",
IBE: "IbaguŽ",
IBI: "Iboki",
IBL: "Bazaruto Island",
IBM: "Japal Camp",
IBO: "Ibo",
IBP: "Iberia",
IBR: "Omitama",
IBZ: "Ibiza (Eivissa)",
ICC: "Isla de Coche",
ICI: "Cicia",
ICK: "Nieuw Nickerie",
ICL: "Clarinda",
ICN: "Seoul",
ICO: "Carles",
ICS: "Cascade",
ICT: "Wichita",
ICY: "Icy Bay",
IDA: "Idaho Falls",
IDB: "Idre",
IDF: "Idiofa",
IDG: "Ida Grove",
IDH: "Grangeville",
IDI: "Indiana",
IDK: "Indulkana",
IDN: "Indagen",
IDO: "Cristal‰ndia",
IDP: "Independence",
IDR: "Indore",
IDY: "ële d'Yeu",
IEG: "Nowe Kramsko",
IEJ: "Ie",
IES: "Riesa",
IEV: "Kyiv",
IFA: "Iowa Falls",
IFH: "Hesa",
IFJ: "êsafjšr?ur",
IFN: "Isfahan",
IFO: "Ivano-Frankivsk",
IFP: "Bullhead City",
IFU: "Ifuru Island",
IGA: "Matthew Town",
IGB: "Ingeniero Jacobacci",
IGD: "I?dõr",
IGE: "Iguela",
IGG: "Igiugig",
IGL: "‚i?li",
IGM: "Kingman",
IGN: "Balo-i",
IGO: "Chigorod—",
IGR: "Puerto Iguazu",
IGS: "Manching",
IGT: "Sunzha",
IGU: "Foz do Iguau",
IHC: "Inhaca",
IHN: "Qishn",
IHO: "Ihosy",
IHR: "Iranshahr",
IHU: "Ihu",
IIA: "Inis Me‡in",
IIL: "Ilam",
IIS: "Nissan Island",
IJK: "Izhevsk",
IJU: "Iju’",
IJX: "Jacksonville",
IKA: "Tehran",
IKB: "North Wilkesboro",
IKE: "Ikerasak",
IKG: "Karakol",
IKI: "Iki",
IKK: "Kankakee",
IKL: "Ikela",
IKO: "Nikolski",
IKP: "Inkerman",
IKS: "Tiksi",
IKT: "Irkutsk",
IKU: "Tamchy",
ILA: "Ilaga",
ILD: "Lleida",
ILE: "Killeen",
ILF: "Ilford",
ILG: "Wilmington",
ILH: "Illesheim",
ILI: "Iliamna",
ILK: "Ilaka",
ILL: "Willmar",
ILM: "Wilmington",
ILN: "Wilmington",
ILO: "Cabatuan",
ILP: "ële des Pins",
ILQ: "Ilo",
ILR: "Ilorin",
ILS: "San Salvador",
ILU: "Kilaguni",
ILY: "Isle of Islay, Argyll and Bute",
ILZ: "Doln? Hri?ov",
IMA: "Iamalele, Fergusson Island",
IMB: "Imbaimadai",
IMD: "Imonda",
IMF: "Imphal",
IMG: "Inhaminga",
IMI: "Arno Atoll",
IMK: "Simikot",
IML: "Imperial",
IMM: "Immokalee",
IMN: "Imane",
IMO: "Zemio",
IMP: "Imperatriz",
IMQ: "Showt",
IMT: "Kingsford",
INA: "Inta",
INB: "Independence",
INC: "Yinchuan",
IND: "Indianapolis",
INE: "Chinde",
INF: "In Guezzam",
INH: "Inhambane",
INI: "Ni?",
INJ: "Injune",
INK: "Wink",
INL: "International Falls",
INN: "Innsbruck",
INO: "Inongo",
INQ: "Inis O’rr",
INS: "Indian Springs",
INT: "Winston Salem",
INU: "Yaren District",
INV: "Inverness",
INW: "Winslow",
INX: "Inanwatan",
INY: "Inyati",
INZ: "In Salah",
IOA: "Ioannina",
IOK: "Iokea",
IOM: "Castletown",
ION: "Impfondo",
IOP: "Ioma",
IOQ: "Isortoq",
IOR: "Inis M—r",
IOS: "IlhŽus",
IOT: "Illorsuit",
IOW: "Iowa City",
IPA: "Ipota",
IPC: "Isla De Pascua",
IPE: "Ipil",
IPG: "Santo Ant™nio do I‡",
IPH: "Ipoh",
IPI: "Ipiales",
IPL: "Imperial",
IPN: "Ipatinga",
IPT: "Williamsport",
IPU: "Ipiaœ",
IPZ: "PŽrez Zeled—n",
IQA: "H?t",
IQM: "Qiemo",
IQN: "Qingyang (Xifeng)",
IQQ: "Iquique",
IQT: "Iquitos",
IRA: "Kirakira",
IRB: "Iraan",
IRC: "Circle",
IRD: "Ishurdi",
IRE: "Irec",
IRG: "Lockhart River",
IRI: "Nduli",
IRJ: "La Rioja",
IRK: "Kirksville",
IRN: "Iriona",
IRO: "Birao",
IRP: "Isiro",
IRS: "Sturgis",
IRU: "Iranamadu",
IRZ: "Santa Isabel Do Rio Negro",
ISA: "Mount Isa",
ISB: "Attock",
ISC: "St. Mary's, Isles of Scilly",
ISD: "IscuandŽ",
ISE: "Isparta",
ISG: "Ishigaki",
ISJ: "Isla Mujeres",
ISK: "Nasik",
ISL: "Bakõrkšy, Istanbul",
ISM: "Orlando",
ISO: "Kinston",
ISP: "Islip",
ISQ: "Manistique",
ISS: "Wiscasset",
IST: "Arnavutkšy, Istanbul",
ISU: "Sulaymaniyah",
ISW: "Wisconsin Rapids",
ITA: "Itacoatiara",
ITB: "Itaituba",
ITE: "Ituber‡",
ITH: "Ithaca",
ITI: "Itambacuri",
ITJ: "Itaja’",
ITK: "Itokama",
ITM: "Osaka",
ITN: "Itabuna",
ITO: "Hilo",
ITP: "Itaperuna",
ITQ: "Itaqui",
ITR: "Itumbiara",
ITU: "Kurilsk",
IUA: "Ontario County IDA",
IUE: "Alofi",
IUI: "Innarsuit",
IUL: "Ilu",
IUP: "Apu’",
IVC: "Invercargill",
IVG: "Berane",
IVI: "Isla Viveros",
IVL: "Ivalo",
IVO: "Chivolo",
IVR: "Inverell",
IVW: "Inverway",
IWA: "Ivanovo",
IWD: "Ironwood",
IWJ: "Masuda",
IWK: "Iwakuni",
IWO: "Ogasawara",
IWS: "Houston",
IXA: "Agartala",
IXB: "Siliguri",
IXC: "Chandigarh",
IXD: "Allahabad",
IXE: "Mangalore",
IXG: "Belgaum",
IXH: "Kailashahar",
IXI: "Lilabari",
IXJ: "Jammu",
IXK: "Keshod",
IXL: "Leh",
IXM: "Madurai",
IXN: "Khowai",
IXP: "Pathankot",
IXQ: "Manik Bhandar",
IXR: "Ranchi",
IXS: "Silchar",
IXT: "Pasighat",
IXU: "Aurangabad",
IXW: "Jamshedpur",
IXX: "Bidar",
IXY: "Kandla",
IXZ: "Port Blair",
IYK: "Inyokern",
IZA: "Juiz de Fora",
IZE: "Hohenlockstedt",
IZM: "Seluk",
IZO: "Izumo",
IZT: "Ixtepec",
JAA: "Jalalabad",
JAC: "Jackson",
JAD: "Perth",
JAE: "JaŽn",
JAF: "Jaffna",
JAG: "Jacobabad",
JAI: "Jaipur",
JAK: "Jacmel",
JAL: "Emiliano Zapata",
JAM: "Bezmer",
JAN: "Jackson",
JAP: "Puntarenas",
JAQ: "Jacquinot Bay",
JAR: "Jahrom",
JAS: "Jasper",
JAT: "Ailinglapalap Atoll",
JAU: "Jauja",
JAV: "Ilulissat",
JAW: "Araripina",
JAX: "Jacksonville",
JBB: "Jember",
JBK: "Qitai",
JBQ: "La Isabela",
JBR: "Jonesboro",
JBS: "S‹o Borja",
JBT: "Bethel",
JCB: "Joaaba",
JCH: "Qasigiannguit",
JCI: "New Century",
JCJ: "Chuja, HachÕuja-do (Chujado Islands)",
JCL: "?eskŽ Bud?jovice",
JCM: "Jacobina",
JCR: "Jacareacanga",
JCS: "Crateœs",
JCT: "Junction",
JCU: "Ceuta",
JCY: "Stonewall",
JDA: "John Day",
JDE: "Hangzhou",
JDF: "Juiz de Fora",
JDG: "Jeju Island",
JDH: "Jodhpur",
JDN: "Jordan",
JDO: "Juazeiro do Norte",
JDR: "S‹o Jo‹o Del Rei",
JDZ: "Jingdezhen",
JED: "Jeddah",
JEE: "Carrefour Sanon",
JEF: "Jefferson City",
JEG: "Aasiaat",
JEJ: "Ailinglapalap Atoll",
JEK: "Jeki",
JEQ: "JequiŽ",
JER: "Saint Helier",
JFK: "New York",
JFM: "Fremantle",
JFN: "Ashtabula",
JFR: "Paamiut",
JGA: "Jamnagar",
JGB: "Jagdalpur",
JGD: "Jiagedaqi",
JGN: "Jiayuguan",
JGO: "Qeqertarsuaq",
JGR: "Kangilinnguit",
JGS: "Ji'an",
JHB: "Johor Bahru",
JHF: "S‹o Roque",
JHG: "Jinghong (Gasa)",
JHL: "Albian Village",
JHM: "Lahaina",
JHN: "Mandailing",
JHS: "Sisimiut",
JHW: "Jamestown",
JIA: "Ju’na",
JIB: "Djibouti City",
JIC: "Jinchang",
JID: "City of Industry",
JIJ: "Jijiga",
JIK: "Ikaria Island",
JIL: "Jilin",
JIM: "Jimma",
JIN: "Jinja",
JIO: "Tiakur",
JIP: "Jipijapa",
JIQ: "Qianjiang",
JIR: "Jiri",
JIU: "Jiujiang",
JJD: "Cruz",
JJG: "Jaguaruna",
JJI: "Juanju’",
JJM: "Meru-Kinna",
JJN: "Quanzhou",
JJU: "Qaqortoq",
JKG: "Jšnkšping",
JKH: "Chios Island",
JKL: "Kalymnos Island",
JKR: "Janakpur",
JKV: "Jacksonville",
JLA: "Cooper Landing",
JLG: "Jalgaon",
JLN: "Joplin",
JLR: "Jabalpur",
JLS: "Jales",
JMA: "Manhuau",
JMB: "Jamba",
JMJ: "Pu'er (Lancang)",
JMK: "Mykonos",
JMO: "Jomsom",
JMR: "Maric‡",
JMS: "Jamestown",
JMU: "Jiamusi",
JNA: "Janu‡ria",
JNB: "Johannesburg",
JNG: "Jining",
JNJ: "Duqm",
JNN: "Nanortalik",
JNS: "Narsaq",
JNU: "Juneau",
JNX: "Naxos",
JNZ: "Jinzhou (Linghai)",
JOE: "Joensuu",
JOG: "Yogyakarta",
JOH: "Port St Johns",
JOI: "Joinville",
JOJ: "Hope Bay",
JOK: "Yoshkar-Ola",
JOL: "Jolo",
JOM: "Njombe",
JOP: "Josephstaal",
JOS: "Jos",
JOT: "Joliet",
JPA: "Jo‹o Pessoa",
JPE: "Paragominas",
JPN: "Washington DC",
JPO: "Patos",
JPR: "Ji-Paran‡",
JPY: "Paraty",
JQA: "Uummannaq",
JQE: "JaquŽ",
JRA: "New York",
JRB: "New York",
JRF: "Kapolei",
JRH: "Jorhat",
JRJ: "Ganzhou",
JRK: "Arsuk",
JRN: "Juruena",
JRO: "Arusha",
JRT: "Juruti",
JSB: "S‹o Benedito",
JSH: "Crete Island",
JSI: "Skiathos",
JSJ: "Jiansanjiang",
JSK: "Bandar-e-Jask",
JSM: "Chubut",
JSO: "Sobral",
JSR: "Jashore (Jessore)",
JST: "Johnstown",
JSU: "Maniitsoq",
JSY: "Syros Island",
JTA: "Tau‡",
JTC: "Bauru",
JTI: "Jata’",
JTN: "ItanhaŽm",
JTR: "Santorini Island",
JTY: "Astypalaia Island",
JUA: "Juara",
JUB: "Juba",
JUH: "Chizhou",
JUI: "Juist",
JUJ: "San Salvador de Jujuy",
JUK: "Ukkusissat",
JUL: "Juliaca",
JUM: "Jumla",
JUN: "Jundah",
JUO: "Jurad—",
JUR: "Jurien Bay",
JUT: "Jutigalpa",
JUU: "Nuugaatsiaq",
JUV: "Upernavik",
JUZ: "Quzhou (Kezheng)",
JVA: "Ankavandra",
JVI: "Manville",
JVL: "Janesville",
JWA: "Jwaneng",
JWN: "Zanjan",
JWO: "Gimseang-ro",
JXA: "Jixi",
JXN: "Jackson",
JYR: "Jiroft",
JYV: "JyvŠskylŠn Maalaiskunta",
JZH: "Ngawa (Songpan)",
KAA: "Kasama",
KAB: "Kariba",
KAC: "Qamishly",
KAD: "Kaduna",
KAE: "Kake",
KAF: "Karato",
KAG: "Gangneung",
KAH: "Melbourne",
KAI: "Kaieteur Falls",
KAJ: "Kajaani",
KAK: "Kar",
KAL: "Kaltag",
KAM: "Kamaran",
KAN: "Kano",
KAO: "Kuusamo",
KAP: "Kapanga",
KAQ: "Kamulai Mission",
KAR: "Kamarang",
KAS: "Karasburg",
KAT: "Awanui",
KAU: "Kauhava",
KAV: "KavanayŽn",
KAW: "Kawthoung",
KAX: "Kalbarri",
KAY: "Wakaya Island",
KAZ: "Kao-Celebes Island",
KBA: "Kabala",
KBB: "Kirkimbie",
KBC: "Birch Creek",
KBD: "Kimberley Downs",
KBE: "Bell Island",
KBF: "Karubaga",
KBH: "Kahama",
KBI: "Kribi",
KBJ: "Petermann",
KBK: "Kushinagar",
KBL: "Kabul",
KBN: "Kabinda",
KBO: "Kabalo",
KBP: "Boryspil",
KBQ: "Kasungu",
KBR: "Kota Baharu",
KBS: "Bo",
KBT: "Kaben",
KBU: "Stagen",
KBV: "Krabi",
KBW: "Chignik",
KBX: "Kambuaya-Papua Island",
KCA: "Kuqa",
KCB: "Kasikasima",
KCC: "Coffman Cove",
KCD: "Kamur",
KCF: "Kadanwari",
KCG: "Chignik",
KCH: "Kuching",
KCI: "Koolan Island",
KCJ: "Komaio",
KCK: "Kirensk",
KCL: "Chignik Flats",
KCM: "Kahramanmara?",
KCN: "Chernofski Harbor",
KCO: "Kartepe",
KCP: "Kamyan'ka",
KCQ: "Chignik Lake",
KCR: "Colorado Creek",
KCS: "Petermann",
KCT: "Galle",
KCU: "Masindi",
KCY: "Krasnoyarsk",
KCZ: "Nankoku",
KDA: "Kolda",
KDB: "Kambalda West",
KDC: "Kandi",
KDD: "Khuzdar",
KDE: "Koroba",
KDH: "Khvoshab",
KDI: "Kendari",
KDJ: "N'DjolŽ",
KDK: "Kodiak",
KDL: "KŠrdla",
KDM: "Huvadhu Atoll",
KDN: "Ndende",
KDO: "Kadhdhoo",
KDP: "Kandep",
KDQ: "Kamberatoro Mission",
KDR: "Kandrian",
KDS: "Kamaran Downs",
KDT: "Nakhon Pathom",
KDU: "Skardu",
KDV: "Vunisea",
KDW: "Kandy",
KDX: "Kadugli",
KDY: "Khandyga",
KDZ: "Kandy",
KEA: "Kerki",
KEB: "Nanwalek",
KEC: "Kasenga",
KED: "KaŽdi",
KEE: "Kelle",
KEF: "Reykjav’k",
KEG: "Denglagu Mission",
KEH: "Kenmore",
KEI: "Kepi",
KEJ: "Kemerovo",
KEK: "Ekwok",
KEL: "Kiel",
KEM: "Kemi / Tornio",
KEN: "Kenema",
KEO: "Odienne",
KEP: "Nepalgunj",
KEQ: "Kebar",
KER: "Kerman",
KES: "Kelsey",
KET: "Kengtung",
KEU: "Keekorok",
KEV: "JŠmsŠ",
KEW: "Keewaywin",
KEX: "Kanabea",
KEY: "Kericho",
KEZ: "Colombo",
KFA: "Kiffa",
KFE: "Cloudbreak Village",
KFM: "Kirby Lake",
KFP: "False Pass",
KFS: "Kastamonu",
KFZ: "Kuk‘s",
KGA: "Kananga",
KGB: "Konge",
KGD: "Kaliningrad",
KGE: "Kagau Island",
KGF: "Karaganda",
KGG: "KŽdougou",
KGH: "Yongai",
KGI: "Broadwood",
KGJ: "Karonga",
KGK: "Koliganek",
KGL: "Kigali",
KGM: "Kungim",
KGN: "Kasongo-Lunda",
KGO: "Kirovograd",
KGP: "Kogalym",
KGQ: "Kangersuatsiaq",
KGR: "Ghan",
KGS: "Kos Island",
KGT: "Garz (Kangding)",
KGU: "Keningau",
KGW: "Kagi",
KGX: "Grayling",
KGZ: "Glacier Creek",
KHA: "Khaneh",
KHC: "Kerch",
KHE: "Kherson",
KHG: "Kashgar",
KHH: "Kaohsiung (Xiaogang)",
KHI: "Karachi",
KHJ: "Kauhajoki",
KHK: "Khark",
KHM: "Kanti",
KHN: "Nanchang",
KHO: "Khoka Moya",
KHQ: "Kullorsuaq",
KHS: "Khasab",
KHT: "Khost",
KHU: "Kremenchuk",
KHV: "Khabarovsk",
KHW: "Khwai River Lodge",
KHX: "Kihihi",
KHY: "Khoy",
KHZ: "Kauehi",
KIB: "Ivanof Bay",
KIC: "King City",
KID: "Kristianstad",
KIE: "Kieta",
KIF: "Kingfisher Lake",
KIG: "Koingnaas",
KIH: "Kish Island",
KII: "Kibuli",
KIJ: "Niigata",
KIK: "Kirkuk",
KIL: "Kilwa",
KIM: "Kimberley",
KIN: "Kingston",
KIO: "Kili Island",
KIP: "Wichita Falls",
KIQ: "Kira",
KIR: "Farranfore",
KIS: "Kisumu",
KIT: "Kithira Island",
KIU: "Kiunga",
KIW: "Kitwe",
KIX: "Osaka",
KIY: "Kilwa Masoko",
KJA: "Krasnoyarsk",
KJB: "Orvakal",
KJH: "Kaili  (Huangping)",
KJI: "Burqin",
KJJ: "Kampala",
KJK: "Wevelgem",
KJP: "Zamami",
KJT: "Kertajati",
KJX: "Blangpidie",
KKA: "Koyuk",
KKB: "Kitoi Bay",
KKC: "Khon Kaen",
KKD: "Kokoda",
KKE: "Kerikeri",
KKG: "Konawaruk",
KKH: "Kongiganak",
KKI: "Akiachak",
KKJ: "Kitakyushu",
KKK: "Kalakaket Creek",
KKL: "Karluk Lake",
KKN: "Kirkenes",
KKO: "Kaikohe",
KKP: "Koolburra",
KKQ: "Krasnoselkup",
KKR: "Raitahiti",
KKS: "Kashan",
KKT: "Kentland",
KKU: "Ekuk",
KKW: "Kikwit",
KKX: "Kikai",
KKY: "Kilkenny",
KKZ: "Krong Khemara Phoumin",
KLB: "Kalabo",
KLC: "Kaolack",
KLD: "Tver",
KLE: "KaŽlŽ",
KLF: "Kaluga",
KLG: "Kalskag",
KLH: "Kolhapur",
KLI: "Kotakoli",
KLK: "Kalokol",
KLL: "Levelock",
KLM: "Kalaleh",
KLN: "Larsen Bay",
KLO: "Kalibo",
KLP: "Seruyan",
KLR: "Kalmar",
KLS: "Kelso",
KLU: "Klagenfurt am Wšrthersee",
KLV: "Karlovy Vary",
KLW: "Klawock",
KLX: "Kalamata",
KLY: "Kalima",
KLZ: "Kleinsee",
KMA: "Kerema",
KMB: "Konambe",
KMC: "King Khaled Military City",
KME: "Kamembe",
KMF: "Hoieti",
KMG: "Kunming",
KMH: "Kuruman",
KMI: "Miyazaki",
KMJ: "Kumamoto",
KMK: "Makabana",
KMM: "Kimaam",
KMN: "Kamina",
KMO: "Manokotak",
KMP: "Keetmanshoop",
KMQ: "Kanazawa",
KMR: "Karimui",
KMS: "Kumasi",
KMU: "Kismayo",
KMV: "Kalemyo",
KMW: "Kostroma",
KMX: "Khamis Mushait",
KMY: "Moser Bay",
KMZ: "Kaoma",
KNA: "Vi–a del Mar",
KNB: "Kanab",
KND: "Kindu",
KNE: "Kanainj",
KNF: "King's Lynn, Norfolk",
KNG: "Kaimana",
KNH: "Shang-I",
KNJ: "Kindamba",
KNK: "Kokhanok",
KNM: "Kaniama",
KNN: "Kankan",
KNO: "Beringin",
KNP: "Capanda",
KNQ: "KonŽ",
KNR: "Jam",
KNT: "Kennett",
KNU: "Kanpur",
KNW: "New Stuyahok",
KNX: "Kununurra",
KNZ: "Kenieba",
KOA: "Kailua-Kona",
KOC: "Koumac",
KOD: "Kotabangun-Borneo Island",
KOE: "Kupang",
KOF: "Komatipoort",
KOH: "Maramie",
KOI: "Orkney Islands",
KOJ: "Kagoshima",
KOK: "Kokkola / Kruunupyy",
KOM: "Komo",
KOO: "Kongolo",
KOP: "Nakhon Phanom",
KOQ: "Kšthen (Anhalt)",
KOR: "Kakoro",
KOS: "Preah Sihanouk",
KOT: "Kotlik",
KOU: "Koulamoutou",
KOV: "Kokshetau",
KOW: "Ganzhou",
KOX: "Kokonao",
KOY: "Olga Bay",
KOZ: "Ouzinkie",
KPA: "Kopiago",
KPB: "Point Baker",
KPC: "Port Clarence",
KPF: "Kondobol",
KPI: "Kapit",
KPL: "Kapal",
KPN: "Kipnuk",
KPO: "Pohang",
KPP: "Kalpower",
KPR: "Port Williams",
KPT: "Jackpot",
KPV: "Perryville",
KPW: "Keperveem",
KPY: "Port Bailey",
KQA: "Akutan",
KQH: "Ajmer (Kishangarh)",
KQL: "Kol",
KQR: "Karara",
KQT: "Kurgan-Tyube",
KRC: "Sungai Penuh",
KRD: "Kurundi Station",
KRE: "Kirundo",
KRF: "Nyland",
KRG: "Karasabai",
KRI: "Kikori",
KRJ: "Amboin",
KRK: "Balice",
KRL: "Korla",
KRM: "Karanambo",
KRN: "Kiruna",
KRO: "Kurgan",
KRP: "Karup",
KRQ: "Kramatorsk",
KRR: "Krasnodar",
KRS: "Kjevik",
KRT: "Khartoum",
KRU: "Gunim",
KRV: "Kimwarer",
KRW: "Turkmenbashi",
KRX: "Kar Kar Island",
KRY: "Karamay",
KRZ: "Kiri",
KSA: "Okat",
KSB: "Kasonombe",
KSC: "Ko?ice",
KSD: "Karlstad",
KSE: "Kasese",
KSF: "Calden",
KSH: "Kermanshah",
KSI: "Kissidougou",
KSJ: "Kasos Island",
KSK: "Karlskoga",
KSL: "Kassala",
KSM: "St Mary's",
KSN: "Kostanay",
KSO: "Argos Orestiko",
KSP: "Kosipe Mission",
KSQ: "Karshi",
KSR: "Benteng",
KSS: "Sikasso",
KSU: "Kvernberget",
KSW: "Kiryat Shmona",
KSX: "Yasuru",
KSY: "Kars",
KSZ: "Kotlas",
KTA: "Karratha",
KTB: "Thorne Bay",
KTC: "Katiola",
KTD: "Kitadait?jima",
KTE: "Kerteh",
KTG: "Ketapang",
KTH: "Tikchik",
KTJ: "Kichwa Tembo",
KTL: "Kitale",
KTM: "Kathmandu",
KTN: "Ketchikan",
KTO: "Kato",
KTP: "Tinson Pen",
KTQ: "Kitee",
KTS: "Brevig Mission",
KTT: "KittilŠ",
KTU: "Kota",
KTV: "Kamarata",
KTW: "Katowice",
KTX: "Koutiala",
KTY: "Kalutara",
KUA: "Kuantan",
KUC: "Kuria",
KUD: "Kudat",
KUE: "Kolombangara Island",
KUF: "Samara",
KUG: "Kubin Island",
KUH: "Kushiro",
KUK: "Kasigluk",
KUL: "Sepang",
KUM: "Yakushima",
KUN: "Kaunas",
KUO: "Kuopio / SiilinjŠrvi",
KUP: "Kupiano",
KUQ: "Kuri",
KUR: "Skazar",
KUS: "Kulusuk",
KUT: "Kopitnari",
KUU: "Bhuntar",
KUV: "Gunsan",
KUY: "Kamusi",
KUZ: "Kuummiut",
KVA: "Kavala",
KVB: "Skšvde",
KVC: "King Cove",
KVE: "Kitava Island",
KVG: "Kavieng",
KVK: "Apatity",
KVL: "Kivalina",
KVM: "Markovo",
KVO: "Kraljevo",
KVR: "Kavalerovo",
KVU: "Korolevu",
KVX: "Kirov",
KWA: "Kwajalein",
KWB: "Karimunjawa",
KWD: "Kavadja",
KWE: "Guiyang (Nanming)",
KWF: "Waterfall",
KWG: "Kryvyi Rih",
KWH: "Khwahan",
KWI: "Kuwait City",
KWJ: "Gwangju",
KWK: "Kwigillingok",
KWL: "Guilin (Lingui)",
KWM: "Kowanyama",
KWN: "Quinhagak",
KWO: "Kawito",
KWP: "West Point",
KWS: "Kwailabesi",
KWT: "Kwethluk",
KWY: "Kiwayu",
KWZ: "Kolwezi",
KXA: "Kasaan",
KXB: "Kolaka",
KXD: "Kondinskoye",
KXE: "Klerksdorp",
KXF: "Koro Island",
KXK: "Komsomolsk-on-Amur",
KXO: "Kisoro",
KXU: "Katiu",
KYA: "Konya",
KYB: "Ken's Bore",
KYD: "Orchid Island",
KYE: "Tripoli",
KYI: "Yalata Mission",
KYK: "Karluk",
KYO: "Tampa",
KYP: "Kyaukpyu",
KYT: "Kyauktu",
KYU: "Koyukuk",
KYX: "Yalumet",
KYZ: "Kyzyl",
KZB: "Zachar Bay",
KZC: "Kampong Chhnang",
KZD: "Krakor",
KZF: "Kaintiba",
KZG: "Kitzingen",
KZI: "Kozani",
KZN: "Kazan",
KZO: "Kyzylorda",
KZR: "Altõnta?",
KZS: "Kastelorizo Island",
LAA: "Lamar",
LAB: "Lab Lab Mission",
LAC: "Pulau Layang-Layang (Swallow Reef)",
LAD: "Luanda",
LAE: "Lae",
LAF: "West Lafayette",
LAH: "Labuha-Halmahera Island",
LAI: "Lannion",
LAJ: "Lages",
LAK: "Aklavik",
LAL: "Lakeland",
LAM: "Los Alamos",
LAN: "Lansing",
LAO: "Laoag City",
LAP: "La Paz",
LAQ: "Al Albraq",
LAR: "Laramie",
LAS: "Las Vegas",
LAU: "Lamu",
LAW: "Lawton",
LAX: "Los Angeles",
LAY: "Ladysmith",
LAZ: "Bom Jesus da Lapa",
LBA: "Leeds, West Yorkshire",
LBB: "Lubbock",
LBC: "LŸbeck",
LBD: "Khujand",
LBE: "Latrobe",
LBF: "North Platte",
LBG: "Paris (Le Bourget, Seine-Saint-Denis)",
LBH: "Sydney",
LBI: "Albi/Le SŽquestre",
LBJ: "Labuan Bajo, Manggarai Barat",
LBK: "Liboi",
LBL: "Liberal",
LBM: "Luabo",
LBN: "Lake Baringo",
LBO: "Lusambo",
LBP: "Long Banga",
LBQ: "Lambarene",
LBR: "L‡brea",
LBS: "Labasa",
LBT: "Lumberton",
LBU: "Labuan",
LBV: "Libreville",
LBW: "Long Bawan",
LBX: "Lubang",
LBY: "La Baule-Escoublac",
LBZ: "Lucapa",
LCA: "Larnaca",
LCB: "Pontes e Lacerda",
LCC: "Galatina (LE)",
LCD: "Louis Trichardt",
LCE: "La Ceiba",
LCF: "Rio Dulce",
LCG: "Culleredo",
LCH: "Lake Charles",
LCI: "Laconia / Gilford",
LCJ: "?—d?",
LCK: "Columbus",
LCL: "Pinar del Rio",
LCM: "La Cumbre",
LCO: "Lague",
LCP: "Loncopue",
LCQ: "Lake City",
LCR: "La Chorrera",
LCS: "Dehong (Longchuan)",
LCT: "Shijiazhuang",
LCV: "Capannori (LU)",
LCX: "Longyan (Liancheng)",
LCY: "London",
LDA: "Malda",
LDB: "Londrina",
LDC: "Lindeman Island",
LDE: "Tarbes/Lourdes/PyrŽnŽes",
LDG: "Leshukonskoye",
LDH: "Lord Howe Island",
LDI: "Lindi",
LDJ: "Linden",
LDK: "Lidkšping",
LDM: "Ludington",
LDN: "Lamidanda",
LDO: "Aurora",
LDS: "Yichun",
LDU: "Lahad Datu",
LDV: "Landivisiau",
LDW: "Lansdowne Station",
LDX: "Saint-Laurent-du-Maroni",
LDY: "Derry",
LDZ: "Londolozi",
LEA: "Exmouth",
LEB: "Lebanon",
LEC: "Len—is",
LED: "St. Petersburg",
LEE: "Leesburg",
LEF: "Lebakeng",
LEH: "Le Havre",
LEI: "Almer’a",
LEJ: "Schkeuditz",
LEK: "LabŽ",
LEM: "Lemmon",
LEN: "La Virgen Del Camino",
LEO: "Lekoni",
LEP: "Leopoldina",
LEQ: "Land's End, Cornwall",
LES: "Lesobeng",
LET: "Leticia",
LEU: "La Seu d'Urgell Pyrenees and Andorra",
LEV: "Bureta",
LEW: "Auburn/Lewiston",
LEX: "Lexington",
LEY: "Lelystad",
LEZ: "La Esperanza",
LFB: "Lumbo",
LFH: "Lanping Bai",
LFI: "Hampton",
LFK: "Lufkin",
LFM: "Lamerd",
LFN: "Louisburg",
LFO: "Kelafo",
LFP: "Lakefield",
LFQ: "Linfen (Yaodu)",
LFT: "Lafayette",
LFW: "LomŽ",
LGA: "New York",
LGB: "Long Beach",
LGC: "LaGrange",
LGD: "La Grande",
LGE: "Lake Gregory",
LGF: "Yuma Proving Ground(Yuma)",
LGG: "Gr‰ce-Hollogne",
LGI: "Deadman's Cay",
LGK: "Langkawi",
LGL: "Long Datih",
LGN: "Linga Linga",
LGO: "Langeoog",
LGQ: "Lago Agrio",
LGR: "Cochrane",
LGS: "Malargue",
LGU: "Logan",
LGW: "London",
LGX: "Luuq",
LGY: "Lagunillas",
LGZ: "Shannan",
LHA: "Lahr/Schwarzwald",
LHB: "h? ch’ minh",
LHE: "Lahore",
LHI: "Lereh-Papua Island",
LHK: "Xiangyang (Laohekou)",
LHN: "Linhares",
LHR: "London",
LHS: "Las Heras",
LHU: "Muneambuanas",
LHV: "Lock Haven",
LHW: "Lanzhou (Yongdeng)",
LIA: "Liangping",
LIB: "Limbunya",
LIC: "Limon",
LIE: "Libenge",
LIF: "Lifou",
LIG: "Limoges/Bellegarde",
LIH: "Lihue",
LII: "Mulia-Papua Island",
LIJ: "Lishui (Liandu)",
LIK: "Likiep Island",
LIL: "Lesquin",
LIM: "Lima",
LIN: "Segrate (MI)",
LIO: "Puerto Limon",
LIP: "Lins",
LIQ: "Lisala",
LIR: "Liberia",
LIS: "Lisbon",
LIT: "Little Rock",
LIV: "Livengood",
LIW: "Loikaw",
LIX: "Likoma Island",
LIY: "Hinesville",
LIZ: "Limestone",
LJA: "Lodja",
LJG: "Lijiang (Gucheng)",
LJN: "Angleton",
LJU: "Zgornji Brnik",
LKA: "Tiwatobi",
LKB: "Lakeba Island",
LKC: "Lekana",
LKD: "Lakeland Downs",
LKE: "Seattle",
LKG: "Lokichogio",
LKH: "Long Akah",
LKI: "Lubang",
LKK: "Kulik Lake",
LKL: "Lakselv",
LKM: "Lolak",
LKN: "Leknes",
LKO: "Lucknow",
LKP: "Lake Placid",
LKR: "Las Khorey",
LKU: "Kalokol",
LKV: "Lakeview",
LKW: "Lekhwair",
LKY: "Lake Manyara National Park",
LKZ: "Brandon, Suffolk",
LLA: "LuleŒ",
LLB: "Qiannan (Libo)",
LLC: "Lal-lo",
LLE: "Malelane",
LLF: "Yongzhou",
LLG: "Chillagoe",
LLH: "La Lima",
LLI: "Girany Amba",
LLJ: "Lubuk Linggau",
LLK: "Lankaran",
LLL: "Lissadell Station",
LLM: "Lomlom",
LLN: "Kelila",
LLO: "Palopo",
LLS: "Las Lomitas",
LLT: "Lobito",
LLU: "Alluitsup Paa",
LLV: "LŸliang",
LLW: "Lumbadzi",
LLX: "Lyndonville",
LLY: "Lumberton",
LMA: "Minchumina",
LMB: "Salima",
LMC: "La Macarena",
LMD: "Los Menucos",
LME: "Le Mans, Sarthe",
LMH: "Lim—n",
LMI: "Lumi",
LML: "Lae Island",
LMM: "Los Mochis",
LMN: "Limbang",
LMO: "Lossiemouth",
LMP: "Lampedusa",
LMQ: "Marsa al Brega",
LMR: "Lime Acres",
LMS: "Louisville",
LMT: "Klamath Falls",
LMU: "Bukit Padi",
LMV: "Naifaru",
LMX: "Micay",
LMY: "Lake Murray",
LMZ: "Palma",
LNA: "West Palm Beach",
LNB: "Lamen Bay",
LND: "Lander",
LNE: "Lonorore",
LNG: "Lese",
LNH: "Alpurrurulam",
LNI: "Point Lonely",
LNJ: "Lincang",
LNK: "Lincoln",
LNL: "Longnan (Cheng)",
LNN: "Willoughby",
LNO: "Leonora",
LNP: "Wise",
LNR: "Spring Green",
LNS: "Lancaster",
LNU: "Malinau",
LNV: "Londolovit",
LNX: "Smolensk",
LNY: "Lanai City",
LNZ: "Linz",
LOB: "Los Andes",
LOC: "Lock",
LOD: "Longana",
LOH: "La Toma (Catamayo)",
LOI: "Lontras",
LOK: "Lodwar",
LOL: "Lovelock",
LOM: "Lagos de Moreno",
LOO: "Laghouat",
LOP: "Mataram (Pujut, Lombok Tengah)",
LOQ: "Lobatse",
LOR: "Fort Rucker Ozark",
LOS: "Lagos",
LOT: "Chicago/Romeoville",
LOU: "Louisville",
LOV: "Monclova",
LOW: "Louisa",
LOY: "Loyengalani",
LOZ: "London",
LPA: "Gran Canaria Island",
LPB: "La Paz / El Alto",
LPC: "Lompoc",
LPD: "La Pedrera",
LPE: "La Primavera",
LPF: "Liupanshui (Zhongshan)",
LPG: "La Plata",
LPI: "Linkšping",
LPJ: "Guayabal",
LPK: "Lipetsk",
LPL: "Liverpool",
LPM: "Lamap",
LPN: "Leron Plains",
LPO: "La Porte",
LPP: "Lappeenranta",
LPQ: "Luang Phabang",
LPS: "Lopez",
LPU: "Long Apung-Borneo Island",
LPX: "Liep?ja",
LPY: "Chaspuzac, Haute-Loire",
LQK: "Pickens",
LQM: "Puerto Legu’zamo",
LQN: "Qala-i-Naw",
LRA: "Larissa",
LRB: "Leribe",
LRD: "Laredo",
LRE: "Longreach",
LRF: "Jacksonville",
LRG: "Loralai",
LRH: "La Rochelle/ële de RŽ",
LRJ: "Le Mars",
LRL: "Niamtougou",
LRM: "La Romana",
LRQ: "Laurie River",
LRR: "Lar",
LRS: "Leros Island",
LRT: "Lorient/Lann/BihouŽ",
LRU: "Las Cruces",
LRV: "Gran Roque Island",
LSA: "Losuia",
LSB: "Lordsburg",
LSC: "La Serena-Coquimbo",
LSE: "La Crosse",
LSF: "Fort Benning",
LSH: "Lashio",
LSI: "Lerwick, Shetland",
LSJ: "Long Island",
LSK: "Lusk",
LSL: "Los Chiles",
LSM: "Long Semado",
LSN: "Los Banos",
LSO: "Les Sables-d'Olonne",
LSP: "Paraguan‡",
LSQ: "Los Angeles",
LSR: "Kutacane",
LSS: "Les Saintes",
LST: "Launceston (Western Junction)",
LSU: "Long Sukang",
LSV: "Las Vegas",
LSW: "Lhok Seumawe-Sumatra Island",
LSX: "Lhok Sukon-Sumatra Island",
LSY: "Lismore",
LSZ: "Mali Lo?inj",
LTA: "Tzaneen",
LTC: "Lai",
LTD: "Ghadames",
LTF: "Leitre",
LTG: "Langtang",
LTI: "Altai",
LTK: "Latakia",
LTL: "Lastourville",
LTM: "Lethem",
LTN: "Luton, Bedfordshire",
LTO: "Loreto",
LTP: "Lyndhurst",
LTQ: "Le Touquet-Paris-Plage",
LTS: "Altus",
LTT: "La M™le, Var",
LTU: "Latur",
LTV: "Lotus Vale",
LTW: "California",
LTX: "Latacunga",
LUA: "Lukla",
LUB: "Lumid Pau",
LUC: "Laucala Island",
LUD: "Luderitz",
LUE: "Lu?enec",
LUF: "Glendale",
LUG: "Agno",
LUI: "La Uni—n",
LUJ: "Lusikisiki",
LUK: "Cincinnati",
LUL: "Laurel",
LUM: "Dehong (Mangshi)",
LUN: "Lusaka",
LUO: "Luena",
LUP: "Kalaupapa",
LUQ: "San Luis",
LUR: "Cape Lisburne",
LUS: "Lusanga",
LUT: "Laura Station",
LUV: "Langgur",
LUW: "Luwok",
LUX: "Luxembourg",
LUZ: "Lublin",
LVA: "Laval, Mayenne",
LVD: "Lime Village",
LVI: "Livingstone",
LVK: "Livermore",
LVL: "Lawrenceville",
LVM: "Livingston",
LVO: "Laverton",
LVP: "Lavan Airport",
LVR: "Lucas do Rio Verde",
LVS: "Las Vegas",
LWA: "Lebak",
LWB: "Lewisburg",
LWC: "Lawrence",
LWE: "Lewoleba",
LWI: "Lowai",
LWK: "Lerwick, Shetland Islands",
LWL: "Wells",
LWM: "Lawrence",
LWN: "Gyumri",
LWO: "Lviv",
LWR: "Leeuwarden",
LWS: "Lewiston",
LWT: "Lewistown",
LWV: "Lawrenceville",
LWY: "Lawas",
LXA: "Shannan (Gonggar)",
LXG: "Luang Namtha",
LXN: "Lexington",
LXR: "Luxor",
LXS: "Limnos Island",
LXU: "Lukulu",
LXV: "Leadville",
LYA: "Luoyang (Laocheng)",
LYB: "Blossom Village",
LYC: "Lycksele",
LYG: "Lianyungang",
LYH: "Lynchburg",
LYI: "Linyi (Hedong)",
LYK: "Lunyuk",
LYN: "Chassieu, Lyon",
LYO: "Lyons",
LYP: "Faisalabad",
LYR: "Longyearbyen",
LYS: "Colombier-Saugnieu, Rh™ne",
LYT: "Lady Elliot Island",
LYU: "Ely",
LYX: "Romney Marsh, Kent",
LZA: "Luiza",
LZC: "L‡zaro C‡rdenas",
LZG: "Nanchong (Langzhong)",
LZH: "Liuzhou (Liujiang)",
LZI: "Luozi",
LZM: "Luzamba",
LZN: "Matsu (Nangan)",
LZO: "Luzhou (Yunlong)",
LZU: "Lawrenceville",
LZY: "Nyingchi (Mainling)",
MAA: "Chennai",
MAB: "Marab‡",
MAC: "Macon",
MAD: "Madrid",
MAE: "Madera",
MAF: "Midland",
MAG: "Madang",
MAH: "Mah—n (Ma—)",
MAJ: "Majuro Atoll",
MAK: "Malakal",
MAL: "Mangole Island",
MAM: "Matamoros",
MAN: "Manchester, Greater Manchester",
MAO: "Manaus",
MAP: "Mamai",
MAR: "Maracaibo",
MAS: "Manus Island",
MAT: "Matadi",
MAV: "Maloelap Island",
MAW: "Malden",
MAX: "Ouro Sogui",
MAY: "Mangrove Cay",
MAZ: "Mayaguez",
MBA: "Mombasa",
MBC: "M'Bigou",
MBD: "Mafeking",
MBE: "Monbetsu",
MBG: "Mobridge",
MBH: "Maryborough",
MBI: "Mbeya",
MBJ: "Montego Bay",
MBK: "Matup‡",
MBL: "Manistee",
MBM: "Mkambati",
MBN: "Wunaamin Miliwundi Ranges",
MBO: "Mamburao",
MBP: "Moyobamba",
MBQ: "Mbarara",
MBS: "Freeland",
MBT: "Masbate",
MBU: "Mbambanakira",
MBV: "Masa",
MBW: "Melbourne",
MBX: "Orehova Vas",
MBY: "Moberly",
MBZ: "MauŽs",
MCA: "Macenta",
MCB: "McComb",
MCC: "Sacramento",
MCD: "Mackinac Island",
MCE: "Merced",
MCF: "Tampa",
MCG: "McGrath",
MCI: "Kansas City",
MCJ: "La Mina-Maicao",
MCK: "McCook",
MCL: "Denali Park",
MCM: "Fontvieille",
MCN: "Macon",
MCO: "Orlando",
MCP: "Macap‡",
MCS: "Monte Caseros",
MCT: "Muscat",
MCU: "LŽpaud, Creuse",
MCV: "McArthur River Mine",
MCW: "Mason City",
MCX: "Makhachkala",
MCY: "Maroochydore",
MCZ: "Macei—",
MDA: "San Antonio",
MDB: "Melinda",
MDC: "Manado",
MDD: "Midland",
MDE: "Medell’n",
MDF: "Medford",
MDG: "Mudanjiang",
MDH: "Murphysboro",
MDI: "Makurdi",
MDJ: "Madras",
MDK: "Mbandaka",
MDL: "Mandalay",
MDM: "Munduku",
MDN: "Madison",
MDO: "Middleton Island",
MDP: "Mindiptana-Papua Island",
MDQ: "Mar del Plata",
MDR: "Musiara",
MDS: "Middle Caicos",
MDT: "Harrisburg",
MDU: "Mendi",
MDV: "MŽdouneu, Gabon",
MDW: "Chicago",
MDX: "Mercedes",
MDY: "Sand Island",
MDZ: "Mendoza",
MEA: "MacaŽ",
MEB: "Essendon Fields",
MEC: "Manta",
MED: "Medina",
MEE: "MarŽ",
MEF: "Melfi",
MEG: "Malanje",
MEH: "Mehamn",
MEI: "Meridian",
MEJ: "Meadville",
MEK: "Meknes",
MEL: "Melbourne",
MEM: "Memphis",
MEN: "Mende/BrŽnoux",
MEO: "Manteo",
MEP: "Mersing",
MEQ: "Kuala Pesisir",
MER: "Merced",
MES: "Medan",
MET: "Moreton",
MEU: "Almeirim",
MEV: "Minden",
MEW: "Mweka",
MEX: "Ciudad de MŽxico",
MEY: "Meghauli",
MEZ: "Musina",
MFA: "Kilindoni",
MFB: "Monfort",
MFC: "Mafeteng",
MFD: "Mansfield",
MFE: "McAllen",
MFF: "Moanda",
MFG: "Muzaffarabad",
MFH: "Mesquite",
MFI: "Marshfield",
MFJ: "Moala",
MFK: "Matsu (Beigan)",
MFL: "Wando Vale",
MFM: "Nossa Senhora do Carmo",
MFO: "Manguna",
MFQ: "Maradi",
MFR: "Medford",
MFS: "Miraflores",
MFU: "Mfuwe",
MFV: "Melfa",
MFX: "Les Allues",
MFZ: "Demgulu",
MGA: "Managua",
MGB: "Mount Gambier",
MGC: "Michigan City",
MGD: "Magdalena",
MGE: "Marietta",
MGF: "Maring‡",
MGH: "Margate",
MGI: "Matagorda Island",
MGJ: "Montgomery",
MGK: "Mong Tong",
MGL: "Mšnchengladbach",
MGM: "Montgomery",
MGN: "MaganguŽ",
MGP: "Manga Mission",
MGQ: "Mogadishu",
MGR: "Moultrie",
MGS: "Mangaia Island",
MGT: "Milingimbi Island",
MGU: "Manaung",
MGW: "Morgantown",
MGX: "Moabi",
MGY: "Dayton",
MGZ: "Mkeik",
MHA: "Mahdia",
MHB: "Auckland City",
MHC: "Dalcahue",
MHD: "Mashhad",
MHE: "Mitchell",
MHF: "Morichal",
MHG: "Mannheim",
MHH: "Marsh Harbour",
MHI: "Moucha Island",
MHK: "Manhattan",
MHL: "Marshall",
MHM: "Manaoba",
MHN: "Mullen",
MHO: "Wunaamin Miliwundi Ranges",
MHQ: "Mariehamn",
MHR: "Sacramento",
MHS: "Dunsmuir",
MHT: "Manchester",
MHU: "Mount Hotham",
MHV: "Mojave",
MHW: "El Ba–ado",
MHX: "Manihiki Island",
MHY: "Morehead",
MHZ: "Bury Saint Edmunds, Suffolk",
MIA: "Miami",
MIB: "Minot",
MIC: "Minneapolis",
MID: "MŽrida",
MIE: "Muncie",
MIF: "Monahans",
MIG: "Mianyang (Fucheng)",
MIH: "Mitchell Plateau",
MII: "Mar’lia",
MIJ: "Mili Island",
MIK: "Mikkeli",
MIM: "Merimbula",
MIO: "Miami",
MIP: "Beersheba",
MIQ: "Omaha",
MIR: "Monastir",
MIS: "Misima Island",
MIT: "Shafter",
MIU: "Maiduguri",
MIV: "Millville",
MIW: "Marshalltown",
MIX: "Mirit’-Paran‡",
MIZ: "Mainoru",
MJA: "Manja",
MJB: "Mejit Atoll",
MJD: "Moenjodaro",
MJE: "Majkin",
MJF: "Mosj¿en",
MJG: "Mayajigua",
MJI: "Tripoli",
MJJ: "Moki",
MJK: "Denham",
MJL: "Mouila",
MJM: "Mbuji Mayi",
MJN: "Mahajanga",
MJO: "Mount Etjo Safari Lodge",
MJQ: "Jackson",
MJR: "Miramar",
MJS: "Maganja",
MJT: "Mytilene",
MJU: "Mamuju",
MJW: "Gonarezhou National Park",
MJX: "Toms River",
MJY: "Motygino",
MJZ: "Mirny",
MKA: "Miller",
MKB: "Mekambo",
MKC: "Kansas City",
MKE: "Milwaukee",
MKG: "Muskegon",
MKH: "Mokhotlong",
MKI: "Mboki",
MKJ: "Makoua",
MKK: "Kaunakakai",
MKL: "Jackson",
MKM: "Mukah",
MKN: "Babase Island",
MKO: "Muskogee",
MKP: "Makemo",
MKQ: "Merauke",
MKS: "Mekane Selam",
MKT: "Mankato",
MKU: "Makokou",
MKW: "Manokwari",
MKY: "Mackay",
MKZ: "Malacca",
MLA: "Valletta",
MLB: "Melbourne",
MLC: "Mc Alester",
MLD: "Malad City",
MLE: "MalŽ",
MLF: "Milford",
MLG: "Malang",
MLI: "Moline",
MLJ: "Milledgeville",
MLK: "Malta",
MLL: "Marshall",
MLM: "Morelia",
MLN: "Melilla",
MLO: "Milos Island",
MLP: "Malabang",
MLQ: "Malalaua",
MLS: "Miles City",
MLT: "Millinocket",
MLU: "Monroe",
MLV: "Merluna",
MLW: "Monrovia",
MLX: "Malatya",
MLY: "Manley Hot Springs",
MLZ: "Melo",
MMB: "?zora",
MMC: "Ciudad Mante",
MMD: "Minamidaito",
MME: "Darlington, Durham",
MMF: "Mamfe",
MMH: "Mammoth Lakes",
MMI: "Athens",
MMJ: "Matsumoto",
MMK: "Murmansk",
MML: "Marshall",
MMN: "Stow",
MMO: "Vila do Maio",
MMP: "Santa Cruz de Momp—x",
MMQ: "Mbala",
MMS: "Marks",
MMT: "Eastover",
MMU: "Morristown",
MMV: "Mal Island",
MMX: "Malmš",
MMY: "Miyakojima",
MMZ: "Maymana",
MNA: "Karakelong Island",
MNB: "Muanda",
MNC: "Nacala",
MND: "Medina",
MNE: "Mungeranie",
MNF: "Mana Island",
MNG: "Maningrida",
MNH: "Al Masna'ah",
MNI: "Gerald's Park",
MNJ: "Mananjary",
MNK: "Maiana",
MNL: "Manila (Pasay)",
MNM: "Menominee",
MNN: "Marion",
MNO: "Manono",
MNP: "Hermit Islands",
MNR: "Mongu",
MNS: "Mansa",
MNT: "Minto",
MNU: "Mawlamyine",
MNX: "ManicorŽ",
MNY: "Stirling Island",
MNZ: "Manassas",
MOA: "Moa",
MOB: "Mobile",
MOC: "Montes Claros",
MOD: "Modesto",
MOF: "Waioti",
MOG: "Mong Hsat",
MOH: "Morowali",
MOI: "Mitiaro Island",
MOJ: "Moengo",
MOK: "Muynak",
MOL: "r¿",
MOM: "Moudjeria",
MOO: "Moomba",
MOP: "Mount Pleasant",
MOQ: "Morondava",
MOR: "Morristown",
MOS: "Elim",
MOT: "Minot",
MOU: "Mountain Village",
MOV: "Moranbah",
MOX: "Morris",
MOY: "Monterrey",
MOZ: "Moorea-Maiao",
MPA: "Mpacha",
MPB: "Miami",
MPC: "Muko Muko",
MPD: "Sindhri",
MPF: "Mapoda",
MPG: "Makini",
MPH: "Caticlan",
MPI: "Mamitupu",
MPJ: "Morrilton",
MPL: "Montpellier/MŽditerranŽe",
MPM: "Maputo",
MPN: "Mount Pleasant",
MPO: "Mount Pocono",
MPP: "Mulatupo",
MPR: "Mc Pherson",
MPS: "Mount Pleasant",
MPT: "Maliana",
MPU: "Tatau Island",
MPV: "Barre/Montpelier",
MPW: "Mariupol",
MPX: "Miyanmin",
MPY: "Maripasoula",
MPZ: "Mount Pleasant",
MQA: "Eighty Mile Beach",
MQB: "Macomb",
MQC: "Miquelon",
MQD: "Maquinchao",
MQE: "Marqua",
MQF: "Magnitogorsk",
MQG: "Midgard",
MQH: "Minau",
MQJ: "Khonuu",
MQK: "San Mat’as",
MQL: "Mildura",
MQM: "Mardin",
MQN: "Mo i Rana",
MQO: "Malam",
MQP: "Mpumalanga",
MQQ: "Moundou",
MQR: "Mosquera",
MQS: "Lovell",
MQT: "Gwinn",
MQU: "Mariquita",
MQV: "Sayada",
MQW: "Mc Rae",
MQX: "Mekele",
MQY: "Smyrna",
MRA: "Misrata",
MRB: "Martinsburg",
MRC: "Columbia/Mount Pleasant",
MRD: "MŽrida",
MRE: "Masai Mara",
MRF: "Marfa",
MRG: "Mareeba",
MRH: "May River",
MRI: "Anchorage",
MRK: "Marco Island",
MRM: "Manari",
MRN: "Morganton",
MRO: "Masterton",
MRP: "Marla",
MRQ: "Gasan",
MRR: "Macar‡",
MRS: "Marignane, Bouches-du-Rh™ne",
MRT: "Moroak",
MRU: "Plaine Magnien",
MRV: "Mineralnyye Vody",
MRW: "R¿dby",
MRX: "Mahshahr",
MRY: "Monterey",
MRZ: "Moree",
MSA: "Muskrat Dam",
MSB: "Saint Martin",
MSC: "Mesa",
MSG: "Matsaile",
MSH: "Masirah",
MSI: "Masalembo Island",
MSJ: "Misawa",
MSK: "Puerto Gait‡n",
MSL: "Muscle Shoals",
MSM: "Masi Manimba",
MSN: "Madison",
MSO: "Missoula",
MSP: "Minneapolis",
MSQ: "Minsk",
MSR: "Mu?",
MSS: "Massena",
MST: "Maastricht",
MSU: "Mazenod",
MSV: "Monticello",
MSW: "Massawa",
MSX: "Mossendjo",
MSY: "New Orleans",
MSZ: "Mo‰medes",
MTB: "Montel’bano",
MTC: "Mount Clemens",
MTE: "Monte Alegre",
MTF: "Mizan Teferi",
MTG: "Vila Bela Da Sant’ssima Trindade",
MTH: "Marathon",
MTI: "Vila do Mosteiros",
MTJ: "Montrose",
MTK: "Makin Island",
MTM: "Metlakatla",
MTN: "Baltimore",
MTO: "Mattoon",
MTP: "Montauk",
MTR: "Monter’a",
MTS: "Manzini",
MTT: "Cosoleacaque",
MTU: "Montepuez",
MTV: "Ablow",
MTW: "Manitowoc",
MTX: "Fairbanks",
MTY: "Monterrey",
MTZ: "Masada",
MUA: "Munda",
MUB: "Maun",
MUC: "Munich",
MUD: "Mueda",
MUE: "Waimea (Kamuela)",
MUG: "Mulege",
MUH: "Marsa Matruh",
MUI: "Fort Indiantown Gap(Annville)",
MUJ: "Omo National Park",
MUK: "Mauke Island",
MUL: "Moultrie",
MUM: "Muli",
MUN: "Matur’n",
MUO: "Mountain Home",
MUQ: "Muccan Station",
MUR: "Marudi",
MUS: "Ogasawara",
MUT: "Muscatine",
MUU: "Maraœ",
MUW: "Ghriss",
MUX: "Multan",
MUY: "Mouyondzi",
MUZ: "Musoma",
MVA: "Myvatn",
MVB: "Franceville",
MVC: "Monroeville",
MVD: "Ciudad de la Costa",
MVE: "Montevideo",
MVF: "Mossor—",
MVK: "Mulka",
MVL: "Morrisville",
MVM: "Kayenta",
MVN: "Mount Vernon",
MVO: "Mongo",
MVP: "Mitœ",
MVQ: "Mogilev",
MVR: "Maroua",
MVS: "Mucuri",
MVU: "Musgrave",
MVV: "Megve",
MVW: "Burlington",
MVX: "Minvoul",
MVY: "Martha's Vineyard",
MVZ: "Masvingo",
MWA: "Marion",
MWC: "Milwaukee",
MWD: "Mianwali",
MWE: "Merowe",
MWF: "Maewo Island",
MWG: "Marawaka",
MWH: "Moses Lake",
MWI: "Maramuni",
MWJ: "Matthews Ridge",
MWK: "Palmatak",
MWL: "Mineral Wells",
MWM: "Windom",
MWN: "Mwadui",
MWO: "Middletown",
MWQ: "Magway",
MWR: "Motswari Private Game Reserve",
MWS: "Morowali",
MWT: "Moolawatana Station",
MWU: "Mussau Island",
MWV: "Sen Monorom",
MWX: "Muan (Piseo-ri)",
MWY: "Miranda Downs",
MWZ: "Mwanza",
MXA: "Manila",
MXB: "Masamba",
MXC: "Monticello",
MXD: "Marion Downs",
MXE: "Maxton",
MXF: "Montgomery",
MXH: "Moro",
MXI: "Mati",
MXJ: "Minna",
MXK: "Mindik",
MXL: "Mexicali",
MXM: "Morombe",
MXN: "Morlaix/Ploujean",
MXO: "Monticello",
MXP: "Ferno (VA)",
MXQ: "Cairu",
MXR: "Myrhorod",
MXS: "Maota",
MXT: "Maintirano",
MXV: "Mšršn",
MXW: "Mandalgobi",
MXX: "Mora",
MXY: "Mccarthy",
MXZ: "Meizhou (Meixian)",
MYA: "Moruya",
MYB: "Mayumba",
MYC: "Maracay",
MYD: "Malindi",
MYE: "Miyakejima",
MYF: "San Diego",
MYG: "Abraham Bay Settlement",
MYH: "Marble Canyon",
MYI: "Murray Island",
MYJ: "Matsuyama",
MYK: "May Creek",
MYL: "McCall",
MYM: "Monkey Mountain",
MYN: "Marib",
MYP: "Mary",
MYQ: "Mysore",
MYR: "Myrtle Beach",
MYS: "Moyale",
MYT: "Myitkyina",
MYU: "Mekoryuk",
MYV: "Marysville",
MYW: "Mtwara",
MYX: "Menyamya",
MYY: "Miri",
MYZ: "Monkey Bay",
MZA: "Mazamari",
MZB: "Moc’mboa da Praia",
MZC: "Mitzic",
MZD: "Santiago de MŽndez",
MZG: "Huxi",
MZH: "Amasya",
MZI: "SŽvarŽ",
MZJ: "Marana",
MZK: "Marakei",
MZL: "Manizales",
MZN: "Minj",
MZO: "Manzanillo",
MZQ: "Mkuze",
MZR: "Mazar-i-Sharif",
MZS: "Moradabad",
MZT: "Mazatlˆn",
MZU: "Muzaffarpur",
MZV: "Mulu",
MZW: "Mecheria",
MZY: "Mossel Bay",
MZZ: "Marion",
NAA: "Narrabri",
NAD: "Macanal",
NAE: "Natitingou",
NAF: "Banaina-Borneo Island",
NAG: "Nagpur",
NAH: "Tabukan Utara, Sangihe Islands",
NAI: "Annai",
NAJ: "Nakhchivan",
NAK: "Chaloem Phra Kiat",
NAL: "Nalchik",
NAM: "Namniwel",
NAN: "Nadi",
NAO: "Nanchong (Gaoping)",
NAP: "Napoli",
NAQ: "Qaanaaq",
NAR: "Armenia",
NAS: "Nassau",
NAT: "Natal",
NAU: "Napuka Island",
NAV: "Nev?ehir",
NAY: "Beijing",
NAZ: "Star Harbor",
NBA: "Nambaiyufa",
NBB: "Barranco Minas",
NBC: "Nizhnekamsk",
NBE: "Enfidha",
NBG: "New Orleans",
NBH: "Nambucca Heads",
NBJ: "Luanda (êcolo e Bengo)",
NBL: "San Blas",
NBN: "San Antonio de PalŽ",
NBO: "Nairobi",
NBS: "Baishan",
NBW: "Guantanamo Bay Naval Station",
NBX: "Nabire",
NCA: "North Caicos",
NCE: "Nice, Alpes-Maritimes",
NCG: "Nuevo Casas Grandes",
NCH: "Nachingwea",
NCI: "Necocli",
NCJ: "Sunchales",
NCL: "Newcastle upon Tyne, Tyne and Wear",
NCN: "Chenega",
NCO: "North Kingstown",
NCR: "San Carlos",
NCS: "Newcastle",
NCT: "Nicoya/Guanacate",
NCU: "Nukus",
NCY: "Epagny Metz-Tessy",
NDA: "Bandanaira",
NDB: "Nouadhibou",
NDC: "Nanded",
NDD: "Sumbe",
NDE: "Mandera",
NDF: "N'dalatando",
NDG: "Qiqihar",
NDI: "Namudi",
NDJ: "N'Djamena",
NDK: "Namorik Atoll",
NDL: "N'DŽlŽ",
NDM: "Mendi",
NDN: "Nadunumu",
NDR: "Al Aaroui",
NDS: "Sandstone",
NDU: "Rundu",
NDY: "Sanday",
NEC: "Necochea",
NEG: "Negril",
NEI: "Terney",
NEJ: "Nejo",
NEK: "Nekemte",
NEL: "Lakehurst",
NEN: "Jacksonville",
NER: "Neryungri",
NEV: "Charlestown",
NEW: "New Orleans",
NFG: "Nefteyugansk",
NFL: "Fallon",
NFO: "Angaha, Niuafo'ou Island",
NFR: "Nafurah 1",
NGB: "Ningbo",
NGD: "Anegada",
NGE: "N'GaoundŽrŽ",
NGF: "Kaneohe",
NGI: "Ngau",
NGK: "Nogliki",
NGL: "Ngala",
NGO: "Tokoname",
NGP: "Corpus Christi",
NGQ: "Shiquanhe",
NGS: "Nagasaki",
NGU: "Norfolk",
NGW: "Corpus Christi",
NGX: "Ngawal",
NHD: "Dubai",
NHF: "New Halfa",
NHK: "Patuxent River",
NHT: "London",
NHV: "Nuku Hiva",
NHX: "Foley",
NHZ: "Brunswick",
NIA: "Nimba",
NIB: "Nikolai",
NIG: "Nikunau",
NIK: "Niokolo-Koba National Park",
NIM: "Niamey",
NIN: "Ninilchik",
NIO: "Nioki",
NIP: "Jacksonville",
NIQ: "Niaqornat",
NIR: "Beeville",
NIS: "Simberi Island",
NIT: "Niort/SouchŽ",
NIU: "Naiu Atoll",
NIX: "Nioro du Sahel",
NJA: "Ayase / Yamato",
NJC: "Nizhnevartovsk",
NJF: "Najaf",
NJJ: "Heihe",
NJK: "El Centro",
NKA: "Ntoum",
NKC: "Nouakchott",
NKD: "Sinak",
NKG: "Nanjing",
NKI: "Tuxekan Island",
NKL: "N'Kolo-Fuma",
NKM: "Nagoya",
NKN: "Gwarawon",
NKO: "Ankokoambo",
NKP: "Nukutepipi",
NKT: "?õrnak",
NKU: "Nkaus",
NKW: "Diego Garcia",
NKX: "San Diego",
NKY: "Nkayi",
NLA: "Ndola",
NLC: "Lemoore",
NLD: "Nuevo Laredo",
NLE: "Niles",
NLF: "Darnley Island",
NLG: "Nelson Lagoon",
NLH: "Ninglang",
NLI: "Nikolayevsk-na-Amure Airport",
NLK: "Burnt Pine",
NLN: "Kneeland",
NLO: "N'dolo",
NLP: "Nelspruit",
NLT: "Xinyuan",
NLU: "Mexico City",
NLV: "Nikolayev",
NMA: "Namangan",
NMB: "Daman",
NMC: "Normans Cay",
NME: "Nightmute",
NMF: "Noonu Atoll",
NMG: "Isla del Rey",
NMI: "Navi Mumbai",
NML: "Fort McMurray",
NMN: "Namane",
NMP: "Basalt",
NMS: "Namsang",
NMT: "Namtu",
NNA: "Kenitra",
NNB: "Santa Ana Island",
NND: "Nangade",
NNG: "Nanning (Jiangnan)",
NNI: "Namutoni",
NNK: "Naknek",
NNL: "Nondalton",
NNM: "Naryan Mar",
NNR: "Inverin",
NNU: "Nanuque",
NNX: "Nunukan-Nunukan Island",
NNY: "Nanyang (Wancheng)",
NOA: "Nowra Hill",
NOB: "Nicoya",
NOC: "Charlestown",
NOD: "Norddeich",
NOG: "Nogales",
NOI: "Krymsk",
NOJ: "Noyabrsk",
NOK: "Nova Xavantina",
NOM: "Nomad River",
NON: "Nonouti",
NOO: "Naoro Vilage",
NOP: "Sinop",
NOR: "Nor?fjšr?ur",
NOS: "Nosy Be",
NOT: "Novato",
NOU: "NoumŽa (La Tontouta)",
NOV: "Huambo",
NOZ: "Novokuznetsk",
NPA: "Pensacola",
NPE: "Napier",
NPG: "Nipa",
NPH: "Nephi",
NPL: "New Plymouth",
NPO: "Nanga Pinoh-Borneo Island",
NPP: "Napperby",
NPR: "Novo Progresso",
NPT: "Newport",
NPU: "San Pedro de Urab‡",
NPY: "Mpanda",
NQA: "Millington",
NQI: "Kingsville",
NQL: "Niquel‰ndia",
NQN: "Neuquen",
NQT: "Nottingham",
NQU: "Nuqu’",
NQX: "Key West",
NQY: "Newquay",
NQZ: "Astana",
NRA: "Narrandera",
NRB: "Jacksonville",
NRD: "Norderney",
NRE: "Namrole",
NRG: "Narrogin",
NRI: "Afton",
NRK: "Norrkšping",
NRL: "North Ronaldsay",
NRM: "Nara",
NRN: "Weeze",
NRR: "Ceiba",
NRS: "Imperial Beach",
NRT: "Narita",
NRY: "Newry",
NSB: "Bimini",
NSE: "Milton",
NSH: "Nowshahr",
NSI: "YaoundŽ",
NSK: "Norilsk",
NSL: "Slayton",
NSM: "Norseman",
NSN: "Nelson",
NSQ: "Nuussuaq",
NSR: "S‹o Raimundo Nonato",
NST: "Nakhon Si Thammarat",
NSY: "Sigonella (CT)",
NTB: "Notodden",
NTC: "Santa Carolina",
NTD: "Point Mugu",
NTE: "Nantes",
NTG: "Nantong (Tongzhou)",
NTI: "Bintuni",
NTJ: "Manti",
NTL: "Williamtown",
NTN: "Normanton",
NTO: "Ponta do Sol",
NTQ: "Wajima",
NTR: "Monterrey",
NTT: "Niuatoputapu",
NTU: "Virginia Beach",
NTX: "Ranai-Natuna Besar Island",
NTY: "Pilanesberg",
NUA: "Nuwara Eliya",
NUD: "En Nahud",
NUE: "Nuremberg",
NUF: "Hatton",
NUG: "Nuguria Island",
NUH: "Nunchia",
NUI: "Nuiqsut",
NUJ: "Amirabad",
NUK: "Nukutavake",
NUL: "Nulato",
NUM: "Sharma",
NUP: "Nunapitchuk",
NUQ: "Mountain View",
NUS: "Norsup",
NUU: "Nakuru",
NUW: "Oak Harbor",
NUX: "Novy Urengoy",
NVA: "Neiva",
NVD: "Nevada",
NVI: "Navoi",
NVM: "Nova Mutum",
NVN: "Beckwourth",
NVP: "Novo Aripuan‹",
NVS: "Marzy, Nivre",
NVT: "Navegantes",
NVY: "Neyveli",
NWA: "Fomboni",
NWH: "Newport",
NWI: "Norwich, Norfolk",
NWT: "Nowata",
NYA: "Nyagan",
NYE: "Nyeri",
NYG: "Quantico",
NYI: "Sunyani",
NYK: "Nanyuki",
NYM: "Nadym",
NYO: "Nykšping",
NYR: "Nyurba",
NYS: "New York",
NYT: "Pyinmana",
NYU: "Nyaung U",
NYW: "Monywar",
NZA: "Nzagi",
NZC: "Nazca",
NZE: "NzŽrŽkorŽ",
NZG: "Nizhneangarsk",
NZH: "Manzhouli",
NZL: "Zhalantun",
NZY: "San Diego",
OAA: "Baraki Barak",
OAG: "Orange",
OAH: "Shindand",
OAI: "Bagram",
OAJ: "Richlands",
OAK: "Oakland",
OAL: "Cacoal",
OAN: "Olanchito",
OAR: "Marina",
OAS: "Sharana",
OAX: "Oaxaca",
OAZ: "Lashkar Gah",
OBC: "Obock",
OBD: "Obano",
OBE: "Okeechobee",
OBF: "We§ling",
OBI: "îbidos",
OBL: "Zoersel",
OBM: "Morobe",
OBN: "North Connel",
OBO: "Obihiro",
OBS: "Lanas, Ardche",
OBU: "Kobuk",
OBX: "Obo",
OBY: "Ittoqqortoormiit",
OCA: "Key Largo",
OCC: "Coca",
OCE: "Ocean City",
OCF: "Ocala",
OCH: "Nacogdoches",
OCJ: "Boscobel",
OCN: "Oceanside",
OCS: "Corisco Island",
OCV: "Oca–a",
OCW: "Washington",
ODA: "Ouadda",
ODB: "C—rdoba",
ODC: "Oakdale",
ODE: "Odense",
ODH: "Hook, Hampshire",
ODJ: "Ouanda DjallŽ",
ODL: "Cordillo Downs",
ODM: "Accident",
ODN: "Long Seridan",
ODO: "Bodaybo",
ODR: "Ord River",
ODS: "Odessa",
ODT: "Odessa",
ODW: "Oak Harbor",
ODY: "Oudomsay",
OEA: "Lawrenceville",
OEC: "Oecussi-Ambeno",
OEM: "Paloemeu",
OEO: "Osceola",
OER: "…rnskšldsvik",
OES: "San Antonio Oeste",
OFF: "Omaha",
OFI: "Ouango Fitini",
OFJ: "îlafsfjšr?ur",
OFK: "Norfolk",
OFU: "Ofu",
OGA: "Ogallala",
OGB: "Orangeburg",
OGD: "Ogden",
OGG: "Kahului",
OGL: "Ogle",
OGM: "Ustupu",
OGN: "Yonaguni",
OGO: "Abengourou",
OGR: "Bongor",
OGS: "Ogdensburg",
OGU: "Ordu",
OGV: "Ombika",
OGX: "Ouargla",
OGZ: "Beslan",
OHB: "Moramanga",
OHD: "Ohrid",
OHE: "Mohe",
OHH: "Okha",
OHI: "Oshakati",
OHO: "Okhotsk",
OHR: "Wyk auf Fšhr",
OHS: "Sohar",
OHT: "Kohat",
OIA: "Ouril‰ndia do Norte",
OIC: "Norwich",
OIM: "Izu Oshima",
OIR: "Okushiri Island",
OIT: "Oita",
OJC: "Olathe",
OJU: "Tojo Una-Una",
OKA: "Naha",
OKB: "Orchid Beach",
OKC: "Oklahoma City",
OKD: "Sapporo",
OKE: "Wadomari",
OKF: "Okaukuejo",
OKG: "Okoyo",
OKI: "Okinoshima",
OKJ: "Okayama",
OKK: "Kokomo",
OKL: "Oksibil",
OKM: "Okmulgee",
OKN: "Okondja",
OKO: "Fussa",
OKP: "Oksapmin",
OKQ: "Okaba",
OKR: "Yorke Island",
OKS: "Oshkosh",
OKT: "Kzyl-Yar",
OKU: "Mokuti Lodge",
OKV: "Okao",
OLA: "¯rland",
OLB: "Olbia (SS)",
OLC: "S‹o Paulo De Olivena",
OLD: "Old Town",
OLE: "Olean",
OLF: "Wolf Point",
OLH: "Old Harbor",
OLI: "Rif",
OLJ: "Olpoi",
OLK: "Fuerte Olimpo",
OLL: "Oyo",
OLM: "Olympia",
OLN: "Sarmiento",
OLO: "Olomouc",
OLP: "Olympic Dam",
OLQ: "Olsobip",
OLR: "Khost",
OLS: "Nogales",
OLU: "Columbus",
OLV: "Olive Branch",
OLX: "Olkiombo",
OLY: "Olney-Noble",
OLZ: "Olyokminsk",
OMA: "Omaha",
OMB: "Omboue",
OMC: "Ormoc City",
OMD: "Oranjemund",
OME: "Nome",
OMF: "Mafraq",
OMG: "Omega",
OMH: "Urmia",
OMI: "Omidiyeh",
OMJ: "Nagasaki",
OMK: "Omak",
OMM: "Marmul",
OMN: "Osmanabad",
OMO: "Mostar",
OMR: "Oradea",
OMS: "Omsk",
OMY: "Tbeng Meanchey",
ONA: "Winona",
ONB: "Onange Mission",
OND: "Ondangwa",
ONH: "Oneonta",
ONI: "Moanamani",
ONJ: "Kitaakita",
ONK: "Olenyok",
ONL: "O'Neill",
ONM: "Socorro",
ONO: "Oregon",
ONP: "Newport",
ONQ: "Zonguldak",
ONT: "Ontario",
ONU: "Ono-i-Lau",
ONX: "Col—n",
ONY: "Olney",
OOA: "Cedar",
OOD: "Koodaideri Mine",
OOK: "Toksook Bay",
OOL: "Gold Coast",
OOM: "Cooma",
OOT: "Onotoa",
OPA: "K—pasker",
OPB: "Maitanakunai",
OPF: "Miami",
OPL: "Opelousas",
OPO: "Porto",
OPP: "Salin—polis",
OPS: "Sinop",
OPU: "Balimo",
OPW: "Opuwa",
OQN: "Kokand",
ORA: "Or‡n",
ORB: "…rebro",
ORC: "Orocue",
ORD: "Chicago",
ORE: "Saint-Denis-de-l'H™tel, Loiret",
ORF: "Norfolk",
ORG: "Paramaribo",
ORH: "Worcester",
ORI: "Port Lions",
ORJ: "Orinduik",
ORK: "Cork",
ORL: "Orlando",
ORM: "Northampton, Northamptonshire",
ORN: "Es-SŽnia",
ORO: "Yoro",
ORP: "Orapa",
ORT: "Northway",
ORU: "Oruro",
ORV: "Noorvik",
ORW: "Ormara Raik",
ORX: "Oriximin‡",
ORY: "Paris (Orly, Val-de-Marne)",
ORZ: "Orange Walk",
OSB: "Osage Beach",
OSC: "Oscoda",
OSD: "…stersund",
OSE: "Omora",
OSF: "Moscow",
OSG: "Ossima",
OSH: "Oshkosh",
OSI: "Klisa",
OSK: "Oskarshamn",
OSL: "Oslo (Gardermoen)",
OSM: "Mosul",
OSN: "Pyeongtaek",
OSR: "Mo?nov",
OSS: "Osh",
OST: "Oostende",
OSU: "Columbus",
OSW: "Orsk",
OSX: "Kosciusko",
OSY: "Namsos",
OTC: "Bol",
OTD: "Contadora Island",
OTG: "Worthington",
OTH: "North Bend",
OTI: "Gotalalamo-Morotai Island",
OTJ: "Otjiwarongo",
OTK: "Tillamook",
OTL: "Boutilimit",
OTM: "Ottumwa",
OTN: "Oaktown",
OTO: "Wulan",
OTP: "Otopeni",
OTQ: "Otog Front Banner",
OTR: "Corredores",
OTS: "Anacortes",
OTT: "Cotriguau",
OTU: "Remedios",
OTZ: "Kotzebue",
OUA: "Ouagadougou",
OUD: "Ahl Angad",
OUG: "Ouahigouya",
OUH: "Oudtshoorn",
OUI: "Ushant",
OUK: "Grunay Island",
OUL: "Oulu / Oulunsalo",
OUM: "Oum Hadjer",
OUN: "Norman",
OUR: "Batouri",
OUS: "Ourinhos",
OUT: "Bousso",
OUZ: "ZouŽrate",
OVA: "Bekily",
OVB: "Novosibirsk",
OVD: "Ran—n",
OVE: "Oroville",
OVG: "Overberg",
OVL: "Ovalle",
OVR: "Olavarria",
OVS: "Sovetskiy",
OWA: "Owatonna",
OWB: "Owensboro",
OWD: "Norwood",
OWK: "Norridgewock",
OXB: "Bissau",
OXC: "Oxford",
OXD: "Oxford",
OXF: "Kidlington, Oxfordshire",
OXO: "Orientos",
OXR: "Oxnard",
OYA: "Goya",
OYC: "Camopi",
OYE: "Oyem",
OYG: "Moyo",
OYK: "Oiapoque",
OYL: "Moyale (Lower)",
OYN: "Ouyen",
OYO: "Tres Arroyos",
OYP: "Saint-Georges-de-l'Oyapock",
OZA: "Ozona",
OZC: "Ozamiz",
OZG: "Zagora",
OZH: "Zaporizhia",
OZP: "Mor—n",
OZR: "Fort Rucker/Ozark",
OZZ: "Ouarzazate",
PAA: "Hpa-N",
PAB: "Bilaspur",
PAC: "Albrook",
PAD: "BŸren",
PAE: "Everett",
PAF: "Pakuba",
PAG: "Pagadian",
PAH: "Paducah",
PAJ: "Parachinar",
PAK: "Hanapepe",
PAL: "La Dorada",
PAM: "Panama City",
PAO: "Palo Alto",
PAP: "Port-au-Prince",
PAQ: "Palmer",
PAS: "Paros",
PAT: "Patna",
PAU: "Pauk",
PAV: "Paulo Afonso",
PAX: "Port-de-Paix",
PAY: "Pamol",
PAZ: "Poza Rica",
PBA: "Cairu",
PBB: "Parana’ba",
PBC: "Puebla",
PBD: "Porbandar",
PBE: "Puerto Berrio",
PBF: "Pine Bluff",
PBG: "Plattsburgh",
PBH: "Paro",
PBI: "West Palm Beach",
PBJ: "Paama Island",
PBL: "Puerto Cabello",
PBM: "Zandery",
PBN: "Port Amboim",
PBO: "Paraburdoo",
PBP: "Nandayure",
PBQ: "Pimenta Bueno",
PBR: "Puerto Barrios",
PBT: "Puerto Leda",
PBU: "Putao",
PBX: "Porto Alegre do Norte",
PBZ: "Plettenberg Bay",
PCA: "Portage Creek",
PCB: "Jakarta",
PCC: "Puerto Rico",
PCD: "Prairie Du Chien",
PCF: "Potchefstroom",
PCG: "Paso Caballos",
PCH: "Palacios",
PCJ: "Puerto La Victoria",
PCL: "Pucallpa",
PCM: "Playa del Carmen",
PCN: "Koromiko",
PCO: "La Ribera",
PCP: "S‹o TomŽ & Pr’ncipe",
PCQ: "Phongsaly",
PCR: "Puerto Carre–o",
PCS: "Picos",
PCT: "Princeton/Rocky Hill",
PCU: "Poplarville",
PCV: "MulegŽ",
PDA: "Puerto In’rida",
PDB: "Pedro Bay",
PDC: "NŽpoui",
PDD: "Ponta do Ouro",
PDF: "Prado",
PDG: "Padang (Katapiang)",
PDI: "Pindiu",
PDK: "Atlanta",
PDL: "Ponta Delgada",
PDM: "Pedas’",
PDN: "Kangaroo Island",
PDO: "Talang Gudang-Sumatra Island",
PDP: "Punta del Este",
PDR: "Presidente Dutra",
PDS: "Piedras Negras",
PDT: "Pendleton",
PDU: "Paysandœ",
PDV: "Plovdiv",
PDX: "Portland",
PDZ: "Capure",
PEA: "Ironstone",
PEB: "Pebane",
PEC: "Pelican",
PED: "Pardubice",
PEE: "Perm",
PEF: "PeenemŸnde",
PEG: "Perugia (PG)",
PEH: "Pehuaj—",
PEI: "Pereira",
PEK: "Beijing",
PEL: "Pelaneng",
PEM: "Puerto Maldonado",
PEN: "Penang",
PEP: "Peppimenarti",
PEQ: "Pecos",
PER: "Perth",
PES: "Petrozavodsk",
PET: "Pelotas",
PEU: "Puerto Lempira",
PEV: "PŽcs",
PEW: "Peshawar",
PEX: "Pechora",
PEY: "Penong",
PEZ: "Penza",
PFA: "Harbin",
PFB: "Passo Fundo",
PFC: "Pacific City",
PFJ: "Patreksfjšr?ur",
PFM: "Primrose",
PFO: "Paphos",
PFQ: "Parsabad",
PFR: "Ilebo",
PGA: "Page",
PGB: "Pangoa",
PGC: "Petersburg",
PGD: "Punta Gorda",
PGF: "Perpignan/Rivesaltes",
PGH: "Pantnagar",
PGI: "Chitato",
PGK: "Pangkal Pinang",
PGL: "Pascagoula",
PGM: "Port Graham",
PGN: "Pangia",
PGO: "Pagosa Springs",
PGQ: "Pekaulang",
PGR: "Paragould",
PGS: "Peach Springs",
PGU: "Khiyaroo",
PGV: "Greenville",
PGX: "PŽrigueux/Bassillac",
PGZ: "Ponta Grossa",
PHA: "Phan Rang",
PHB: "Parna’ba",
PHC: "Port Harcourt",
PHD: "New Philadelphia",
PHE: "Port Hedland",
PHF: "Newport News",
PHG: "Port Harcourt",
PHH: "Pokhara",
PHI: "Pinheiro",
PHK: "Pahokee",
PHL: "Philadelphia",
PHN: "Port Huron",
PHO: "Point Hope",
PHP: "Philip",
PHQ: "Phosphate Hill",
PHR: "Nanuku Auberge Resort",
PHS: "Phitsanulok",
PHT: "Paris",
PHU: "Phu Giao",
PHW: "Phalaborwa",
PHX: "Phoenix",
PIA: "Peoria",
PIB: "Moselle",
PIC: "Pine Cay",
PIE: "Pinellas Park",
PIF: "Pingtung",
PIH: "Pocatello",
PIK: "Prestwick, South Ayrshire",
PIL: "Pilar",
PIM: "Pine Mountain",
PIN: "Parintins",
PIO: "Pisco",
PIP: "Pilot Point",
PIQ: "Pipillipai",
PIR: "Pierre",
PIS: "Poitiers/Biard",
PIT: "Pittsburgh",
PIU: "Piura",
PIV: "Pirapora",
PIW: "Pikwitonei",
PIX: "Pico Island",
PIZ: "Point Lay",
PJA: "Pajala",
PJB: "Payson",
PJC: "Pedro Juan Caballero",
PJG: "Panjgur",
PJM: "Puerto Jimenez",
PKA: "Napaskiak",
PKB: "Parkersburg (Williamstown)",
PKC: "Petropavlovsk-Kamchatsky",
PKD: "Park Rapids",
PKE: "Parkes",
PKF: "Park Falls",
PKG: "Pangkor Island",
PKJ: "Playa Grande",
PKK: "Pakhokku",
PKM: "Port Kaituma",
PKN: "Pangkalanbun",
PKO: "Parakou",
PKR: "Pokhara",
PKT: "Wadeye",
PKU: "Pekanbaru",
PKV: "Pskov",
PKW: "Selebi Phikwe",
PKX: "Beijing",
PKY: "Palangkaraya",
PKZ: "Pakse",
PLA: "Planadas",
PLD: "Carrillo",
PLE: "Paiela",
PLF: "Pala",
PLJ: "Placencia",
PLK: "Branson / Hollister",
PLL: "Manaus",
PLM: "Palembang",
PLN: "Pellston",
PLO: "Port Lincoln",
PLQ: "Palanga",
PLR: "Pell City",
PLS: "Providenciales",
PLT: "Plato",
PLU: "Belo Horizonte",
PLV: "Poltava",
PLW: "Palu",
PLX: "Semey",
PLY: "Plymouth",
PLZ: "Gqeberha (Port Elizabeth)",
PMA: "Chake Chake",
PMB: "Pembina",
PMC: "Puerto Montt",
PMD: "Palmdale",
PMF: "Parma (PR)",
PMG: "Ponta Por‹",
PMH: "Portsmouth",
PMI: "Palma de Mallorca",
PML: "Cold Bay",
PMN: "Pumani",
PMO: "Palermo",
PMP: "Pimaga",
PMQ: "Perito Moreno",
PMR: "Palmerston North",
PMS: "Tadmur",
PMT: "Paramakatoi",
PMV: "Isla Margarita",
PMW: "Palmas",
PMY: "Puerto Madryn",
PMZ: "Palmar Sur",
PNA: "Pamplona",
PNB: "Porto Nacional",
PNC: "Ponca City",
PND: "Punta Gorda",
PNE: "Philadelphia",
PNG: "Paranagu‡",
PNH: "Phnom Penh (Pou Senchey)",
PNI: "Pohnpei Island",
PNJ: "Yantai",
PNK: "Pontianak",
PNL: "Pantelleria (TP)",
PNN: "Princeton",
PNP: "Popondetta",
PNQ: "Pune",
PNR: "Pointe Noire",
PNS: "Pensacola",
PNT: "Puerto Natales",
PNU: "Panguitch",
PNV: "Panev??ys",
PNX: "Denison",
PNY: "Puducherry (Pondicherry)",
PNZ: "Petrolina",
POA: "Porto Alegre",
POB: "Fort Bragg",
POC: "La Verne",
POD: "Podor",
POE: "Fort Polk",
POF: "Poplar Bluff",
POG: "Port Gentil",
POH: "Pocahontas",
POI: "Potos’",
POJ: "Patos de Minas",
POL: "Pemba",
POM: "Port Moresby",
PON: "Poptœn",
POO: "Poos De Caldas",
POP: "Puerto Plata",
POR: "Pori",
POS: "Port of Spain",
POT: "Ken Jones",
POU: "Poughkeepsie",
POV: "Pre?ov",
POW: "Se?ovlje",
POX: "Cormeilles-en-Vexin, Val-d'Oise",
POY: "Powell",
POZ: "Pozna?",
PPA: "Pampa",
PPB: "Presidente Prudente",
PPC: "Prospect Creek",
PPE: "Puerto Pe–asco",
PPF: "Parsons",
PPG: "Pago Pago",
PPH: "Parai-tepu’",
PPJ: "Jakarta",
PPK: "Petropavl",
PPL: "Phaplu",
PPM: "Pompano Beach",
PPN: "Popay‡n",
PPP: "Proserpine",
PPR: "Pasir Pengarayan",
PPS: "Puerto Princesa",
PPT: "Papeete",
PPU: "Pa Pun",
PPV: "Port Protection",
PPW: "Papa Westray",
PPX: "Nepesi",
PPY: "Pouso Alegre",
PPZ: "Puerto Paez",
PQC: "Phu Quoc Island",
PQD: "Batticaloa",
PQI: "Presque Isle",
PQM: "Palenque",
PQQ: "Port Macquarie",
PQS: "Pilot Station",
PQT: "Qeqertaq",
PRA: "Parana",
PRB: "Paso Robles",
PRC: "Prescott",
PRD: "Pardoo",
PRE: "Pore",
PRG: "Prague",
PRI: "Praslin Island",
PRK: "Prieska",
PRM: "Portim‹o",
PRN: "Prishtina",
PRO: "Perry",
PRP: "Propriano",
PRQ: "Presidencia Roque S‡enz Pe–a",
PRR: "Paruima",
PRS: "Parasi",
PRU: "Pye",
PRV: "P?erov",
PRW: "Prentice",
PRX: "Paris",
PRY: "Pretoria",
PRZ: "Prineville",
PSA: "Pisa (PI)",
PSB: "Philipsburg",
PSC: "Pasco",
PSD: "Port Said",
PSE: "Ponce",
PSF: "Pittsfield",
PSG: "Petersburg",
PSH: "Sankt Peter-Ording",
PSI: "Pasni",
PSJ: "Poso-Celebes Island",
PSK: "Dublin",
PSL: "Perth",
PSM: "Portsmouth",
PSN: "Palestine",
PSO: "ChachagŸ’",
PSP: "Palm Springs",
PSQ: "Essington",
PSR: "Pescara",
PSS: "Posadas",
PSU: "Putussibau-Borneo Island",
PSV: "Papa Stour Island",
PSW: "Passos",
PSX: "Palacios",
PSY: "Stanley",
PSZ: "Puerto Su‡rez",
PTA: "Port Alsworth",
PTB: "Petersburg",
PTC: "Port Alice",
PTD: "Port Alexander",
PTF: "Malolo Lailai Island",
PTG: "Polokwane",
PTH: "Port Heiden",
PTK: "Pontiac",
PTL: "M‡ncora",
PTM: "Palmarito",
PTN: "Patterson",
PTO: "Pato Branco",
PTP: "Pointe-ˆ-Pitre",
PTQ: "Porto De Moz",
PTS: "Pittsburg",
PTT: "Pratt",
PTU: "Platinum",
PTV: "Porterville",
PTW: "Pottstown",
PTX: "Pitalito",
PTY: "Tocumen",
PTZ: "Shell Mera",
PUA: "Puas Mission",
PUB: "Pueblo",
PUC: "Price",
PUD: "Puerto Deseado",
PUE: "Puerto Obald’a",
PUF: "Pau/PyrŽnŽes (Uzein)",
PUJ: "Punta Cana",
PUK: "Pukaruha",
PUL: "Poulsbo",
PUN: "Punia",
PUP: "Po",
PUQ: "Punta Arenas",
PUR: "Puerto Rico/Manuripi",
PUS: "Busan",
PUT: "Puttaparthi",
PUU: "Puerto As’s",
PUV: "Malabou",
PUW: "Pullman",
PUX: "Puerto Varas",
PUY: "Pula",
PUZ: "Puerto Cabezas",
PVA: "Providencia",
PVC: "Provincetown",
PVD: "Warwick",
PVE: "El Porvenir",
PVF: "Placerville",
PVG: "Shanghai (Pudong)",
PVH: "Porto Velho",
PVI: "Paranava’",
PVK: "Preveza",
PVL: "Pikeville",
PVO: "Portoviejo",
PVR: "Puerto Vallarta",
PVS: "Chukotka",
PVU: "Provo",
PVW: "Plainview",
PWA: "Oklahoma City",
PWD: "Plentywood",
PWE: "Apapelgino",
PWI: "Pawe",
PWK: "Chicago/Prospect Heights/Wheeling",
PWL: "Purwokerto-Java Island",
PWM: "Portland",
PWN: "Pitts Town",
PWO: "Pweto",
PWQ: "Pavlodar",
PWR: "Port Walter",
PWT: "Bremerton",
PWY: "Pinedale",
PXA: "Bentayan",
PXH: "Mount Eba",
PXL: "Polacca",
PXM: "Puerto Escondido",
PXO: "Vila Baleira",
PXR: "Surin",
PXU: "Pleiku",
PYA: "Puerto Boyac‡",
PYB: "Jeypore",
PYC: "Ukupseni",
PYE: "Penrhyn Island",
PYG: "Pakyong",
PYH: "Puerto Ayacucho",
PYJ: "Yakutia",
PYK: "Karaj",
PYL: "Perry Island",
PYM: "Plymouth",
PYN: "Pay‡n",
PYO: "Puerto Putumayo",
PYR: "Andravida",
PYS: "Paradise",
PYT: "Paracatu",
PYV: "Yaviza",
PYY: "Pai",
PZA: "Paz De Ariporo",
PZB: "Pietermaritzburg",
PZE: "Penzance, Cornwall",
PZH: "Fort Sandeman",
PZI: "Panzhihua (Renhe)",
PZK: "Pukapuka Atoll",
PZL: "Phinda",
PZO: "Puerto Ordaz-Ciudad Guayana",
PZR: "Bajo Baud—",
PZS: "Temuco",
PZU: "Port Sudan",
PZY: "Pie??any",
QAQ: "L'Aquila",
QBC: "Bella Coola",
QCH: "Colatina",
QCP: "Currais Novos",
QCU: "Akunnaaq",
QCY: "Lincoln, Lincolnshire",
QDB: "Cachoeira Do Sul",
QDJ: "Djelfa",
QDV: "Jundia’",
QDY: "Taean",
QFG: "Eqalugaarsuit",
QFI: "Iginniarfik",
QFN: "Narsarmijit",
QFX: "Igaliku",
QGF: "Montenegro",
QGP: "Garanhuns",
QGQ: "Attu",
QGU: "Gifu",
QHN: "Taguatinga",
QHR: "Debre Zeyit",
QHU: "Husum",
QHV: "Novo Hamburgo",
QIG: "Iguatu",
QIT: "Itapetinga",
QJB: "Jubail",
QJE: "Kitsissuarsuit",
QJH: "Qassimiut",
QJI: "Ikamiut",
QJP: "Pocheon",
QLD: "Blida",
QMH: "Oum El Bouaghi",
QMJ: "Masjed Soleyman",
QNS: "Porto Alegre",
QOQ: "Saarloq",
QOW: "Owerri",
QPG: "Paya Lebar",
QPH: "Palapye",
QPS: "Pirassununga",
QPW: "Kangaatsiaq",
QRA: "Johannesburg",
QRF: "Bragado",
QRO: "QuerŽtaro",
QRW: "Okpe",
QRY: "Ikerassaarsuk",
QSC: "S‹o Carlos",
QSF: "SŽtif",
QSI: "Moshi",
QSR: "Salerno",
QSX: "New Amsterdam",
QSZ: "Shache",
QUB: "Ubari",
QUG: "Chichester, West Sussex",
QUO: "Uyo",
QUS: "Gusau",
QUV: "Aappilattoq",
QUW: "Ammassivik",
RAA: "Rakanda",
RAB: "Kokopo",
RAC: "Racine",
RAD: "Tortola",
RAE: "Arar",
RAF: "Rafaela",
RAG: "Raglan",
RAH: "Rafha",
RAI: "Praia",
RAJ: "Rajkot",
RAK: "Marrakech",
RAL: "Riverside",
RAN: "Ravenna (RA)",
RAO: "Ribeir‹o Preto",
RAP: "Rapid City",
RAQ: "Raha",
RAR: "Avarua",
RAS: "Rasht",
RAV: "Cravo Norte",
RAW: "Arawa",
RAZ: "Rawalakot",
RBA: "Rabat",
RBB: "Borba",
RBC: "Robinvale",
RBD: "Dallas",
RBE: "Ratanakiri",
RBF: "Big Bear",
RBG: "Roseburg",
RBI: "Rabi Island",
RBJ: "Rebun",
RBK: "Murrieta",
RBL: "Red Bluff",
RBM: "Atting",
RBO: "RoborŽ",
RBP: "Rabaraba",
RBQ: "Rurrenabaque",
RBR: "Rio Branco",
RBT: "Marsabit",
RBU: "Roebourne",
RBV: "Ramata",
RBW: "Walterboro",
RBX: "Rumbek",
RBY: "Ruby",
RBZ: "Shahrisabz",
RCA: "Rapid City",
RCB: "Richards Bay",
RCE: "Roche Harbor",
RCH: "Riohacha",
RCK: "Rockdale",
RCL: "Redcliffe",
RCO: "Rochefort/Saint-Agnant",
RCQ: "Reconquista",
RCR: "Rochester",
RCS: "Rochester, Kent",
RCT: "Reed City",
RCU: "Rio Cuarto",
RCY: "Port Nelson",
RDA: "Rockhampton Downs",
RDB: "Red Dog",
RDC: "Reden‹o",
RDD: "Redding",
RDE: "Merdei-Papua Island",
RDG: "Reading",
RDL: "El Hassana",
RDM: "Redmond",
RDN: "Redang",
RDO: "Radom",
RDP: "Durgapur",
RDR: "Grand Forks",
RDS: "Rincon de los Sauces",
RDT: "Richard Toll",
RDU: "Raleigh/Durham",
RDV: "Red Devil",
RDZ: "Rodez/Marcillac",
REA: "Reao",
REB: "LŠrz",
REC: "Recife",
RED: "Reedsville",
REE: "Lubbock",
REG: "Reggio Calabria",
REI: "RŽgina",
REL: "Rawson",
REN: "Orenburg",
REO: "Rome",
REQ: "Chagai",
RER: "Retalhuleu",
RES: "Resistencia",
RET: "R¿st",
REU: "Reus",
REW: "Rewa",
REX: "Reynosa",
REY: "Reyes",
REZ: "Resende",
RFA: "Rafa•",
RFD: "Chicago/Rockford",
RFG: "Refugio",
RFK: "Rolling Fork",
RFN: "Raufarhšfn",
RFP: "Uturoa",
RFR: "Rio Frio / Progreso",
RFS: "La Rosita",
RGA: "Rio Grande",
RGH: "Balurghat",
RGK: "Gorno-Altaysk",
RGL: "Rio Gallegos",
RGN: "Yangon",
RGO: "Hoemun-ri",
RGR: "Ranger",
RGS: "Burgos",
RGT: "Rengat-Sumatra Island",
RHA: "Reykh—lar",
RHD: "Termas de R’o Hondo",
RHG: "Ruhengeri",
RHI: "Rhinelander",
RHN: "Rosh Pinah",
RHO: "Rhodes",
RHP: "Ramechhap",
RHT: "Badanjilin",
RHV: "San Jose",
RIA: "Santa Maria",
RIB: "Riberalta",
RIC: "Richmond",
RID: "Richmond",
RIE: "Rice Lake",
RIF: "Richfield",
RIG: "Rio Grande",
RIH: "R’o Hato",
RIJ: "Rioja",
RIL: "Rifle",
RIM: "Rodriguez de Mendoza",
RIN: "Ringi Cove",
RIR: "Riverside",
RIS: "Rishiri",
RIV: "Riverside",
RIW: "Riverton",
RIX: "Riga",
RIY: "Riyan",
RIZ: "Rizhao (Donggang)",
RJA: "Madhurapudi",
RJB: "Rajbiraj",
RJH: "Rajshahi",
RJI: "Rajouri",
RJK: "Omi?alj",
RJL: "Logro–o",
RJM: "Waisai",
RJN: "Rafsanjan",
RKD: "Rockland",
RKE: "Roskilde",
RKH: "Rock Hill",
RKI: "Sipura Island",
RKP: "Rockport",
RKR: "Poteau",
RKS: "Rock Springs",
RKT: "Ras Al Khaimah",
RKU: "Yule Island",
RKV: "Reykjav’k",
RKW: "Rockwood",
RKY: "Rokeby",
RKZ: "Xigaz (Samzhubz)",
RLA: "Rolla",
RLD: "Richland",
RLG: "Laage",
RLK: "Bavannur",
RLO: "Merlo",
RLP: "Rosella Plains",
RLR: "Isalo",
RLT: "Arlit",
RMA: "Roma",
RMB: "Buraimi",
RMD: "Ramagundam",
RME: "Rome",
RMF: "Marsa Alam",
RMG: "Rome",
RMI: "Rimini (RN)",
RML: "Colombo",
RMO: "Chi?in?u",
RMP: "Rampart",
RMQ: "Taichung (Qingshui)",
RMS: "Ramstein-Miesenbach",
RMT: "Rimatara Island",
RMU: "Corvera",
RMY: "Mariposa",
RMZ: "Tobolsk",
RNA: "Arona",
RNB: "Ronneby",
RNC: "Mc Minnville",
RND: "Universal City",
RNE: "Saint-LŽger-sur-Roanne",
RNH: "New Richmond",
RNI: "Corn Island",
RNJ: "Yoron",
RNL: "Rennell Island",
RNM: "Ghaba",
RNN: "R¿nne",
RNO: "Reno",
RNP: "Rongelap Island",
RNS: "Saint-Jacques-de-la-Lande, Ille-et-Vilaine",
RNT: "Renton",
RNU: "Ranau",
RNZ: "Rensselaer",
ROA: "Roanoke",
ROB: "Monrovia",
ROC: "Rochester",
ROD: "Robertson",
ROF: "Montague",
ROG: "Rogers",
ROI: "Roi Et",
ROK: "Rockhampton",
ROL: "Roosevelt",
RON: "Paipa",
ROO: "Rondon—polis",
ROP: "Rota Island",
ROR: "Babelthuap Island",
ROS: "Rosario",
ROT: "Rotorua",
ROU: "Shtraklevo",
ROV: "Rostov-on-Don",
ROW: "Roswell",
ROX: "Roseau",
ROY: "Rio Mayo",
ROZ: "Rota",
RPA: "Rolpa",
RPB: "Roper Bar",
RPN: "Rosh Pina",
RPR: "Raipur",
RPU: "Urucu",
RPV: "Roper Valley",
RPX: "Roundup",
RQA: "Ruoqiang Town",
RQO: "El Reno",
RQW: "Qayyarah",
RQY: "Shimoga",
RRG: "Port Mathurin",
RRJ: "Rio De Janeiro",
RRK: "Rourkela",
RRL: "Merrill",
RRM: "Marromeu",
RRR: "Raroia",
RRS: "R¿ros",
RRT: "Warroad",
RSA: "Santa Rosa",
RSD: "Rock Sound",
RSE: "Sydney",
RSH: "Russian Mission",
RSI: "Hanak",
RSJ: "Rosario",
RSK: "Ransiki-Papua Island",
RSL: "Russell",
RSN: "Ruston",
RSS: "Ad Damazin",
RST: "Rochester",
RSU: "Yeosu",
RSW: "Fort Myers",
RSX: "Rouses Point",
RTA: "Rotuma",
RTB: "Coxen Hole",
RTE: "S‹o Paulo",
RTG: "Satar Tacik, Manggarai",
RTI: "Ba'a - Rote Island",
RTL: "Okoboji",
RTM: "Rotterdam",
RTN: "Raton",
RTO: "Tangerang-Java Island",
RTP: "Yagoonya",
RTU: "Maratua",
RUA: "Arua",
RUD: "Shahrud",
RUE: "Butembo",
RUG: "Rugao (Nantong)",
RUH: "Riyadh",
RUI: "Alto",
RUK: "Rukumkot",
RUL: "Maavaarulu",
RUM: "Rumjatar",
RUN: "Sainte-Marie",
RUP: "Rupsi",
RUS: "Marau",
RUT: "Rutland",
RUU: "Kawbenaberi",
RUV: "Rubelsanto",
RUY: "Cop‡n Ruinas",
RVA: "Farafangana",
RVC: "River Cess",
RVD: "Rio Verde",
RVE: "Saravena",
RVK: "R¿rvik",
RVN: "Rovaniemi",
RVO: "Reivilo",
RVR: "Green River",
RVS: "Tulsa",
RVY: "Rivera",
RWF: "Redwood Falls",
RWI: "Rocky Mount",
RWL: "Rawlins",
RWN: "Rivne",
RXA: "Ar Rawdah",
RXE: "Rexburg",
RXS: "Roxas City",
RYB: "Rybinsk",
RYG: "Oslo",
RYK: "Rahim Yar Khan",
RYL: "Lower Zambezi River",
RYN: "Royan/MŽdis",
RYO: "Rio Turbio",
RZA: "Puerto Santa Cruz",
RZE: "Jasionka",
RZH: "Preobrazheniye",
RZP: "Taytay",
RZR: "Ramsar",
RZS: "Sawan Gas Field",
RZV: "Rize",
SAA: "Saratoga",
SAB: "Zion's Hill",
SAC: "Sacramento",
SAD: "Safford",
SAE: "Saattut",
SAF: "Santa Fe",
SAG: "Kakadi",
SAH: "Sanaa",
SAI: "Siem Reap",
SAK: "Sau?‡rkr—kur",
SAL: "San Salvador (San Luis Talpa)",
SAM: "Salamo",
SAN: "San Diego",
SAP: "San Pedro Sula",
SAQ: "Andros Island",
SAR: "Sparta",
SAS: "Salton City",
SAT: "San Antonio",
SAU: "Sabu-Sawu Island",
SAV: "Savannah",
SAW: "Pendik, Istanbul",
SAX: "Boca de S‡balo",
SAY: "Ampugnano (SI)",
SAZ: "Sasstown",
SBA: "Santa Barbara",
SBB: "Santa B‡rbara",
SBC: "Selbang",
SBD: "San Bernardino",
SBF: "Sardeh Band",
SBG: "Sabang",
SBH: "Gustavia",
SBI: "Koundara",
SBJ: "S‹o Mateus",
SBK: "TrŽmuson, C™tes-d'Armor",
SBL: "Santa Ana del Yacuma",
SBM: "Sheboygan",
SBN: "South Bend",
SBO: "Salina",
SBP: "San Luis Obispo",
SBQ: "Sibi",
SBR: "Saibai Island",
SBS: "Steamboat Springs",
SBT: "Sabetta",
SBU: "Springbok",
SBV: "Sabah",
SBW: "Sibu",
SBX: "Shelby",
SBY: "Salisbury",
SBZ: "Sibiu",
SCA: "Santa Catalina",
SCB: "Scribner",
SCC: "Deadhorse",
SCD: "Sulaco",
SCE: "State College",
SCF: "Scottsdale",
SCH: "Schenectady",
SCI: "San Crist—bal",
SCK: "Stockton",
SCL: "Santiago",
SCM: "Scammon Bay",
SCN: "SaarbrŸcken",
SCO: "Aktau",
SCP: "Saint-CrŽpin, Hautes-Alpes",
SCQ: "Santiago de Compostela",
SCR: "Malung-SŠlen",
SCT: "Mori",
SCU: "Santiago",
SCV: "Suceava",
SCW: "Syktyvkar",
SCX: "Salina Cruz",
SCY: "Puerto Baquerizo Moreno",
SCZ: "Santa Cruz/Graciosa Bay/Luova",
SDB: "Langebaanweg",
SDC: "Sand Creek",
SDD: "Lubango",
SDE: "Santiago del Estero",
SDF: "Louisville",
SDI: "Saidor",
SDJ: "Natori",
SDK: "Sandakan",
SDL: "Sundsvall/ HŠrnšsand",
SDM: "San Diego",
SDN: "Sandane",
SDP: "Sand Point",
SDQ: "Santo Domingo",
SDR: "Santander",
SDS: "Sado",
SDT: "Saidu Sharif",
SDU: "Rio de Janeiro",
SDW: "Sindhudurg",
SDX: "Sedona",
SDY: "Sidney",
SEA: "Seattle",
SEB: "Sabha",
SEE: "San Diego/El Cajon",
SEF: "Sebring",
SEG: "Selinsgrove",
SEH: "Senggeh",
SEK: "Srednekolymsk",
SEM: "Selma",
SEN: "Southend-on-Sea, Essex",
SEO: "SŽguŽla",
SEP: "Stephenville",
SEQ: "Bengkalis-Sumatra Island",
SER: "Seymour",
SES: "Svetlogorsk",
SET: "Serra Talhada",
SEU: "Seronera",
SEW: "Siwa Oasis",
SEY: "SŽlibaby",
SEZ: "Mahe Island",
SFA: "Sfax",
SFB: "Orlando",
SFC: "St-Franois",
SFD: "San Fernando de Apure",
SFE: "San Fernando",
SFF: "Spokane",
SFG: "Grand Case",
SFH: "Mexicali",
SFJ: "Kangerlussuaq",
SFK: "Soure",
SFL: "S‹o Filipe",
SFM: "Sanford",
SFN: "Santa Fe",
SFO: "San Francisco",
SFS: "Olongapo",
SFT: "SkellefteŒ",
SFU: "Safia",
SFV: "Santa FŽ Do Sul",
SFX: "Ciudad Guayana",
SFZ: "Pawtucket",
SGA: "Shiveh",
SGC: "Surgut",
SGD: "S¿nderborg",
SGE: "Burbach",
SGF: "Springfield",
SGG: "Sermiligaaq",
SGH: "Springfield",
SGI: "Sargodha",
SGK: "Sengapi",
SGL: "Cavite",
SGM: "MulegŽ",
SGN: "Ho Chi Minh City",
SGP: "Shay Gap",
SGQ: "Sanggata/Sangkimah",
SGR: "Houston",
SGT: "Stuttgart",
SGU: "St George",
SGV: "Sierra Grande",
SGW: "Saginaw Bay",
SGX: "Songea",
SGY: "Skagway",
SHA: "Shanghai (Minhang)",
SHB: "Nakashibetsu",
SHC: "Shire Inda Selassie",
SHD: "Weyers Cave",
SHE: "Hunnan, Shenyang",
SHF: "Shihezi",
SHG: "Shungnak",
SHH: "Shishmaref",
SHI: "Miyakojima",
SHJ: "Sharjah",
SHK: "Sehonghong",
SHL: "Shillong",
SHM: "Shirahama",
SHN: "Shelton",
SHO: "Mpaka",
SHR: "Sheridan",
SHS: "Jingzhou (Shashi)",
SHV: "Shreveport",
SHW: "Sharurah",
SHX: "Shageluk",
SHY: "Shinyanga",
SHZ: "Seshutes",
SIA: "Xi'an (Baqiao)",
SIB: "Sibiti",
SIC: "Las Perlas",
SID: "Espargos",
SIF: "Simara",
SIG: "San Juan",
SIH: "Silgadi Doti",
SIJ: "Siglufjšr?ur",
SIK: "Sikeston",
SIL: "Sila Mission",
SIM: "Simbai",
SIN: "Singapore",
SIP: "Simferopol",
SIQ: "Pasirkuning-Singkep Island",
SIR: "Sion",
SIS: "Sishen",
SIT: "Sitka",
SIU: "Siuna",
SIV: "Sullivan",
SIW: "Parapat-Sumatra Island",
SIX: "Singleton",
SIY: "Montague",
SIZ: "Sissano",
SJA: "San Juan de Marcona",
SJB: "San Joaqu’n",
SJC: "San Jose",
SJD: "San JosŽ del Cabo",
SJE: "San JosŽ Del Guaviare",
SJF: "Cruz Bay",
SJH: "San Juan Del CŽsar",
SJI: "San Jose",
SJJ: "Sarajevo",
SJK: "S‹o JosŽ Dos Campos",
SJL: "S‹o Gabriel da Cachoeira",
SJN: "St Johns",
SJO: "San JosŽ (Alajuela)",
SJP: "S‹o JosŽ do Rio Preto",
SJQ: "Sesheke",
SJR: "San Juan De Uraba",
SJS: "San JosŽ de Chiquitos",
SJT: "San Angelo",
SJU: "San Juan",
SJV: "San Javier",
SJW: "Shijiazhuang",
SJX: "Sartaneja",
SJY: "SeinŠjoki / Ilmajoki",
SJZ: "Velas",
SKA: "Spokane",
SKB: "Basseterre",
SKC: "Suki",
SKD: "Samarkand",
SKF: "San Antonio",
SKG: "Thessaloniki",
SKH: "Surkhet",
SKJ: "Singkawang",
SKK: "Shaktoolik",
SKL: "Ashaig",
SKM: "Skeldon",
SKN: "Hadsel",
SKO: "Sokoto",
SKP: "Ilinden",
SKQ: "Sekakes",
SKR: "Shakiso",
SKS: "Vojens",
SKT: "Sialkot",
SKU: "Skiros Island",
SKV: "Saint Catherine",
SKW: "Skwentna",
SKX: "Saransk",
SKZ: "Mirpur Khas",
SLA: "Salta",
SLB: "Storm Lake",
SLC: "Salt Lake City",
SLD: "Slia?",
SLE: "Salem",
SLF: "As-Sulayyil",
SLG: "Siloam Springs",
SLH: "Sola",
SLI: "Solwesi",
SLJ: "Karijini National Park",
SLK: "Saranac Lake",
SLL: "Salalah",
SLM: "Salamanca",
SLN: "Salina",
SLO: "Salem",
SLP: "San Luis Potos’",
SLQ: "Sleetmute",
SLR: "Sulphur Springs",
SLT: "Salida",
SLU: "Castries",
SLV: "Jubbarhatti",
SLW: "Saltillo",
SLX: "Salt Cay",
SLY: "Salekhard",
SLZ: "S‹o Lu’s",
SMA: "Vila do Porto",
SMB: "Cerro Sombrero",
SMD: "Fort Wayne",
SME: "Somerset",
SMF: "Sacramento",
SMH: "Sapmanga",
SMI: "Samos Island",
SMJ: "Sim",
SMK: "St Michael",
SML: "Stella Maris",
SMM: "Semporna",
SMN: "Salmon",
SMO: "Santa Monica",
SMP: "Stockholm",
SMQ: "Sampit",
SMR: "Santa Marta",
SMS: "Vohilava",
SMT: "Sorriso",
SMU: "Sheep Mountain",
SMV: "Samedan",
SMW: "Smara",
SMX: "Santa Maria",
SMY: "Simenti",
SMZ: "Stoelmanseiland",
SNA: "Santa Ana",
SNB: "Milikapiti",
SNC: "Salinas",
SNE: "Preguia",
SNF: "San Felipe",
SNG: "San Ignacio de Velasco",
SNI: "Greenville",
SNJ: "Sandino",
SNK: "Snyder",
SNL: "Shawnee",
SNM: "San Ignacio de Moxos",
SNN: "Shannon",
SNP: "St Paul Island",
SNQ: "San Quint’n",
SNR: "Saint-Nazaire/Montoir",
SNS: "Salinas",
SNT: "Sabana de Torres",
SNU: "Santa Clara",
SNV: "Santa Elena de UairŽn",
SNW: "Thandwe",
SNX: "Semnan",
SNY: "Sidney",
SNZ: "Rio de Janeiro",
SOA: "S—c Tr?ng",
SOB: "S‡rmellŽk",
SOC: "Surakarta",
SOD: "Sorocaba",
SOE: "Souanke",
SOF: "Sofia",
SOG: "Sogndal",
SOH: "Solita",
SOI: "South Molle Island Resort",
SOJ: "S¿rkjosen",
SOK: "Semonkong",
SOL: "Solomon",
SOM: "El Tigre",
SON: "Luganville",
SOO: "Sšderhamn",
SOP: "Carthage",
SOQ: "Sorong",
SOR: "T2",
SOT: "Sodankyla",
SOU: "Southampton",
SOV: "Seldovia",
SOW: "Show Low",
SOX: "Sogamoso",
SOY: "Stronsay",
SOZ: "Solenzara",
SPA: "Spartanburg",
SPB: "Charlotte Amalie",
SPC: "Sta Cruz de la Palma, La Palma Island",
SPD: "Saidpur",
SPE: "Sepulot",
SPF: "Spearfish",
SPG: "St Petersburg",
SPH: "Sopu",
SPI: "Springfield",
SPJ: "Sparti",
SPM: "Trier",
SPN: "I Fadang, Saipan",
SPP: "Menongue",
SPQ: "San Pedro",
SPR: "San Pedro",
SPS: "Wichita Falls",
SPT: "Sipitang",
SPU: "Ka?tel ?tafili?",
SPV: "Sepik Plains",
SPW: "Spencer",
SPX: "Al Jiza",
SPZ: "Springdale",
SQA: "Santa Ynez",
SQB: "Piedras",
SQD: "Shangrao (Hengfeng)",
SQE: "San Luis De Palenque",
SQF: "Solano",
SQG: "Sintang",
SQH: "Mai Son",
SQI: "Rock Falls",
SQJ: "Sanming (Sha)",
SQK: "Sidi El Barrani",
SQL: "San Carlos",
SQM: "S‹o Miguel Do Araguaia",
SQN: "Sanana",
SQO: "Storuman",
SQQ: "?iauliai",
SQR: "Soroako",
SQS: "Spanish Lookout",
SQT: "Samarai Island",
SQU: "Plaza Saposoa",
SQV: "Sequim",
SQW: "Skive",
SQX: "S‹o Miguel do Oeste",
SQY: "S‹o Loureno Do Sul",
SRA: "Santa Rosa",
SRB: "Santa Rosa",
SRC: "Searcy",
SRD: "San Ram—n / MamorŽ",
SRE: "Yamparaez",
SRG: "Semarang",
SRH: "Sarh",
SRJ: "San Borja",
SRK: "Siorapaluk",
SRL: "MulegŽ",
SRM: "Sandringham Station",
SRO: "Santana Ramos",
SRP: "Leirvik",
SRQ: "Sarasota/Bradenton",
SRR: "North Stradbroke Island",
SRS: "San Marcos",
SRT: "Soroti",
SRU: "Falam",
SRV: "Stony River",
SRW: "Salisbury",
SRX: "Sirt",
SRY: "Sari",
SRZ: "Santa Cruz",
SSA: "Salvador",
SSB: "Christiansted",
SSC: "Sumter",
SSD: "San Felipe",
SSE: "Solapur",
SSF: "San Antonio",
SSG: "Malabo",
SSH: "Sharm El Sheikh",
SSI: "St Simons Island",
SSJ: "Alstahaug",
SSK: "Sturt Creek",
SSL: "Santa Rosalia",
SSN: "Seongnam",
SSO: "S‹o Loureno",
SSP: "Silver Plains",
SSQ: "La Sarre",
SSR: "Pentecost Island",
SSS: "Siassi",
SST: "Santa Teresita",
SSW: "Friday Harbor",
SSX: "Singita Safari Lodge",
SSY: "Mbanza Congo",
SSZ: "Guaruj‡",
STA: "Skjern",
STB: "San Carlos del Zulia",
STC: "Saint Cloud",
STD: "Santo Domingo",
STE: "Stevens Point",
STF: "Stephens Island",
STG: "St George",
STH: "Strathmore",
STI: "Santiago",
STJ: "St Joseph",
STK: "Sterling",
STL: "St Louis",
STM: "SantarŽm",
STN: "London",
STP: "Saint Paul",
STQ: "St Marys",
STR: "Stuttgart",
STS: "Santa Rosa",
STT: "Charlotte Amalie",
STU: "Santa Cruz",
STV: "Surat",
STW: "Stavropol",
STX: "Christiansted",
STY: "Salto",
STZ: "Santa Terezinha",
SUA: "Stuart",
SUB: "Surabaya",
SUD: "Stroud",
SUE: "Sturgeon Bay",
SUF: "Lamezia Terme (CZ)",
SUG: "Surigao City",
SUI: "Sukhumi",
SUJ: "Satu Mare",
SUK: "Batagay-Alyta",
SUL: "Sui",
SUM: "Sumter",
SUN: "Hailey",
SUO: "Sunriver",
SUP: "Sumenep",
SUQ: "Sucœa",
SUR: "Summer Beaver",
SUS: "St Louis",
SUT: "Sumbawanga",
SUU: "Fairfield",
SUV: "Nausori",
SUW: "Superior",
SUX: "Sioux City",
SUY: "Suntar",
SVA: "Savoonga",
SVB: "Sambava",
SVC: "Silver City",
SVD: "Kingstown",
SVE: "Susanville",
SVF: "SavŽ",
SVG: "Stavanger",
SVH: "Statesville",
SVI: "San Vicente Del Cagu‡n",
SVJ: "Svolv¾r",
SVK: "Silver Creek",
SVL: "Savonlinna",
SVN: "Savannah",
SVO: "Moscow",
SVP: "Kuito",
SVQ: "Sevilla",
SVR: "Savissivik",
SVS: "Stevens Village",
SVT: "Savuti",
SVU: "Savusavu",
SVV: "San Salvador de Paul",
SVW: "Sparrevohn",
SVX: "Yekaterinburg",
SWA: "Jieyang (Rongcheng)",
SWB: "Shaw River",
SWD: "Seward",
SWE: "Siwea",
SWF: "Newburgh",
SWG: "Satwag",
SWJ: "Malekula Island",
SWL: "San Vicente",
SWN: "Sherpur Naqeebpur",
SWO: "Stillwater",
SWP: "Swakopmund",
SWQ: "Sumbawa Besar",
SWR: "Silur Mission",
SWS: "Swansea",
SWT: "Strezhevoy",
SWU: "Suwon",
SWV: "Evensk",
SWW: "Sweetwater",
SWX: "Shakawe",
SWY: "Sitiawan",
SWZ: "Sydney (Badgerys Creek)",
SXA: "Sialum",
SXB: "Strasbourg",
SXE: "Sale",
SXG: "Senanga",
SXH: "Sehulea",
SXI: "Siri",
SXJ: "Shanshan",
SXK: "Saumlaki-Yamdena Island",
SXL: "Sligo",
SXM: "Sint Maarten",
SXN: "Sowa",
SXO: "S‹o FŽlix Do Araguaia",
SXP: "Nunam Iqua",
SXQ: "Soldotna",
SXR: "Srinagar",
SXS: "Sahabat",
SXT: "Taman Negara",
SXU: "Soddu",
SXV: "Salem",
SXW: "Sauren",
SXX: "S‹o FŽlix do Xingu",
SXY: "Sidney",
SXZ: "Siirt",
SYA: "Shemya",
SYB: "Seal Bay",
SYC: "Shiringayoc",
SYD: "Sydney (Mascot)",
SYE: "Sa'dah",
SYF: "Gabriola Island",
SYH: "Namche Bazaar",
SYI: "Shelbyville",
SYJ: "Sirjan",
SYK: "Stykkish—lmur",
SYL: "Camp Roberts/San Miguel",
SYM: "Pu'er",
SYN: "Dennison",
SYO: "Shonai",
SYP: "Santiago",
SYQ: "San Jose",
SYR: "Syracuse",
SYS: "Saskylakh",
SYT: "L'H™pital-le-Mercier, Sa™ne-et-Loire",
SYU: "Sue Islet",
SYV: "Sylvester",
SYW: "Sehwan Sharif",
SYX: "Sanya (Tianya)",
SYY: "Stornoway, Western Isles",
SYZ: "Shiraz",
SZA: "Soyo",
SZB: "Subang",
SZE: "Semera",
SZF: "Samsun",
SZG: "Salzburg",
SZH: "Shuozhou",
SZI: "Zaysan",
SZJ: "Isla de la Juventud",
SZK: "Skukuza",
SZL: "Knob Noster",
SZM: "Sesriem",
SZN: "Santa Cruz Island",
SZP: "Santa Paula",
SZS: "Oban",
SZV: "Suzhou",
SZX: "Shenzhen (Bao'an)",
SZY: "Szymany",
SZZ: "Glewice",
TAB: "Scarborough",
TAC: "Tacloban City",
TAD: "Trinidad",
TAE: "Daegu",
TAF: "Tafraoui",
TAG: "Panglao",
TAI: "Ta'izz",
TAJ: "Aitape",
TAK: "Takamatsu",
TAL: "Tanana",
TAM: "Tampico",
TAO: "Qingdao (Jiaozhou)",
TAP: "Tapachula",
TAQ: "Tarcoola",
TAR: "Grottaglie",
TAS: "Tashkent",
TAT: "Poprad",
TAU: "Tauramena",
TAW: "Tacuarembo",
TAX: "Tikong-Taliabu Island",
TAY: "Reola",
TAZ: "Da?oguz",
TBB: "Tuy Hoa",
TBC: "Tuba City",
TBD: "Timbiqui",
TBE: "Timbunke",
TBG: "Tabubil",
TBH: "Tablas Island",
TBI: "Cat Island",
TBJ: "Tabarka",
TBM: "Tumbang Samba-Borneo Island",
TBN: "Fort Leonard Wood",
TBO: "Tabora",
TBP: "Tumbes",
TBQ: "Tarabo",
TBR: "Statesboro",
TBS: "Tbilisi",
TBT: "Tabatinga",
TBU: "Nuku'alofa",
TBV: "Tabal Island",
TBW: "Tambov",
TBX: "Tambelan",
TBY: "Tshabong",
TBZ: "Tabriz",
TCA: "Tennant Creek",
TCB: "Treasure Cay",
TCC: "Tucumcari",
TCD: "Tarapac‡",
TCE: "Mihail Kog?lniceanu",
TCF: "Tocoa",
TCG: "Tacheng",
TCH: "Tchibanga",
TCJ: "Torembi",
TCK: "Tinboli",
TCL: "Tuscaloosa",
TCM: "Tacoma",
TCN: "Tehuac‡n",
TCO: "Tumaco",
TCP: "Taba",
TCQ: "Tacna",
TCR: "Vagaikulam",
TCS: "Truth or Consequences",
TCT: "Takotna",
TCU: "Homeward",
TCX: "Tabas",
TCY: "Terrace Bay",
TCZ: "Baoshan (Tengchong)",
TDA: "Trinidad",
TDB: "Tetebedi",
TDD: "Trinidad",
TDG: "Tandag",
TDJ: "Tadjoura",
TDK: "Taldykorgan",
TDL: "Tandil",
TDN: "Drysdale River",
TDO: "Toledo",
TDP: "Corrientes",
TDS: "Sasereme",
TDT: "Timbavati",
TDV: "Tanandava",
TDW: "Amarillo",
TDX: "Laem Ngop",
TDZ: "Toledo",
TEA: "Tela",
TEB: "Teterboro",
TEC: "Telmaco Borba",
TED: "Thisted",
TEE: "TŽbessi",
TEG: "Tenkodogo",
TEH: "Tetlin",
TEI: "Tezu",
TEK: "Tatitlek",
TEL: "Telupid",
TEM: "Temora",
TEN: "Tongren (Daxing)",
TEO: "Terapo Mission",
TEP: "Teptep",
TEQ: "‚orlu",
TER: "Praia da Vit—ria",
TES: "Tessenei",
TET: "Tete",
TEV: "Teruel",
TEX: "Telluride",
TEY: "?ingeyri",
TFB: "Tifalmin",
TFF: "TefŽ",
TFI: "Tufi",
TFL: "Te—filo Otoni",
TFM: "Telefomin",
TFN: "Tenerife",
TFR: "New Cairo",
TFS: "Tenerife",
TFT: "Taftan",
TFU: "Chengdu (Jianyang)",
TFY: "Krui",
TGA: "Western Water Catchment",
TGB: "Rizal",
TGC: "Belawai",
TGD: "Podgorica",
TGG: "Kuala Terengganu",
TGH: "Tongoa Island",
TGI: "Tingo Maria",
TGJ: "Tiga",
TGK: "Taganrog",
TGL: "Sudest Island",
TGM: "Recea",
TGN: "Morwell",
TGO: "Tongliao",
TGP: "Bor",
TGQ: "Tangar‡ da Serra",
TGR: "Touggourt",
TGS: "ChokwŽ",
TGT: "Tanga",
TGU: "Tegucigalpa",
TGZ: "Tuxtla GutiŽrrez",
THA: "Tullahoma",
THB: "Thaba-Tseka",
THC: "Zwedru",
THD: "Thanh H—a",
THE: "Teresina",
THG: "Biloela",
THH: "Taharoa",
THI: "Tichitt",
THK: "Thakhek",
THL: "Tachileik",
THM: "Thompson Falls",
THN: "TrollhŠttan",
THO: "?—rshšfn",
THP: "Thermopolis",
THQ: "Tianshui (Maiji)",
THR: "Tehran",
THT: "Tamchakett",
THU: "Pituffik",
THV: "Thomasville",
THW: "Trincomalee",
THX: "Turukhansk",
THY: "Thohoyandou",
THZ: "Tahoua",
TIA: "Rinas",
TIB: "Tibœ",
TIC: "Arno Atoll",
TID: "Tiaret",
TIE: "Tippi",
TIF: "TaÕif",
TII: "Tarinkot",
TIJ: "Tijuana",
TIK: "Oklahoma City",
TIL: "Cheadle",
TIM: "Timika",
TIN: "Tindouf",
TIO: "Tilin",
TIQ: "Tinian Island",
TIR: "Tirupati",
TIV: "Tivat",
TIW: "Tacoma",
TIX: "Titusville",
TIY: "Tidjikja",
TIZ: "Tari",
TJA: "Tarija",
TJB: "Tanjung Balai-Karinmunbesar Island",
TJC: "Ticantiqu’",
TJG: "Tanta-Tabalong",
TJH: "Toyooka",
TJI: "Trujillo",
TJK: "Tokat",
TJL: "Trs Lagoas",
TJM: "Tyumen",
TJN: "Takume",
TJQ: "Tanjung Pandan",
TJS: "Tanjung Selor-Borneo Island",
TJU: "Kulyab",
TJV: "Thanjavur",
TKA: "Talkeetna",
TKB: "Tekadu",
TKC: "Tiko",
TKD: "Sekondi-Takoradi",
TKE: "Tenakee Springs",
TKF: "Truckee",
TKG: "Bandar Lampung",
TKI: "Tokeen",
TKJ: "Tok",
TKK: "Weno Island",
TKL: "Taku Lodge",
TKM: "Taksimo",
TKN: "Amagi",
TKO: "Tlokoeng",
TKQ: "Kigoma",
TKR: "Thakurgaon",
TKS: "Tokushima",
TKU: "Turku",
TKV: "Tatakoto",
TKW: "Tekin",
TKY: "Turkey Creek",
TKZ: "Tokoroa",
TLA: "Teller",
TLB: "Tarbela",
TLC: "Toluca",
TLD: "Tuli Lodge",
TLE: "Toliara",
TLF: "Telida",
TLG: "Tulaghi Island",
TLH: "Tallahassee",
TLI: "Toli Toli-Celebes Island",
TLJ: "Takotna",
TLK: "Talakan Oil Field",
TLL: "Tallinn",
TLM: "Zenata",
TLN: "Hyres, Var",
TLO: "Tol",
TLP: "Tumolbil",
TLQ: "Turpan",
TLR: "Tulare",
TLS: "Toulouse/Blagnac",
TLT: "Tuluksak",
TLU: "Santiago de Tolœ",
TLV: "Tel Aviv",
TLW: "Talasea",
TLX: "Talca",
TLY: "Plastun",
TLZ: "Catal‹o",
TMA: "Tifton",
TMB: "Miami",
TMC: "Radamata",
TMD: "Timbedra",
TME: "Tame",
TMF: "Thimarafushi",
TMG: "Tomanggong",
TMH: "Tanah Merah",
TMI: "Tumling Tar",
TMJ: "Termez",
TML: "Tamale",
TMM: "Toamasina",
TMN: "Tamana Island",
TMP: "Tampere / Pirkkala",
TMQ: "Tambao",
TMR: "Tamanrasset",
TMS: "S‹o TomŽ",
TMT: "Oriximin‡",
TMU: "Nicoya",
TMW: "Tamworth",
TMX: "Timimoun",
TMY: "Tiom-Papua Island",
TNA: "Jinan (Licheng)",
TNB: "Tanah Grogot",
TNC: "Tin City",
TND: "Trinidad",
TNE: "Tanegashima",
TNF: "Toussus-le-Noble, Yvelines",
TNG: "Tangier",
TNH: "Tonghua",
TNJ: "Tanjung Pinang-Bintan Island",
TNK: "Tununak",
TNL: "Ternopil",
TNM: "Villa Las Estrellas",
TNN: "Tainan (Rende)",
TNO: "Tamarindo",
TNP: "Twentynine Palms",
TNQ: "Teraina",
TNR: "Antananarivo",
TNS: "Tungsten",
TNT: "Miami",
TNU: "Newton",
TNV: "Tabuaeran Island",
TNW: "Ahuano",
TNX: "Stung Treng",
TNZ: "Tosontsengel",
TOA: "Torrance",
TOB: "Adam",
TOC: "Toccoa",
TOD: "Tioman Island",
TOE: "Tozeur",
TOF: "Tomsk",
TOG: "Togiak Village",
TOH: "Loh/Linua",
TOI: "Troy",
TOJ: "Madrid",
TOK: "Torokina",
TOL: "Toledo",
TOM: "Timbuktu",
TON: "Tonu",
TOO: "Coto Brus",
TOP: "Topeka",
TOQ: "Tocopilla",
TOR: "Torrington",
TOS: "Troms¿",
TOT: "Totness",
TOU: "Touho",
TOV: "Tortola",
TOW: "Toledo",
TOX: "Tobolsk",
TOY: "Toyama",
TOZ: "Touba",
TPA: "Tampa",
TPC: "Tarapoa",
TPE: "Taoyuan",
TPF: "Tampa",
TPG: "Taiping",
TPH: "Tonopah",
TPI: "Tapini",
TPJ: "Taplejung",
TPK: "Tapaktuan",
TPL: "Temple",
TPN: "Tiputini",
TPP: "Tarapoto",
TPQ: "Tepic",
TPR: "Tom Price",
TPS: "Trapani (TP)",
TPT: "Tapeta",
TPU: "Tikapur",
TPX: "Tupai Atoll",
TQA: "Tasiusaq",
TQD: "Al Habbaniyah",
TQI: "Tiniteqilaaq",
TQL: "Tarko-Sale",
TQN: "Taleqan",
TQO: "Tulum",
TQP: "Trepell",
TQQ: "Waha-Tomea Island",
TQS: "Tres Esquinas",
TRA: "Tarama",
TRB: "Turbo",
TRC: "Torre—n",
TRD: "Trondheim",
TRE: "Balemartine",
TRF: "Torp",
TRG: "Tauranga",
TRH: "Trona",
TRI: "Blountville",
TRJ: "Tarakbits",
TRK: "Tarakan",
TRL: "Terrell",
TRM: "Palm Springs",
TRN: "Caselle Torinese (TO)",
TRO: "Taree",
TRQ: "Tarauac‡",
TRR: "Trincomalee",
TRS: "Ronchi dei Legionari (GO)",
TRT: "Toraja",
TRU: "Trujillo",
TRV: "Thiruvananthapuram",
TRW: "Tarawa",
TRX: "Trenton",
TRY: "Tororo",
TRZ: "Tiruchirappalli",
TSA: "Taipei (Songshan)",
TSB: "Tsumeb",
TSC: "Taisha",
TSD: "Tshipise",
TSF: "Treviso (TV)",
TSG: "Tanacross",
TSH: "Tshikapa",
TSI: "Tsile Tsile",
TSJ: "Tsushima",
TSL: "Tamu’n",
TSM: "Taos",
TSN: "Tianjin",
TSP: "Tehachapi",
TSQ: "Torres",
TSR: "Timi?oara",
TSS: "New York",
TST: "Trang",
TSU: "Tabiteuea South",
TSV: "Townsville",
TSW: "Tsewi",
TSX: "Santan-Borneo Island",
TSY: "Tasikmalaya-Java Island",
TSZ: "Tsetserleg",
TTA: "Tan Tan",
TTB: "Arbatax",
TTC: "Taltal",
TTD: "Portland",
TTE: "Sango",
TTG: "Tartagal",
TTH: "Thumrait",
TTI: "Tetiaroa",
TTJ: "Tottori",
TTL: "Nanuya Levu Island",
TTM: "Tabl—n De Tamara",
TTN: "Ewing Township",
TTO: "Britton",
TTQ: "Tortuguero",
TTR: "Makale",
TTS: "Tsaratanana",
TTT: "Taitung City",
TTU: "TŽtouan",
TTW: "Tissamaharama",
TTX: "Anjo Peninsula",
TUA: "Tulc‡n",
TUC: "San Miguel de Tucum‡n",
TUD: "Tambacounda",
TUF: "Tours, Indre-et-Loire",
TUG: "Tuguegarao City",
TUH: "Manchester",
TUI: "Turaif",
TUJ: "Tum",
TUK: "Turbat",
TUL: "Tulsa",
TUM: "Tumut",
TUN: "Tunis",
TUO: "Taupo",
TUP: "Tupelo",
TUQ: "Tougan",
TUR: "Tucuru’",
TUS: "Tucson",
TUU: "Tabuk",
TUV: "Tucupita",
TUW: "Coetupo",
TUX: "Tumbler Ridge",
TUY: "Tulum",
TVA: "Morafenobe",
TVC: "Traverse City",
TVF: "Thief River Falls",
TVI: "Thomasville",
TVL: "South Lake Tahoe",
TVS: "Tangshan (Fengrun)",
TVU: "Matei",
TVY: "Dawei",
TWA: "Twin Hills",
TWB: "Toowoomba",
TWC: "Tumxuk",
TWD: "Port Townsend",
TWE: "Taylor",
TWF: "Twin Falls",
TWH: "Two Harbors",
TWP: "Torwood",
TWT: "Bongao",
TWU: "Tawau",
TWY: "Tawa",
TWZ: "Twitzel",
TXC: "Orsha",
TXE: "Takengon",
TXF: "Teixeira de Freitas",
TXK: "Texarkana",
TXM: "Atinjoe",
TXN: "Huangshan",
TXR: "Tanbar Station",
TXU: "Tabou",
TYA: "Tula",
TYC: "Taiyuan",
TYD: "Tynda",
TYE: "Tyonek",
TYF: "Torsby",
TYL: "Talara",
TYM: "Staniel Cay",
TYN: "Taiyuan",
TYP: "Tobermorey",
TYR: "Tyler",
TYS: "Alcoa",
TYT: "Treinta y Tres",
TYZ: "Taylor",
TZA: "Belize City",
TZC: "Caro",
TZL: "Dubrave Gornje",
TZM: "Tizimin",
TZN: "Andros",
TZO: "Ankisatra",
TZX: "Trabzon",
UAB: "Sarõam",
UAC: "San Luis R’o Colorado",
UAE: "Aue",
UAH: "Ua Huka",
UAI: "Suai",
UAK: "Narsarsuaq",
UAL: "Luau",
UAM: "Yigo",
UAP: "Ua Pou",
UAQ: "San Juan",
UAR: "Bouarfa",
UAS: "Samburu",
UAX: "Uaxactun",
UBA: "Uberaba",
UBB: "Mabuiag Island",
UBI: "Buin",
UBJ: "Ube",
UBN: "Ulaanbaatar (Sergelen)",
UBP: "Ubon Ratchathani",
UBS: "Columbus",
UBT: "Ubatuba",
UBU: "Kalumburu",
UCB: "Ulanqab",
UCC: "Mercury",
UCE: "Eunice",
UCK: "Lutsk",
UCN: "Buchanan",
UCT: "Ukhta",
UCY: "Union City",
UCZ: "Uchiza",
UDA: "Undara",
UDD: "Bermuda Dunes",
UDE: "Uden",
UDI: "Uberl‰ndia",
UDJ: "Uzhhorod",
UDN: "Campoformido (UD)",
UDR: "Udaipur",
UEL: "Quelimane",
UEN: "Urengoy",
UEO: "Kumejima",
UES: "Waukesha",
UET: "Quetta",
UFA: "Ufa",
UGA: "Bulgan",
UGB: "Pilot Point",
UGC: "Urgench",
UGI: "San Juan",
UGL: "Union Glacier",
UGN: "Chicago/Waukegan",
UGO: "Uige",
UGS: "Ugashik",
UGT: "Khankhongor",
UGU: "Sugapa",
UHE: "UherskŽ Hradi?t?",
UHS: "Aleksandrovsk-Sakhalinskiy",
UIB: "Quibd—",
UIH: "Quy Nohn",
UII: "Utila Island",
UIK: "Ust-Ilimsk",
UIL: "Quillayute",
UIN: "Quincy",
UIO: "Quito",
UIP: "Quimper/Pluguffan",
UIT: "Jabor Jaluit Atoll",
UJE: "Ujae Atoll",
UJN: "Bongsan-ri, Uljin",
UJU: "Uiju",
UKA: "Ukunda",
UKB: "Kobe",
UKE: "Bhawanipatna",
UKG: "Ust-Kuyga",
UKH: "Mukhaizna Oil Field",
UKI: "Ukiah",
UKK: "Ust-Kamenogorsk (Oskemen)",
UKN: "Waukon",
UKR: "Mukayras",
UKS: "Sevastopol",
UKT: "Quakertown",
UKU: "Nuku",
UKX: "Ust-Kut",
ULA: "San Julian",
ULB: "Ambrym Island",
ULD: "Ulundi",
ULE: "Sule",
ULG: "…lgii",
ULH: "Al Ula",
ULI: "Falalop Island",
ULK: "Lensk",
ULL: "Glenforsa",
ULM: "New Ulm",
ULN: "Ulaanbaatar",
ULO: "Ulaangom",
ULQ: "Tulu‡",
ULS: "Mulatos",
ULU: "Gulu",
ULV: "Ulyanovsk",
ULX: "Ulusaba",
ULY: "Cherdakly",
ULZ: "Uliastai",
UMA: "Mais’",
UMB: "Kalumbila",
UMC: "Umba",
UMD: "Uummannaq",
UME: "UmeŒ",
UMI: "Quince Mil",
UMM: "Cantwell",
UMR: "Woomera",
UMS: "Ust-Maya",
UMT: "Umiat",
UMU: "Umuarama",
UMY: "Sumy",
UMZ: "Mena",
UNA: "Una",
UNC: "Ungu’a",
UND: "Kunduz",
UNE: "Qacha's Nek",
UNG: "Kiunga",
UNI: "Union Island",
UNK: "Unalakleet",
UNN: "Ranong",
UNR: "…ndšrkhaan",
UNT: "Baltasound, Shetland Islands",
UNU: "Juneau",
UOA: "Moruroa Atoll",
UOL: "Buol-Celebes Island",
UOS: "Sewanee",
UOX: "Oxford",
UPB: "Havana",
UPG: "Ujung Pandang",
UPL: "Upala",
UPN: "Uruapan",
UPP: "Hawi",
UPR: "Upiara",
UPV: "Pewsey, Wiltshire",
URA: "Uralsk",
URC: "†rŸmqi",
URD: "Ebermannstadt",
URE: "Kuressaare",
URG: "Uruguaiana",
URI: "La Uribe",
URJ: "Uray",
URM: "Urim‡n",
URN: "Urgun",
URO: "Boos",
URR: "Urrao",
URS: "Kursk",
URT: "Surat Thani",
URU: "Uroubi",
URY: "Gurayat",
URZ: "Or?zg?n",
USA: "Concord",
USC: "Union",
USH: "Ushuaia",
USI: "Mabaruma",
USJ: "Usharal",
USK: "Usinsk",
USL: "Useless Loop",
USM: "Na Thon (Ko Samui Island)",
USN: "Ulsan",
USQ: "U?ak",
USR: "Ust-Nera",
USS: "Sancti Spiritus",
UST: "St Augustine",
USU: "Coron",
UTA: "Mutare",
UTD: "Nutwood Downs",
UTE: "Bultfontein",
UTG: "Quthing",
UTH: "Udon Thani",
UTI: "Utti / Valkeala",
UTK: "Utirik Island",
UTM: "Tunica",
UTN: "Upington",
UTO: "Utopia Creek",
UTP: "Rayong",
UTR: "Uttaradit",
UTS: "Ust-Tsylma",
UTT: "Mthatha",
UTU: "Ustupu",
UTW: "Queenstown",
UUA: "Bugulma",
UUD: "Ulan Ude",
UUK: "Kuparuk",
UUS: "Yuzhno-Sakhalinsk",
UUU: "Manumu",
UVA: "Uvalde",
UVE: "OuvŽa",
UVF: "Vieux Fort",
UVI: "Uni‹o da Vit—ria",
UVL: "Kharja Oases",
UVO: "Uvol",
UWA: "Ware",
UYL: "Nyala",
UYN: "Yulin",
UYU: "Quijarro",
UZC: "Stapari",
UZM: "Hope Bay",
UZR: "Urzhar",
UZU: "Curuzu Cuatia",
VAA: "Vaasa",
VAB: "Yavarate",
VAC: "Cloppenburg",
VAD: "Valdosta",
VAF: "Chabeuil, Dr™me",
VAG: "Varginha",
VAH: "Vallegrande",
VAI: "Vanimo",
VAK: "Chevak",
VAL: "Valena",
VAM: "Maamigili",
VAN: "Van",
VAO: "Suavanao",
VAP: "Vi–a Del Mar",
VAQ: "Vanavara",
VAR: "Varna",
VAS: "Sivas",
VAT: "Vatomandry",
VAV: "Vava'u Island",
VAW: "Vard¿",
VBA: "Aeng",
VBC: "Mandalay",
VBG: "Lompoc",
VBP: "Bokpyinn",
VBS: "Montichiari (BS)",
VBV: "Vanua Balavu",
VBY: "Visby",
VCA: "Can Tho",
VCC: "Vacaria",
VCD: "Victoria River",
VCE: "Venezia (VE)",
VCF: "Valcheta",
VCH: "Vichadero",
VCL: "Tam Ngh?a",
VCP: "Campinas",
VCS: "Con Dao",
VCT: "Victoria",
VCV: "Victorville",
VDA: "Eilat",
VDC: "Vit—ria da Conquista",
VDE: "El Hierro Island",
VDH: "Dong Hoi",
VDI: "Vidalia",
VDM: "Viedma / Carmen de Patagones",
VDO: "Van Don",
VDR: "Villa Dolores",
VDS: "Vads¿",
VDY: "Toranagallu",
VDZ: "Valdez",
VEE: "Venetie",
VEG: "Maikwak",
VEL: "Vernal",
VEO: "Severo-Yeniseysk",
VER: "Veracruz",
VEV: "Barakoma",
VEX: "Tioga",
VEY: "Vestmannaeyjar",
VFA: "Victoria Falls",
VGA: "Gannavaram",
VGD: "Vologda",
VGO: "Vigo",
VGS: "General Villegas",
VGT: "Las Vegas",
VGZ: "Villa Garz—n",
VHC: "Saurimo",
VHM: "Vilhelmina",
VHN: "Van Horn",
VHV: "Verkhnevilyuisk",
VHY: "Charmeil, Allier",
VHZ: "Vahitahi",
VIA: "Videira",
VIE: "Vienna",
VIG: "El Vig’a",
VIH: "Vichy",
VII: "Vinh",
VIJ: "Spanish Town",
VIL: "Dakhla",
VIN: "Vinnitsa",
VIP: "Payerne",
VIQ: "Viqueque",
VIR: "Durban",
VIS: "Visalia",
VIT: "Alava",
VIU: "Viru",
VIV: "Vivigani",
VIX: "Vit—ria",
VIY: "VŽlizy-Villacoublay, Yvelines",
VJB: "Xai-Xai",
VJI: "Abingdon",
VJQ: "Gurue",
VKG: "Rach Gia",
VKO: "Moscow",
VKS: "Vicksburg",
VKT: "Vorkuta",
VKV: "Arkhangelsk",
VLA: "Vandalia",
VLC: "Valencia",
VLD: "Valdosta",
VLE: "Grand Canyon",
VLG: "Villa Gesell",
VLI: "Port Vila",
VLL: "Valladolid",
VLM: "Villamontes",
VLN: "Valencia",
VLP: "Vila Rica",
VLR: "Vallenar",
VLS: "Epi Island",
VLV: "Valera",
VLY: "Angelsey",
VME: "Villa Mercedes",
VMI: "Puerto Vallemi",
VMU: "Baimuru",
VNA: "Salavan",
VNC: "Venice",
VND: "Vangaindrano",
VNE: "Vannes/Meucon",
VNO: "Vilnius",
VNS: "Varanasi",
VNT: "Ventspils",
VNX: "Vilanculo",
VNY: "Van Nuys",
VOD: "Vodochody",
VOG: "Volgograd",
VOH: "Vohemar",
VOI: "Voinjama",
VOK: "Camp Douglas",
VOL: "Nea Anchialos",
VOT: "Votuporanga",
VOZ: "Voronezh",
VPE: "Ngiva",
VPG: "Vipingo Estate",
VPN: "Vopnafjšr?ur",
VPS: "Valparaiso",
VPY: "Chimoio",
VPZ: "Valparaiso",
VQQ: "Jacksonville",
VQS: "Vieques",
VRA: "Matanzas",
VRB: "Vero Beach",
VRC: "Virac",
VRE: "Vredendal",
VRI: "Varandey",
VRK: "Varkaus / Joroinen",
VRL: "Vila Real",
VRN: "Caselle (VR)",
VRO: "Santa Marta",
VRS: "Versailles",
VRU: "Vyrburg",
VRY: "V¾r¿y",
VRZ: "Lavras",
VSA: "Villahermosa",
VSE: "Viseu",
VSF: "North Springfield",
VST: "Stockholm / VŠsterŒs",
VSV: "Shravasti",
VTB: "Vitebsk",
VTE: "Vientiane",
VTF: "Vatulele",
VTG: "V?ng Tˆu",
VTM: "Beersheba",
VTN: "Valentine",
VTU: "Las Tunas",
VTZ: "Visakhapatnam",
VUP: "Valledupar",
VUS: "Velikiy Ustyug",
VUU: "Liwonde National Park",
VVB: "Mahanoro",
VVC: "Villavicencio",
VVI: "Santa Cruz",
VVK: "VŠstervik",
VVN: "Las Malvinas",
VVO: "Artyom",
VVZ: "Illizi",
VXC: "Lichinga",
VXE: "S‹o Pedro",
VXO: "VŠxjš",
VYD: "Vryheid",
VYI: "Vilyuisk",
VYS: "Peru",
WAA: "Wales",
WAD: "Andriamena",
WAE: "Wadi Al Dawasir",
WAF: "Waana",
WAG: "Wanganui",
WAH: "Wahpeton",
WAI: "Antsohihy",
WAJ: "Wavoi Falls",
WAK: "Ankazoabo",
WAL: "Wallops Island",
WAM: "Ambatondrazaka",
WAN: "Waverney",
WAO: "Wabo",
WAP: "Palena",
WAQ: "Antsalova",
WAT: "Waterford",
WAU: "Wauchope",
WAW: "Warsaw",
WAX: "Zuwarah",
WAY: "Waynesburg",
WBA: "Wahai",
WBB: "Stebbins",
WBC: "Wapolu",
WBD: "Befandriana",
WBE: "Bealanana",
WBG: "Jagel",
WBK: "West Branch",
WBM: "Wapenamanda",
WBO: "Beroroha",
WBQ: "Beaver",
WBR: "Big Rapids",
WBU: "Boulder",
WBW: "Wilkes-Barre",
WCA: "Castro",
WCD: "Cundeelee",
WCH: "ChaitŽn",
WCR: "Chandalar Lake",
WDA: "Ain District",
WDG: "Enid",
WDH: "Windhoek",
WDN: "Eastsound",
WDR: "Winder",
WDS: "Shiyan (Maojian)",
WEA: "Weatherford",
WED: "Wedau",
WEF: "Weifang (Kuiwen)",
WEH: "Weihai",
WEI: "Weipa",
WEL: "Welkom",
WEP: "Weam",
WET: "Tigi",
WFB: "Ketchikan",
WFI: "Fianarantsoa",
WFK: "Frenchville",
WGA: "Forest Hill",
WGB: "Bahawalnagar",
WGC: "Warangal",
WGN: "Shaoyang (Wugang)",
WGO: "Winchester",
WGP: "Waingapu-Sumba Island",
WGT: "Laceby",
WHA: "Wuhu",
WHD: "Hyder",
WHF: "Wadi Halfa",
WHL: "Welshpool",
WHN: "Wuhan (Hannan)",
WHP: "Pacoima",
WHS: "Whalsay, Shetlands",
WHT: "Wharton",
WHU: "Wuhu",
WIB: "Vernon",
WIC: "Wick",
WIE: "Wiesbaden",
WIK: "Waiheke Island",
WIL: "Nairobi",
WIR: "Wairoa",
WIU: "Garove Island",
WJA: "Woja",
WJF: "Lancaster",
WJR: "Wajir",
WJU: "Wonju",
WKA: "Wanaka",
WKF: "Pretoria",
WKI: "Hwange",
WKJ: "Wakkanai",
WKK: "Aleknagik",
WKL: "Waikoloa Village",
WKN: "Wakunai",
WKR: "Walkers Cay",
WLA: "Eighty Mile Beach",
WLD: "Winfield / Arkansas City",
WLG: "Wellington",
WLH: "Walaha",
WLK: "Selawik",
WLR: "Loring",
WLS: "Wallis Island",
WLU: "Puri",
WLW: "Willows",
WMA: "Mandritsara",
WMC: "Winnemucca",
WMD: "Mandabe",
WMH: "Mountain Home",
WMI: "Nowy Dw—r Mazowiecki",
WMK: "Meyers Chuck",
WML: "Malaimbandy",
WMN: "Maroantsetra",
WMO: "White Mountain",
WMP: "Mampikony",
WMR: "Mananara Nord",
WMT: "Zunyi",
WMX: "Wamena",
WNA: "Napakiak",
WND: "Laverton",
WNH: "Wenshan",
WNI: "Wangi-wangi Island",
WNN: "Wunnumin Lake",
WNP: "Naga",
WNR: "Windorah",
WNS: "Nawabashah",
WNU: "Wanuma",
WNZ: "Wenzhou (Longwan)",
WOA: "Wonenara",
WOE: "Hoogerheide",
WOK: "UonquŽn",
WOL: "Albion Park Rail",
WON: "Wondoola",
WOS: "Wonsan",
WOT: "Wang'an",
WOW: "Willow",
WPA: "Puerto AysŽn",
WPB: "Port BergŽ",
WPC: "Pincher Creek",
WPK: "Wrotham Park",
WPL: "Powell River",
WPM: "Wipim",
WPO: "Paonia",
WPR: "Porvenir",
WPU: "Puerto Williams",
WRA: "Warder",
WRB: "Warner Robins",
WRE: "Whangarei",
WRG: "Wrangell",
WRH: "Urhu",
WRI: "Wrightstown",
WRL: "Worland",
WRN: "Windarling Mine",
WRO: "Wroc?aw",
WRT: "Warton",
WRY: "Westray",
WRZ: "Weerawila",
WSA: "Wasua",
WSB: "Steamboat Bay",
WSF: "Cape Sarichef",
WSG: "Washington",
WSH: "Shirley",
WSK: "Wushan",
WSM: "Wiseman",
WSN: "South Naknek",
WSO: "Washabo",
WSP: "Waspam",
WSR: "Wasior",
WST: "Westerly",
WSU: "Wasu",
WSX: "West Sound",
WSY: "Shute Harbour",
WSZ: "Westport",
WTA: "Tambohorano",
WTB: "Toowoomba",
WTD: "West End",
WTE: "Wotje",
WTK: "Noatak",
WTL: "Tuntutuliak",
WTN: "Lincoln, Lincolnshire",
WTO: "Wotho Island",
WTP: "Fatima Mission",
WTR: "Whiteriver",
WTS: "Tsiroanomandidy",
WTT: "Wantoat",
WTZ: "Whitianga",
WUA: "Wuhai",
WUG: "Wau",
WUH: "Wuhan (Huangpi)",
WUI: "Murrin Murrin",
WUM: "Wasum",
WUS: "Wuyishan",
WUT: "Xinzhou",
WUU: "Wau",
WUV: "Wuvulu Island",
WUX: "Wuxi",
WUZ: "Tangbu",
WVB: "Rooikop",
WVI: "Watsonville",
WVK: "Manakara",
WVL: "Waterville",
WVN: "Wilhelmshaven",
WWA: "Wasilla",
WWD: "Wildwood",
WWI: "Woodie Woodie",
WWK: "Wewak",
WWP: "Whale Pass",
WWR: "Woodward",
WWT: "Mertarvik",
WWY: "West Wyalong",
WXN: "Wanzhou",
WYA: "Whyalla",
WYB: "Yes Bay",
WYE: "Yengema",
WYS: "West Yellowstone",
WZA: "Wa",
WZQ: "Urad Middle Banner",
XAI: "Xinyang",
XAL: "çlamos",
XAP: "Chapec—",
XAR: "Aribinda",
XAU: "SaŸl",
XBB: "Blubber Bay",
XBE: "Bearskin Lake",
XBG: "Bogande",
XBJ: "Birjand",
XBN: "Biniguni",
XBO: "Boulsa",
XBR: "Brockville",
XCH: "Flying Fish Cove",
XCL: "Cluff Lake",
XCM: "Chatham-Kent",
XCO: "Colac Otway Shire",
XCR: "Bussy-LettrŽe",
XDE: "Diebougou",
XDJ: "Djibo",
XEN: "Huludao (Xingcheng)",
XEQ: "Tasiusak",
XES: "Lake Geneva",
XFN: "Xiangyang (Xiangzhou)",
XFW: "Hamburg",
XGA: "Gaoua",
XGG: "Gorom-Gorom",
XGN: "Xangongo",
XGR: "Kangiqsualujjuaq",
XIC: "Liangshan (Xichang)",
XIE: "Xienglom",
XIG: "Xinguara",
XIJ: "Ahmed Al Jaber AB",
XIL: "Xilinhot",
XIN: "Meizhou (Xingning)",
XIQ: "Ilimanaq",
XIY: "Xianyang (Weicheng)",
XJD: "Ar Rayyan",
XJM: "Mangla",
XKA: "Kantchari",
XKH: "Xieng Khouang",
XKS: "Kasabonika",
XKY: "Kaya",
XLB: "Lac Brochet",
XLS: "Saint Louis",
XLU: "Leo",
XMA: "Maramag",
XMD: "Madison",
XMG: "Mahendranagar",
XMI: "Masasi",
XMN: "Xiamen",
XMP: "Macmillan Pass",
XMS: "Macas",
XMY: "Yam Island",
XNA: "Fayetteville/Springdale/Rogers",
XNH: "Nasiriyah",
XNN: "Haidong (Huzhu Tu Autonomous County)",
XNT: "Xingtai",
XNU: "Nouna",
XPA: "Pama",
XPK: "Pukatawagan",
XPL: "Palmerola",
XPP: "Poplar River",
XPR: "Pine Ridge",
XQP: "Quepos",
XQU: "Qualicum Beach",
XRH: "Richmond",
XRQ: "New Barag Right Banner",
XRR: "Ross River",
XRY: "Jerez de la Frontera",
XSB: "Sir Bani Yas",
XSC: "South Caicos",
XSD: "Tonopah",
XSE: "Sebba",
XSI: "South Indian Lake",
XSO: "Siocon",
XSP: "Seletar",
XTG: "Thargomindah",
XTL: "Tadoule Lake",
XUZ: "Xuzhou",
XWA: "Williston",
XYA: "Yandina",
XYE: "Ye",
XYR: "Yellow River Mission",
XZA: "ZabrŽ",
XZM: "SŽ",
YAA: "Anahim Lake",
YAB: "Arctic Bay",
YAC: "Cat Lake",
YAE: "Yartsevo",
YAG: "Fort Frances",
YAH: "La Grande-4",
YAI: "Chillan",
YAJ: "Saturna Island",
YAK: "Yakutat",
YAL: "Alert Bay",
YAM: "Sault Ste Marie",
YAN: "Yangambi",
YAO: "YaoundŽ",
YAP: "Yap Island",
YAQ: "Maple Bay",
YAR: "La Grande-3",
YAS: "Yasawa Island",
YAT: "Attawapiskat",
YAU: "Kattiniq",
YAV: "Miners Bay",
YAX: "Angling Lake",
YAY: "St. Anthony",
YAZ: "Tofino",
YBA: "Banff",
YBB: "Kugaaruk",
YBC: "Baie-Comeau",
YBE: "Uranium City",
YBF: "Bamfield",
YBG: "La Baie",
YBH: "Bull Harbour",
YBI: "Black Tickle",
YBJ: "Baie-Johan-Beetz",
YBK: "Baker Lake",
YBL: "Campbell River",
YBO: "Bob Quinn Lake",
YBP: "Yibin (Cuiping)",
YBQ: "Thetis Island",
YBR: "Brandon",
YBS: "Opapimiskan Lake",
YBT: "Brochet",
YBV: "Berens River",
YBW: "Bedwell Harbour",
YBX: "Blanc-Sablon",
YBY: "Bonnyville",
YCA: "Courtenay",
YCB: "Cambridge Bay",
YCC: "Cornwall",
YCD: "Nanaimo",
YCE: "Huron Park",
YCF: "Cortes Bay",
YCG: "Castlegar",
YCH: "Miramichi",
YCK: "Colville Lake",
YCL: "Charlo",
YCM: "Niagara-on-the-Lake",
YCN: "Cochrane",
YCO: "Kugluktuk",
YCQ: "Chetwynd",
YCR: "Cross Lake",
YCS: "Chesterfield Inlet",
YCT: "Coronation",
YCU: "Yuncheng (Yanhu)",
YCW: "Chilliwack",
YCY: "Clyde River",
YCZ: "Fairmont Hot Springs",
YDA: "Dawson City",
YDB: "Burwash Landing",
YDC: "Drayton Valley",
YDF: "Deer Lake",
YDG: "Digby",
YDJ: "Hatchet Lake",
YDL: "Dease Lake",
YDN: "Dauphin",
YDO: "Dolbeau-Saint-Felicien",
YDP: "Nain",
YDQ: "Dawson Creek",
YDT: "Delta",
YDU: "Kasba Lake",
YDV: "Bloodvein River",
YDW: "Obre Lake",
YEB: "Echo Bay",
YEC: "Yecheon-ri",
YEG: "Edmonton",
YEH: "Yinchuan",
YEI: "Yeni?ehir",
YEK: "Arviat",
YEL: "Elliot Lake",
YEM: "Sheguiandah",
YEN: "Estevan",
YEO: "Yeovil, Somerset",
YER: "Fort Severn",
YES: "Yasuj",
YET: "Edson",
YEU: "Eureka",
YEV: "Inuvik",
YEY: "Amos",
YFA: "Fort Albany",
YFB: "Iqaluit",
YFC: "Fredericton",
YFE: "Forestville",
YFG: "Fontanges",
YFH: "Fort Hope",
YFI: "Suncor Energy Site",
YFJ: "Wekwet“",
YFL: "Fort Reliance",
YFO: "Flin Flon",
YFR: "Fort Resolution",
YFS: "Fort Simpson",
YFX: "St. Lewis",
YGA: "Chongqing",
YGB: "Texada",
YGE: "Gorge Harbour",
YGG: "Salt Spring Island",
YGH: "Fort Good Hope",
YGJ: "Yonago",
YGK: "Kingston",
YGL: "La Grande Rivire",
YGM: "Gimli",
YGN: "Broughton Island",
YGO: "Gods Lake Narrows",
YGP: "GaspŽ",
YGQ: "Geraldton",
YGR: "Les ëles-de-la-Madeleine",
YGT: "Igloolik",
YGV: "Havre-Saint-Pierre",
YGW: "Kuujjuarapik",
YGX: "Gillam",
YGZ: "Grise Fiord",
YHA: "Port Hope Simpson",
YHB: "Hudson Bay",
YHC: "Hecate Island",
YHD: "Dryden",
YHE: "Hope",
YHF: "Hearst",
YHG: "Charlottetown",
YHH: "Campbell River",
YHI: "Ulukhaktok",
YHJ: "Nanchang",
YHK: "Gjoa Haven",
YHM: "Hamilton",
YHN: "Hornepayne",
YHO: "Hopedale",
YHP: "Poplar Hill",
YHR: "Chevery",
YHS: "Sechelt",
YHT: "Haines Junction",
YHU: "MontrŽal",
YHY: "Hay River",
YHZ: "Halifax",
YIA: "Yogyakarta",
YIB: "Atikokan",
YIC: "Yichun",
YIE: "Arxan",
YIF: "St-Augustin",
YIG: "Stuart Island",
YIH: "Yichang (Xiaoting)",
YIK: "Ivujivik",
YIN: "Ili (Yining / Ghulja)",
YIO: "Pond Inlet",
YIP: "Detroit",
YIV: "Island Lake",
YIW: "Jinhua (Yiwu)",
YJA: "Jasper",
YJF: "Fort Liard",
YJN: "St Jean",
YJP: "Hinton",
YJS: "Samjiy?n",
YJT: "Stephenville",
YKA: "Kamloops",
YKC: "Collins Bay",
YKD: "Kincardine",
YKE: "Knee Lake",
YKF: "Breslau",
YKG: "Kangirsuk",
YKH: "Yingkou (Laobian)",
YKJ: "Key Lake",
YKK: "Kitkatla",
YKL: "Schefferville",
YKM: "Yakima",
YKN: "Yankton",
YKO: "Hakkari",
YKQ: "Waskaganish",
YKS: "Yakutsk",
YKT: "Klemtu",
YKU: "Chisasibi",
YKX: "Kirkland Lake",
YKY: "Kindersley",
YLB: "Lac La Biche",
YLC: "Kimmirut",
YLD: "Chapleau",
YLE: "What“",
YLG: "Yalgoo",
YLH: "Lansdowne House",
YLI: "Ylivieska",
YLJ: "Meadow Lake",
YLK: "Barrie",
YLL: "Lloydminster",
YLP: "Longue-Pointe-de-Mingan",
YLQ: "La Tuque",
YLR: "Leaf Rapids",
YLS: "Lebel-sur-QuŽvillon",
YLT: "Alert",
YLV: "Yevlakh",
YLW: "Kelowna",
YLX: "Yl’n",
YLY: "Langley",
YMA: "Mayo",
YMB: "Merritt",
YME: "Matane",
YMF: "Galiano Island",
YMG: "Manitouwadge",
YMH: "Mary's Harbour",
YMJ: "Moose Jaw",
YMK: "Mys Kamennyi",
YML: "Charlevoix",
YMM: "Fort McMurray",
YMN: "Makkovik",
YMO: "Moosonee",
YMP: "Port McNeill",
YMS: "Yurimaguas",
YMT: "Chibougamau",
YMU: "Mansons Landing",
YMV: "Mary River",
YMW: "Messines",
YMX: "MontrŽal",
YNA: "Natashquan",
YNB: "Yanbu",
YNC: "Wemindji",
YND: "Gatineau",
YNE: "Norway House",
YNG: "Youngstown/Warren",
YNH: "Hudson's Hope",
YNJ: "Yanji",
YNL: "Points North Landing",
YNM: "Matagami",
YNO: "North Spirit Lake",
YNP: "Natuashish",
YNS: "Nemiscau",
YNT: "Yantai",
YNX: "Snap Lake Mine",
YNY: "Gonghang-ro",
YNZ: "Yancheng (Tinghu)",
YOA: "Ekati",
YOC: "Old Crow",
YOD: "Cold Lake",
YOE: "Donnelly",
YOG: "Ogoki Post",
YOH: "Oxford House",
YOI: "ƒlŽonore Mine",
YOJ: "High Level",
YOL: "Yola",
YON: "Yongphulla",
YOO: "Oshawa",
YOP: "Rainbow Lake",
YOS: "Owen Sound",
YOT: "Yotvata",
YOW: "Ottawa",
YPA: "Prince Albert",
YPB: "Port Alberni",
YPC: "Paulatuk",
YPD: "Parry Sound",
YPE: "Peace River",
YPG: "Portage la Prairie",
YPH: "Inukjuak",
YPJ: "Aupaluk",
YPL: "Pickle Lake",
YPM: "Pikangikum",
YPN: "Port-Menier",
YPO: "Peawanuck",
YPQ: "Peterborough",
YPR: "Prince Rupert",
YPS: "Port Hawkesbury",
YPT: "Sunshine Coast",
YPW: "Powell River",
YPX: "Puvirnituq",
YPY: "Fort Chipewyan",
YPZ: "Burns Lake",
YQA: "Gravenhurst",
YQB: "Quebec",
YQC: "Quaqtaq",
YQD: "The Pas",
YQF: "Springbrook",
YQG: "Windsor",
YQH: "Watson Lake",
YQI: "Yarmouth",
YQJ: "Quadra Island",
YQK: "Kenora",
YQL: "Lethbridge",
YQM: "Moncton",
YQN: "Nakina",
YQQ: "Comox",
YQR: "Regina",
YQS: "St Thomas",
YQT: "Thunder Bay",
YQU: "Grande Prairie",
YQV: "Yorkton",
YQW: "North Battleford",
YQX: "Gander",
YQY: "Sydney",
YQZ: "Quesnel",
YRA: "Gamt“",
YRB: "Resolute Bay",
YRC: "Desolation Sound",
YRD: "Kimsquit Valley",
YRF: "Cartwright",
YRG: "Rigolet",
YRI: "Rivire-du-Loup",
YRJ: "Roberval",
YRL: "Red Lake",
YRM: "Rocky Mountain House",
YRN: "Rivers Inlet",
YRO: "Ottawa",
YRQ: "Trois-Rivires",
YRR: "Big Bay",
YRS: "Red Sucker Lake",
YRT: "Rankin Inlet",
YRV: "Revelstoke",
YSA: "Sable Island",
YSB: "Sudbury",
YSC: "Sherbrooke",
YSD: "Ralston",
YSE: "Squamish",
YSF: "Stony Rapids",
YSG: "Lutselk'e",
YSH: "Smiths Falls",
YSI: "Frying Pan Island",
YSJ: "Saint John",
YSK: "Sanikiluaq",
YSL: "Saint-LŽonard",
YSM: "Fort Smith",
YSN: "Salmon Arm",
YSO: "Postville",
YSP: "Marathon",
YSQ: "Qian Gorlos Mongol Autonomous County",
YST: "St. Theresa Point",
YSU: "Slemon Park",
YSV: "Saglek",
YSX: "Bella Bella",
YSY: "Sachs Harbour",
YTA: "Pembroke",
YTB: "Hartley Bay",
YTD: "Thicket Portage",
YTE: "Kinngait",
YTF: "Alma",
YTG: "Sullivan Bay",
YTH: "Thompson",
YTL: "Big Trout Lake",
YTM: "La Macaza",
YTP: "Tofino",
YTQ: "Tasiujaq",
YTR: "Trenton",
YTS: "Timmins",
YTT: "Tisdale",
YTW: "Hotan (Yutian)",
YTY: "Yangzhou",
YTZ: "Toronto",
YUA: "Chuxiong (Yuanmou)",
YUB: "Tuktoyaktuk",
YUD: "Umiujaq",
YUL: "MontrŽal",
YUM: "Yuma",
YUS: "Yushu (Batang)",
YUT: "Repulse Bay",
YUX: "Sanirajak",
YUY: "Rouyn-Noranda",
YVB: "Bonaventure",
YVC: "La Ronge",
YVD: "Yeva",
YVE: "Vernon",
YVG: "Vermilion",
YVM: "Qikiqtarjuaq",
YVO: "Val-d'Or",
YVP: "Kuujjuaq",
YVQ: "Norman Wells",
YVR: "Vancouver",
YVT: "Buffalo Narrows",
YVV: "Wiarton",
YVZ: "Deer Lake",
YWA: "Petawawa",
YWB: "Kangiqsujuaq",
YWG: "Winnipeg",
YWH: "Victoria",
YWJ: "DŽline",
YWK: "Wabush",
YWL: "Williams Lake",
YWM: "Williams Harbour",
YWP: "Webequie",
YWQ: "Chutes-des-Passes",
YWR: "White River",
YWS: "Whistler",
YWY: "Wrigley",
YXC: "Cranbrook",
YXE: "Saskatoon",
YXH: "Medicine Hat",
YXJ: "Fort Saint John",
YXK: "Rimouski",
YXL: "Sioux Lookout",
YXN: "Whale Cove",
YXP: "Pangnirtung",
YXQ: "Beaver Creek",
YXR: "Earlton",
YXS: "Prince George",
YXT: "Terrace",
YXU: "London",
YXX: "Abbotsford",
YXY: "Whitehorse",
YXZ: "Wawa",
YYA: "Yueyang (Yueyanglou)",
YYB: "North Bay",
YYC: "Calgary",
YYD: "Smithers",
YYE: "Fort Nelson",
YYF: "Penticton",
YYG: "Charlottetown",
YYH: "Taloyoak",
YYJ: "Victoria",
YYL: "Lynn Lake",
YYM: "Cowley",
YYN: "Swift Current",
YYQ: "Churchill",
YYR: "Goose Bay",
YYT: "St. John's",
YYU: "Kapuskasing",
YYW: "Armstrong",
YYY: "Mont-Joli",
YYZ: "Toronto",
YZA: "Cache Creek",
YZE: "Gore Bay",
YZF: "Yellowknife",
YZG: "Salluit",
YZH: "Slave Lake",
YZP: "Sandspit",
YZR: "Sarnia",
YZS: "Coral Harbour",
YZT: "Port Hardy",
YZU: "Whitecourt",
YZV: "Sept-ëles",
YZW: "Teslin",
YZX: "Greenwood",
YZY: "Zhangye (Ganzhou)",
YZZ: "Trail",
ZAC: "York Landing",
ZAD: "Zemunik Donji (Zadar)",
ZAG: "Velika Gorica",
ZAH: "Zahedan",
ZAJ: "Zaranj",
ZAL: "Valdivia",
ZAM: "Zamboanga",
ZAO: "Cahors/Lalbenque",
ZAR: "Zaria",
ZAT: "Zhaotong (Zhaoyang)",
ZAZ: "Zaragoza",
ZBE: "Doln’ Bene?ov",
ZBF: "South Tetagouche",
ZBL: "Biloela",
ZBM: "Bromont",
ZBO: "Bowen",
ZBR: "Konarak",
ZBY: "Sainyabuli",
ZCL: "Zacatecas",
ZCO: "Temuco",
ZDM: "Ramallah",
ZDY: "Delma Island",
ZEC: "Secunda",
ZEG: "Senggo-Papua Island",
ZEL: "Bella Bella",
ZEM: "Eastmain River",
ZEN: "Zenag",
ZER: "Ziro",
ZFA: "Faro",
ZFD: "Fond-du-Lac",
ZFL: "Zhaosu",
ZFM: "Fort Mcpherson",
ZFN: "Tulita",
ZFU: "Aruj‡",
ZFW: "Fairview",
ZGF: "Grand Forks",
ZGI: "Gods River",
ZGM: "Ngoma",
ZGN: "Zhongshan",
ZGR: "Little Grand Rapids",
ZGS: "Le Golfe-du-Saint-Laurent",
ZGU: "Gaua Island",
ZHA: "Zhanjiang",
ZHM: "Shamshernagar",
ZHP: "High Prairie",
ZHY: "Zhongwei (Shapotou)",
ZIA: "Moscow",
ZIC: "Victoria",
ZIG: "Ziguinchor",
ZIH: "Ixtapa",
ZIS: "Zintan",
ZIX: "Zhigansk",
ZIZ: "Zamzama Gas Field",
ZJG: "Jenpeg",
ZJN: "Swan River",
ZKB: "Kasaba Bay",
ZKE: "Kashechewan",
ZKG: "C™te-Nord-du-Golfe-du-Saint-Laurent",
ZKL: "Zigong (Gongjing)",
ZKP: "Zyryanka",
ZLO: "Manzanillo",
ZLR: "Linares",
ZLT: "La Tabatire",
ZLX: "Zalingei",
ZMD: "Sena Madureira",
ZMH: "108 Mile",
ZMM: "Zamora",
ZMT: "Masset",
ZNA: "Nanaimo",
ZNC: "Nyac",
ZND: "Zinder",
ZNE: "Newman",
ZNU: "Namu",
ZNZ: "Zanzibar",
ZOE: "Ludwigshafen am Rhein",
ZOF: "Ocean Falls",
ZOS: "Osorno",
ZPB: "Sachigo Lake",
ZPC: "Pucon",
ZPH: "Zephyrhills",
ZPO: "Pinehouse Lake",
ZQN: "Queenstown",
ZQS: "Queen Charlotte",
ZQW: "ZweibrŸcken",
ZQZ: "Zhangjiakou",
ZRH: "Zurich",
ZRI: "Serui",
ZRJ: "Round Lake",
ZRM: "Sarmi",
ZRZ: "Zaraza",
ZSA: "San Salvador",
ZSE: "Saint-Pierre",
ZSJ: "Sandy Lake",
ZSS: "Sassandra",
ZST: "Stewart",
ZSW: "Prince Rupert",
ZTA: "Tureia",
ZTB: "Tte-ˆ-la-Baleine",
ZTH: "Zakynthos",
ZTM: "Shamattawa",
ZTR: "Zhytomyr",
ZTS: "Tahsis",
ZTU: "Zaqatala",
ZUC: "Ignace",
ZUD: "Ancud",
ZUH: "Zhuhai (Jinwan)",
ZUL: "Zilfi",
ZUM: "Churchill Falls",
ZVA: "Miandrivazo",
ZVG: "Springvale",
ZWL: "Wollaston Lake",
ZXT: "Zabrat",
ZYI: "Zunyi",
ZYL: "Sylhet",
ZZE: "Zangilan",
ZZO: "Tymovskoye",
ZZU: "Mzuzu",
ZZV: "Zanesville"}